/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Swipe4Work Admin API
 * OpenAPI spec version: 0.1.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AddLeadToCompanyCommandDto,
  AddSalesGoalRealizedCompanyCommandDto,
  AdminAiAgentControllerComposeJobDto,
  AdminAiAgentControllerComposeJobResultDto,
  AdminAiAgentControllerDetermineJobDataDto,
  AdminAiAgentControllerDetermineJobDataResultDto,
  AdminAiAgentControllerInvokeJobDataToolDto,
  AdminAiAgentControllerInvokeJobDataToolResultDto,
  AdminAiAgentControllerJobAgentChatDto,
  AdminAiAgentControllerJobAgentChatResultDto,
  AdminAiAgentControllerJobDescriptionResultDto,
  AdminAiAgentControllerRewriteJobDescriptionDto,
  AdminAiAgentControllerRewriteJobDescriptionResultDto,
  AdminAiAgentControllerWriteJobDescriptionDto,
  AdminCertificateCrudListResult,
  AdminCertificateCrudUpdateCommand,
  AdminGetMySalesStatsParams,
  AdminGetSalesForecastParams,
  AdminGetSalesGoalStatsParams,
  AdminGetSalesStatsParams,
  AdminGetSubscriptionMetricsParams,
  AdminHardSkillCrudListResult,
  AdminHardSkillCrudListSkillCategoriesResult,
  AdminHardSkillCrudUpdateCommand,
  AdminImportPersonasBody,
  AdminInspectPersonaCsvBody,
  AdminIntegrationConnectionControllerCopyToSubCompanyDto,
  AdminIscoGroupCrudListResult,
  AdminJobFunctionCrudCreateCommand,
  AdminJobFunctionCrudJobFunctionDto,
  AdminJobFunctionCrudListResult,
  AdminJobFunctionCrudRenameRequestBody,
  AdminJobFunctionCrudUpdateCommand,
  AdminListAiJobsParams,
  AdminListIscoGroupJobsParams,
  AdminListJobFunctionCustomResult,
  AdminListJobFunctionCustomsParams,
  AdminListJobFunctionsParams,
  AdminListJobsByFunctionResult,
  AdminListLinkItemsParams,
  AdminListLinkableSalesDemosParams,
  AdminListMySalesDailyLogsParams,
  AdminListMySalesGoalsParams,
  AdminListSalesDailyLogsParams,
  AdminListSalesDemosParams,
  AdminListSalesGoalsParams,
  AdminListUserSkillCustomResult,
  AdminListUserSkillCustomsParams,
  AdminPreviewJobFunctionMergeParams,
  AdminReferralSourceCrudCreateCommand,
  AdminReferralSourceCrudListResult,
  AdminReferralSourceCrudReferralSourceDto,
  AdminReferralSourceCrudUpdateCommand,
  AdminSearchIntegrationErrorsParams,
  AdminSkillSuggestionControllerScoreSkillsRequest,
  AdminSkillSuggestionControllerSuggestSkillsRequest,
  AdminSkillSuggestionControllerSuggestSkillsResponse,
  AiJobContentDto,
  CancelMatchingSimulationResult,
  CreateAiJobCommandDto,
  CreateCategoryCommandDto,
  CreateCategoryResult,
  CreateCompanyFromAdminAdminCreateCompanyDto,
  CreateCompanyFromAdminResult,
  CreateEmployerInviteCommandDto,
  CreateIframeLinkCommandDto,
  CreateIframeLinkResult,
  CreateInternalLinkCommandDto,
  CreateInternalLinkResult,
  CreateJobImportBatchCommandDto,
  CreateJobImportBatchResult,
  CreateMatchingSimulationCommandDto,
  CreateMatchingSimulationResult,
  CreateMetabaseIframeLinkCommandDto,
  CreateMetabaseIframeLinkResult,
  CreateSalesDailyLogCommandDto,
  CreateSalesDailyLogResult,
  CreateSalesDemoCommandDto,
  CreateSalesDemoResult,
  CreateSalesGoalCommandDto,
  CreateSalesGoalResult,
  CreateSegmentCommandDto,
  CreateSegmentResult,
  CreateSubCompanyFromAdminCompanyDto,
  CreateSubCompanyFromAdminResult,
  CreateTeammateInviteCommandDto,
  CreateUriLinkCommandDto,
  CreateUriLinkResult,
  CreateWebhookEndpointCommandDto,
  DeleteCompanyCommandDto,
  DeleteEmployeeAccountParams,
  DeleteEmployerCommandDto,
  DeleteMatchingSimulationScoresResult,
  ExactOnlineControllerGetExactOnlineAuthorizeUrlResult,
  ExportCompanyJobsQuery,
  GenerateSandboxDataCommand,
  GetAdminAccessResult,
  GetAdminAiJobResult,
  GetAdminAlgorithmVersionResult,
  GetAdminAlgorithmVersionStatisticsParams,
  GetAdminAlgorithmVersionStatisticsResult,
  GetAdminAtsIntegrationConnectionDetailResult,
  GetAdminAtsJobParams,
  GetAdminCandidateMatchScoreStatisticsParams,
  GetAdminCandidateMatchScoreStatisticsResult,
  GetAdminCandidateStackComparisonParams,
  GetAdminCandidateStackComparisonResult,
  GetAdminCandidateStatisticsResult,
  GetAdminCompanyBillingResult,
  GetAdminCompanyStatisticsParams,
  GetAdminCompanyStatisticsResult,
  GetAdminJobMatchScoreStatisticsParams,
  GetAdminJobMatchScoreStatisticsResult,
  GetAdminJobResult,
  GetAdminJobStackComparisonParams,
  GetAdminJobStackComparisonResult,
  GetAdminJobStatisticsResult,
  GetAdminMatchScoreParams,
  GetAdminMatchScoreResult,
  GetAdminMatchingCandidateResult,
  GetAdminStandInPairParams,
  GetAdminUserSkillSuggestionContextResult,
  GetAtsJobResult,
  GetAutoCompleteLocationsParams,
  GetAutoCompleteLocationsResult,
  GetCompanyFromAdminResult,
  GetCreditNoteFileUrlResult,
  GetEmployerInviteLinkParams,
  GetEmployerInviteLinkResult,
  GetExactOnlineConnectionStatusResult,
  GetIntegrationErrorAlertPolicyResult,
  GetIntegrationErrorLogResult,
  GetInvoiceFileUrlResult,
  GetJobImportBatchResult,
  GetLocationDetailsParams,
  GetLocationDetailsResult,
  GetLocationGeocodeParams,
  GetLocationGeocodeResult,
  GetMatchingSimulationResult,
  GetMatchingSimulationStatisticsParams,
  GetMatchingSimulationStatisticsResult,
  GetMatchingSimulationStatusResult,
  GetMetabaseIframeUrlQueryDto,
  GetMetabaseIframeUrlResult,
  GetRoleResult,
  GetSalesDailyLogLogDetailDto,
  GetSalesForecastResult,
  GetSalesGoalStatsResult,
  GetSalesStatsResult,
  GetSegmentAudienceCountQueryDto,
  GetSegmentAudienceCountResult,
  GetSegmentResult,
  GetStandInPairResult,
  GetSubscriptionMetricsResult,
  GetWebhookEndpointSecretSecretDto,
  GetWebhookEndpointWebhookEndpointDetailDto,
  IntegrationConnectionDto,
  InvalidateCompanyStatisticsCacheParams,
  InvalidateMatchingSimulationStatisticsCacheParams,
  ItemInput,
  JobCategoryCrudJobCategoryDto,
  JobCategoryCrudListResult,
  JobFunctionCrudListResult,
  JobFunctionIscoClassifierResult,
  LinkCustomerCompanyToExactFromAdminCommandDto,
  LinkItemDto,
  LinkSalesDemoInviteCommandDto,
  ListActiveSubscriptionsFromAdminResult,
  ListAdminAiJobsResult,
  ListAdminAlgorithmVersionGroupsResult,
  ListAdminAlgorithmVersionMatchScoresResult,
  ListAdminAlgorithmVersionsResult,
  ListAdminAtsJobsParams,
  ListAdminCandidateJobApplicationsParams,
  ListAdminCandidateJobApplicationsResult,
  ListAdminCandidateMatchScoresResult,
  ListAdminCompaniesParams,
  ListAdminEmployersParams,
  ListAdminEmployersResult,
  ListAdminJobApplicationsParams,
  ListAdminJobApplicationsResult,
  ListAdminJobMatchScoresResult,
  ListAdminLocationsParams,
  ListAdminMatchingCandidatesParams,
  ListAdminMatchingCandidatesResult,
  ListAdminMatchingJobCategoriesResult,
  ListAdminMatchingJobFunctionsResult,
  ListAdminPermissionsResult,
  ListAdminSimulationMatchScoresParams,
  ListAdminSimulationMatchScoresResult,
  ListAdminSubscriptionPlansResult,
  ListAdminUsersResult,
  ListAllSkillsResult,
  ListAtsJobApplicationsForConnectionParams,
  ListAtsJobApplicationsForConnectionResult,
  ListAtsJobsResult,
  ListCategoriesResult,
  ListCertificatesResult,
  ListCompaniesFromAdminResult,
  ListCompanyIntegrationConnectionsFromAdminResult,
  ListCompanyMediaParams,
  ListCompanyMediaResult,
  ListCreditNotesForCompanyResult,
  ListEducationLevelsResult,
  ListInterestsResult,
  ListInternalEmployersParams,
  ListInternalEmployersResult,
  ListInternalRolesDetailedResult,
  ListInternalRolesResult,
  ListInvoicesForCompanyResult,
  ListJobFunctionsParams,
  ListJobImportBatchesResult,
  ListLinkItemsResult,
  ListLinkableSalesDemosResult,
  ListLinkableSalesInvitesResult,
  ListMatchingSimulationsResult,
  ListNewJobReasonsResult,
  ListPersonalCharacteristicsResult,
  ListPersonalityTypesResult,
  ListRelinkableCompaniesResult,
  ListSalesDailyLogsResult,
  ListSalesDemosResult,
  ListSalesGoalsResult,
  ListSegmentsParams,
  ListSegmentsResult,
  ListSimilarJobFunctionsParams,
  ListSimilarJobFunctionsResult,
  ListSimulationCandidatesParams,
  ListSimulationCandidatesResult,
  ListSimulationJobsParams,
  ListSimulationJobsResult,
  ListSkillsCertificatesAndLanguagesResult,
  ListSkillsForJobCategoriesParams,
  ListSkillsForJobCategoriesResult,
  ListWebhookEndpointsResult,
  LocationSearchScope,
  LookupAdminCandidatesParams,
  LookupAdminCandidatesResult,
  LookupCompaniesFromAdminResult,
  MapAdminJobWithAtsJobCommandDto,
  MergeJobFunctionsRequestBody,
  MergeJobFunctionsResult,
  MoveInviteSubscriptionStartDateEarlierCommandDto,
  MoveSalesGoalRealizedCompanyCommandDto,
  MoveSubscriptionStartDateEarlierCommandDto,
  PerformStandInActionCommandDto,
  PerformStandInActionResult,
  PersonaImportInspectResult,
  PersonaImportOptions,
  PersonaImportResult,
  PreviewJobFunctionMergeResult,
  PreviewSuggestedJobFunctionsQueryDto,
  PreviewSuggestedJobFunctionsResult,
  ProblemDetails,
  PromoteCustomJobFunctionRequestBody,
  PromoteCustomJobFunctionResult,
  PromoteCustomSkillRequestBody,
  PromoteCustomSkillResult,
  RecalculateCandidateMatchScoresResult,
  RecalculateJobMatchScoresResult,
  RejectCustomJobFunctionResult,
  RejectCustomSkillResult,
  ReorderCategoriesCommandDto,
  ReorderCategoryContentsCommandDto,
  ResendAtsJobApplicationResult,
  ResendAtsJobApplicationsResult,
  ResolveCompanyByExactGuidFromAdminResult,
  ReviewAiJobCommandDto,
  ScheduleAutoMatchForExistingCandidatesResult,
  SearchAdminCompaniesParams,
  SearchAdminJobsParams,
  SearchAdminJobsResult,
  SearchAdminLocationsParams,
  SearchAdminLocationsResult,
  SearchCandidatesForSegmentParams,
  SearchCandidatesForSegmentResult,
  SearchCompaniesForSegmentParams,
  SearchCompaniesForSegmentResult,
  SearchCompaniesFromAdminResult,
  SearchCustomerCompaniesWithExactDataFromAdminResult,
  SearchExactAccountsFromAdminResult,
  SearchExactOnlineAccountsParams,
  SearchExactOnlineCustomerCompaniesParams,
  SearchIntegrationErrorLogsResult,
  SearchJobsForSegmentParams,
  SearchJobsForSegmentResult,
  SetCompanyIdealCommandDto,
  SetCompanyIdealResult,
  SetCustomJobFunctionIscoGroupRequestBody,
  SetCustomJobFunctionIscoGroupResult,
  SetEmployerCompanyRolesCommandDto,
  SetInternalEmployerRolesCommandDto,
  SetIscoUnitGroupIdealCommandDto,
  SetIscoUnitGroupIdealResult,
  SetJobFunctionIscoGroupCommandRequestBody,
  SetJobFunctionIscoGroupCommandResult,
  SetLeadEmailEnabledParams,
  SetManagedCompanyParams,
  SetTeammateInviteCompaniesCommandDto,
  Unit,
  UnrejectCustomJobFunctionResult,
  UnrejectCustomSkillResult,
  UpdateAdminJobCommandDto,
  UpdateCompanyFromAdminRequestDto,
  UpdateCompanyVideoFromAdminCommandDto,
  UpdateIframeLinkCommandDto,
  UpdateIntegrationErrorAlertPolicyCommandDto,
  UpdateInternalLinkCommandDto,
  UpdateInternalRoleCommandDto,
  UpdateJobImportItemCommandDto,
  UpdateMetabaseIframeLinkCommandDto,
  UpdateSalesDailyLogCommandDto,
  UpdateSalesDemoCommandDto,
  UpdateSalesDemoStatusCommandDto,
  UpdateSalesGoalCommandDto,
  UpdateSegmentCommandDto,
  UpdateSegmentResult,
  UpdateUriLinkCommandDto,
  UpdateWebhookEndpointCommandDto
} from './models';

import { fetchWithAuth } from '../../../src/modules/orval/fetch-with-auth';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAdminListWebhookEndpointsUrl = () => {




  return `/admin/webhooks`
}

/**
 * @summary List all webhook endpoints.
 */
export const adminListWebhookEndpoints = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListWebhookEndpointsResult> => {

  return fetchWithAuth<ListWebhookEndpointsResult>(getAdminListWebhookEndpointsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListWebhookEndpointsQueryKey = () => {
    return [
    'admin','webhooks'
    ] as const;
    }


export const getAdminListWebhookEndpointsQueryOptions = <TData = Awaited<ReturnType<typeof adminListWebhookEndpoints>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListWebhookEndpoints>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListWebhookEndpointsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListWebhookEndpoints>>> = ({ signal }) => adminListWebhookEndpoints({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListWebhookEndpoints>>, TError, TData>
}

export type AdminListWebhookEndpointsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListWebhookEndpoints>>>
export type AdminListWebhookEndpointsQueryError = unknown


/**
 * @summary List all webhook endpoints.
 */

export function useAdminListWebhookEndpoints<TData = Awaited<ReturnType<typeof adminListWebhookEndpoints>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListWebhookEndpoints>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListWebhookEndpointsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminCreateWebhookEndpointUrl = () => {




  return `/admin/webhooks`
}

/**
 * @summary Create a new webhook endpoint.
 */
export const adminCreateWebhookEndpoint = async (createWebhookEndpointCommandDto?: CreateWebhookEndpointCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

  return fetchWithAuth<number>(getAdminCreateWebhookEndpointUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createWebhookEndpointCommandDto)
  }
);}





export const getAdminCreateWebhookEndpointMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateWebhookEndpoint>>, TError,{data?: CreateWebhookEndpointCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateWebhookEndpoint>>, TError,{data?: CreateWebhookEndpointCommandDto}, TContext> => {

const mutationKey = ['adminCreateWebhookEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateWebhookEndpoint>>, {data?: CreateWebhookEndpointCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateWebhookEndpoint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateWebhookEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateWebhookEndpoint>>>
    export type AdminCreateWebhookEndpointMutationBody = CreateWebhookEndpointCommandDto | undefined
    export type AdminCreateWebhookEndpointMutationError = ProblemDetails

    /**
 * @summary Create a new webhook endpoint.
 */
export const useAdminCreateWebhookEndpoint = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateWebhookEndpoint>>, TError,{data?: CreateWebhookEndpointCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateWebhookEndpoint>>,
        TError,
        {data?: CreateWebhookEndpointCommandDto},
        TContext
      > => {
      return useMutation(getAdminCreateWebhookEndpointMutationOptions(options), queryClient);
    }

export const getAdminGetWebhookEndpointUrl = (id: number,) => {




  return `/admin/webhooks/${id}`
}

/**
 * @summary Get a single webhook endpoint by ID.
 */
export const adminGetWebhookEndpoint = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetWebhookEndpointWebhookEndpointDetailDto> => {

  return fetchWithAuth<GetWebhookEndpointWebhookEndpointDetailDto>(getAdminGetWebhookEndpointUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetWebhookEndpointQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','webhooks',id
    ] as const;
    }


export const getAdminGetWebhookEndpointQueryOptions = <TData = Awaited<ReturnType<typeof adminGetWebhookEndpoint>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetWebhookEndpoint>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetWebhookEndpointQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetWebhookEndpoint>>> = ({ signal }) => adminGetWebhookEndpoint(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetWebhookEndpoint>>, TError, TData>
}

export type AdminGetWebhookEndpointQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetWebhookEndpoint>>>
export type AdminGetWebhookEndpointQueryError = ProblemDetails


/**
 * @summary Get a single webhook endpoint by ID.
 */

export function useAdminGetWebhookEndpoint<TData = Awaited<ReturnType<typeof adminGetWebhookEndpoint>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetWebhookEndpoint>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetWebhookEndpointQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminUpdateWebhookEndpointUrl = (id: number,) => {




  return `/admin/webhooks/${id}`
}

/**
 * @summary Update an existing webhook endpoint.
 */
export const adminUpdateWebhookEndpoint = async (id: number,
    updateWebhookEndpointCommandDto?: UpdateWebhookEndpointCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getAdminUpdateWebhookEndpointUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateWebhookEndpointCommandDto)
  }
);}





export const getAdminUpdateWebhookEndpointMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateWebhookEndpoint>>, TError,{id: number;data?: UpdateWebhookEndpointCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateWebhookEndpoint>>, TError,{id: number;data?: UpdateWebhookEndpointCommandDto}, TContext> => {

const mutationKey = ['adminUpdateWebhookEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateWebhookEndpoint>>, {id: number;data?: UpdateWebhookEndpointCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateWebhookEndpoint(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateWebhookEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateWebhookEndpoint>>>
    export type AdminUpdateWebhookEndpointMutationBody = UpdateWebhookEndpointCommandDto | undefined
    export type AdminUpdateWebhookEndpointMutationError = ProblemDetails

    /**
 * @summary Update an existing webhook endpoint.
 */
export const useAdminUpdateWebhookEndpoint = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateWebhookEndpoint>>, TError,{id: number;data?: UpdateWebhookEndpointCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateWebhookEndpoint>>,
        TError,
        {id: number;data?: UpdateWebhookEndpointCommandDto},
        TContext
      > => {
      return useMutation(getAdminUpdateWebhookEndpointMutationOptions(options), queryClient);
    }

export const getAdminDeleteWebhookEndpointUrl = (id: number,) => {




  return `/admin/webhooks/${id}`
}

/**
 * @summary Delete a webhook endpoint.
 */
export const adminDeleteWebhookEndpoint = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getAdminDeleteWebhookEndpointUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminDeleteWebhookEndpointMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteWebhookEndpoint>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteWebhookEndpoint>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminDeleteWebhookEndpoint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteWebhookEndpoint>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminDeleteWebhookEndpoint(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteWebhookEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteWebhookEndpoint>>>

    export type AdminDeleteWebhookEndpointMutationError = ProblemDetails

    /**
 * @summary Delete a webhook endpoint.
 */
export const useAdminDeleteWebhookEndpoint = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteWebhookEndpoint>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminDeleteWebhookEndpoint>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminDeleteWebhookEndpointMutationOptions(options), queryClient);
    }

export const getAdminGetWebhookEndpointSecretUrl = (id: number,) => {




  return `/admin/webhooks/${id}/secret`
}

/**
 * @summary Get the plaintext secret for a webhook endpoint.
 */
export const adminGetWebhookEndpointSecret = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetWebhookEndpointSecretSecretDto> => {

  return fetchWithAuth<GetWebhookEndpointSecretSecretDto>(getAdminGetWebhookEndpointSecretUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetWebhookEndpointSecretQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','webhooks',id,'secret'
    ] as const;
    }


export const getAdminGetWebhookEndpointSecretQueryOptions = <TData = Awaited<ReturnType<typeof adminGetWebhookEndpointSecret>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetWebhookEndpointSecret>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetWebhookEndpointSecretQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetWebhookEndpointSecret>>> = ({ signal }) => adminGetWebhookEndpointSecret(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetWebhookEndpointSecret>>, TError, TData>
}

export type AdminGetWebhookEndpointSecretQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetWebhookEndpointSecret>>>
export type AdminGetWebhookEndpointSecretQueryError = ProblemDetails


/**
 * @summary Get the plaintext secret for a webhook endpoint.
 */

export function useAdminGetWebhookEndpointSecret<TData = Awaited<ReturnType<typeof adminGetWebhookEndpointSecret>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetWebhookEndpointSecret>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetWebhookEndpointSecretQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminToggleWebhookEndpointActiveUrl = (id: number,) => {




  return `/admin/webhooks/${id}/toggle-active`
}

/**
 * @summary Toggle active/inactive status of a webhook endpoint.
 */
export const adminToggleWebhookEndpointActive = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getAdminToggleWebhookEndpointActiveUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getAdminToggleWebhookEndpointActiveMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminToggleWebhookEndpointActive>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminToggleWebhookEndpointActive>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminToggleWebhookEndpointActive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminToggleWebhookEndpointActive>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminToggleWebhookEndpointActive(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminToggleWebhookEndpointActiveMutationResult = NonNullable<Awaited<ReturnType<typeof adminToggleWebhookEndpointActive>>>

    export type AdminToggleWebhookEndpointActiveMutationError = ProblemDetails

    /**
 * @summary Toggle active/inactive status of a webhook endpoint.
 */
export const useAdminToggleWebhookEndpointActive = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminToggleWebhookEndpointActive>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminToggleWebhookEndpointActive>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminToggleWebhookEndpointActiveMutationOptions(options), queryClient);
    }

export const getAdminListCertificatesUrl = () => {




  return `/admin/admin-certificate`
}

export const adminListCertificates = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminCertificateCrudListResult> => {

  return fetchWithAuth<AdminCertificateCrudListResult>(getAdminListCertificatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListCertificatesQueryKey = () => {
    return [
    'admin','admin-certificate'
    ] as const;
    }


export const getAdminListCertificatesQueryOptions = <TData = Awaited<ReturnType<typeof adminListCertificates>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListCertificates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListCertificatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListCertificates>>> = ({ signal }) => adminListCertificates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListCertificates>>, TError, TData>
}

export type AdminListCertificatesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListCertificates>>>
export type AdminListCertificatesQueryError = unknown



export function useAdminListCertificates<TData = Awaited<ReturnType<typeof adminListCertificates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListCertificates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListCertificatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminUpdateCertificateUrl = () => {




  return `/admin/admin-certificate`
}

export const adminUpdateCertificate = async (adminCertificateCrudUpdateCommand?: AdminCertificateCrudUpdateCommand, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUpdateCertificateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminCertificateCrudUpdateCommand)
  }
);}





export const getAdminUpdateCertificateMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateCertificate>>, TError,{data?: AdminCertificateCrudUpdateCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateCertificate>>, TError,{data?: AdminCertificateCrudUpdateCommand}, TContext> => {

const mutationKey = ['adminUpdateCertificate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateCertificate>>, {data?: AdminCertificateCrudUpdateCommand}> = (props) => {
          const {data} = props ?? {};

          return  adminUpdateCertificate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateCertificateMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateCertificate>>>
    export type AdminUpdateCertificateMutationBody = AdminCertificateCrudUpdateCommand | undefined
    export type AdminUpdateCertificateMutationError = ProblemDetails

    export const useAdminUpdateCertificate = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateCertificate>>, TError,{data?: AdminCertificateCrudUpdateCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateCertificate>>,
        TError,
        {data?: AdminCertificateCrudUpdateCommand},
        TContext
      > => {
      return useMutation(getAdminUpdateCertificateMutationOptions(options), queryClient);
    }

export const getAdminPublishCertificateUrl = (id: number,) => {




  return `/admin/admin-certificate/${id}/publish`
}

export const adminPublishCertificate = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminPublishCertificateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminPublishCertificateMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPublishCertificate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPublishCertificate>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminPublishCertificate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPublishCertificate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminPublishCertificate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPublishCertificateMutationResult = NonNullable<Awaited<ReturnType<typeof adminPublishCertificate>>>

    export type AdminPublishCertificateMutationError = ProblemDetails

    export const useAdminPublishCertificate = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPublishCertificate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminPublishCertificate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminPublishCertificateMutationOptions(options), queryClient);
    }

export const getAdminUnpublishCertificateUrl = (id: number,) => {




  return `/admin/admin-certificate/${id}/unpublish`
}

export const adminUnpublishCertificate = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUnpublishCertificateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminUnpublishCertificateMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUnpublishCertificate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUnpublishCertificate>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminUnpublishCertificate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUnpublishCertificate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminUnpublishCertificate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUnpublishCertificateMutationResult = NonNullable<Awaited<ReturnType<typeof adminUnpublishCertificate>>>

    export type AdminUnpublishCertificateMutationError = ProblemDetails

    export const useAdminUnpublishCertificate = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUnpublishCertificate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUnpublishCertificate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminUnpublishCertificateMutationOptions(options), queryClient);
    }

export const getAdminListHardSkillsUrl = () => {




  return `/admin/admin-hard-skill`
}

export const adminListHardSkills = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminHardSkillCrudListResult> => {

  return fetchWithAuth<AdminHardSkillCrudListResult>(getAdminListHardSkillsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListHardSkillsQueryKey = () => {
    return [
    'admin','admin-hard-skill'
    ] as const;
    }


export const getAdminListHardSkillsQueryOptions = <TData = Awaited<ReturnType<typeof adminListHardSkills>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListHardSkills>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListHardSkillsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListHardSkills>>> = ({ signal }) => adminListHardSkills({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListHardSkills>>, TError, TData>
}

export type AdminListHardSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListHardSkills>>>
export type AdminListHardSkillsQueryError = unknown



export function useAdminListHardSkills<TData = Awaited<ReturnType<typeof adminListHardSkills>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListHardSkills>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListHardSkillsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminUpdateHardSkillUrl = () => {




  return `/admin/admin-hard-skill`
}

export const adminUpdateHardSkill = async (adminHardSkillCrudUpdateCommand?: AdminHardSkillCrudUpdateCommand, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUpdateHardSkillUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminHardSkillCrudUpdateCommand)
  }
);}





export const getAdminUpdateHardSkillMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateHardSkill>>, TError,{data?: AdminHardSkillCrudUpdateCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateHardSkill>>, TError,{data?: AdminHardSkillCrudUpdateCommand}, TContext> => {

const mutationKey = ['adminUpdateHardSkill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateHardSkill>>, {data?: AdminHardSkillCrudUpdateCommand}> = (props) => {
          const {data} = props ?? {};

          return  adminUpdateHardSkill(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateHardSkillMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateHardSkill>>>
    export type AdminUpdateHardSkillMutationBody = AdminHardSkillCrudUpdateCommand | undefined
    export type AdminUpdateHardSkillMutationError = ProblemDetails

    export const useAdminUpdateHardSkill = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateHardSkill>>, TError,{data?: AdminHardSkillCrudUpdateCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateHardSkill>>,
        TError,
        {data?: AdminHardSkillCrudUpdateCommand},
        TContext
      > => {
      return useMutation(getAdminUpdateHardSkillMutationOptions(options), queryClient);
    }

export const getAdminListSkillCategoriesUrl = () => {




  return `/admin/admin-hard-skill/skill-categories`
}

export const adminListSkillCategories = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminHardSkillCrudListSkillCategoriesResult> => {

  return fetchWithAuth<AdminHardSkillCrudListSkillCategoriesResult>(getAdminListSkillCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListSkillCategoriesQueryKey = () => {
    return [
    'admin','admin-hard-skill','skill-categories'
    ] as const;
    }


export const getAdminListSkillCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof adminListSkillCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSkillCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListSkillCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListSkillCategories>>> = ({ signal }) => adminListSkillCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListSkillCategories>>, TError, TData>
}

export type AdminListSkillCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListSkillCategories>>>
export type AdminListSkillCategoriesQueryError = unknown



export function useAdminListSkillCategories<TData = Awaited<ReturnType<typeof adminListSkillCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSkillCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListSkillCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminPublishHardSkillUrl = (id: number,) => {




  return `/admin/admin-hard-skill/${id}/publish`
}

export const adminPublishHardSkill = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminPublishHardSkillUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminPublishHardSkillMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPublishHardSkill>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPublishHardSkill>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminPublishHardSkill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPublishHardSkill>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminPublishHardSkill(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPublishHardSkillMutationResult = NonNullable<Awaited<ReturnType<typeof adminPublishHardSkill>>>

    export type AdminPublishHardSkillMutationError = ProblemDetails

    export const useAdminPublishHardSkill = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPublishHardSkill>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminPublishHardSkill>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminPublishHardSkillMutationOptions(options), queryClient);
    }

export const getAdminUnpublishHardSkillUrl = (id: number,) => {




  return `/admin/admin-hard-skill/${id}/unpublish`
}

export const adminUnpublishHardSkill = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUnpublishHardSkillUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminUnpublishHardSkillMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUnpublishHardSkill>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUnpublishHardSkill>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminUnpublishHardSkill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUnpublishHardSkill>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminUnpublishHardSkill(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUnpublishHardSkillMutationResult = NonNullable<Awaited<ReturnType<typeof adminUnpublishHardSkill>>>

    export type AdminUnpublishHardSkillMutationError = ProblemDetails

    export const useAdminUnpublishHardSkill = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUnpublishHardSkill>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUnpublishHardSkill>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminUnpublishHardSkillMutationOptions(options), queryClient);
    }

export const getAdminListUserSkillCustomsUrl = (params?: AdminListUserSkillCustomsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-user-skill-custom?${stringifiedParams}` : `/admin/admin-user-skill-custom`
}

export const adminListUserSkillCustoms = async (params?: AdminListUserSkillCustomsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminListUserSkillCustomResult> => {

  return fetchWithAuth<AdminListUserSkillCustomResult>(getAdminListUserSkillCustomsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListUserSkillCustomsQueryKey = (params?: MaybeRefOrGetter<AdminListUserSkillCustomsParams>,) => {
    return [
    'admin','admin-user-skill-custom', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListUserSkillCustomsQueryOptions = <TData = Awaited<ReturnType<typeof adminListUserSkillCustoms>>, TError = unknown>(params?: MaybeRefOrGetter<AdminListUserSkillCustomsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUserSkillCustoms>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListUserSkillCustomsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListUserSkillCustoms>>> = ({ signal }) => adminListUserSkillCustoms(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListUserSkillCustoms>>, TError, TData>
}

export type AdminListUserSkillCustomsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListUserSkillCustoms>>>
export type AdminListUserSkillCustomsQueryError = unknown



export function useAdminListUserSkillCustoms<TData = Awaited<ReturnType<typeof adminListUserSkillCustoms>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminListUserSkillCustomsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUserSkillCustoms>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListUserSkillCustomsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminPromoteUserSkillCustomUrl = (id: number,) => {




  return `/admin/admin-user-skill-custom/${id}/promote`
}

export const adminPromoteUserSkillCustom = async (id: number,
    promoteCustomSkillRequestBody?: PromoteCustomSkillRequestBody, options?: Parameters<typeof fetchWithAuth>[1]): Promise<PromoteCustomSkillResult> => {

  return fetchWithAuth<PromoteCustomSkillResult>(getAdminPromoteUserSkillCustomUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(promoteCustomSkillRequestBody)
  }
);}





export const getAdminPromoteUserSkillCustomMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPromoteUserSkillCustom>>, TError,{id: number;data?: PromoteCustomSkillRequestBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPromoteUserSkillCustom>>, TError,{id: number;data?: PromoteCustomSkillRequestBody}, TContext> => {

const mutationKey = ['adminPromoteUserSkillCustom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPromoteUserSkillCustom>>, {id: number;data?: PromoteCustomSkillRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  adminPromoteUserSkillCustom(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPromoteUserSkillCustomMutationResult = NonNullable<Awaited<ReturnType<typeof adminPromoteUserSkillCustom>>>
    export type AdminPromoteUserSkillCustomMutationBody = PromoteCustomSkillRequestBody | undefined
    export type AdminPromoteUserSkillCustomMutationError = ProblemDetails

    export const useAdminPromoteUserSkillCustom = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPromoteUserSkillCustom>>, TError,{id: number;data?: PromoteCustomSkillRequestBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminPromoteUserSkillCustom>>,
        TError,
        {id: number;data?: PromoteCustomSkillRequestBody},
        TContext
      > => {
      return useMutation(getAdminPromoteUserSkillCustomMutationOptions(options), queryClient);
    }

export const getAdminRejectUserSkillCustomUrl = (id: number,) => {




  return `/admin/admin-user-skill-custom/${id}/reject`
}

export const adminRejectUserSkillCustom = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<RejectCustomSkillResult> => {

  return fetchWithAuth<RejectCustomSkillResult>(getAdminRejectUserSkillCustomUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminRejectUserSkillCustomMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRejectUserSkillCustom>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRejectUserSkillCustom>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminRejectUserSkillCustom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRejectUserSkillCustom>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminRejectUserSkillCustom(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRejectUserSkillCustomMutationResult = NonNullable<Awaited<ReturnType<typeof adminRejectUserSkillCustom>>>

    export type AdminRejectUserSkillCustomMutationError = ProblemDetails

    export const useAdminRejectUserSkillCustom = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRejectUserSkillCustom>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminRejectUserSkillCustom>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminRejectUserSkillCustomMutationOptions(options), queryClient);
    }

export const getAdminUnrejectUserSkillCustomUrl = (id: number,) => {




  return `/admin/admin-user-skill-custom/${id}/unreject`
}

export const adminUnrejectUserSkillCustom = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<UnrejectCustomSkillResult> => {

  return fetchWithAuth<UnrejectCustomSkillResult>(getAdminUnrejectUserSkillCustomUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminUnrejectUserSkillCustomMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUnrejectUserSkillCustom>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUnrejectUserSkillCustom>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminUnrejectUserSkillCustom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUnrejectUserSkillCustom>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminUnrejectUserSkillCustom(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUnrejectUserSkillCustomMutationResult = NonNullable<Awaited<ReturnType<typeof adminUnrejectUserSkillCustom>>>

    export type AdminUnrejectUserSkillCustomMutationError = ProblemDetails

    export const useAdminUnrejectUserSkillCustom = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUnrejectUserSkillCustom>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUnrejectUserSkillCustom>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminUnrejectUserSkillCustomMutationOptions(options), queryClient);
    }

export const getAdminCreateSalesDailyLogUrl = () => {




  return `/admin/admin-sales/logs`
}

/**
 * @summary Create a new daily sales log entry with associated demos.
 */
export const adminCreateSalesDailyLog = async (createSalesDailyLogCommandDto?: CreateSalesDailyLogCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateSalesDailyLogResult> => {

  return fetchWithAuth<CreateSalesDailyLogResult>(getAdminCreateSalesDailyLogUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSalesDailyLogCommandDto)
  }
);}





export const getAdminCreateSalesDailyLogMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateSalesDailyLog>>, TError,{data?: CreateSalesDailyLogCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateSalesDailyLog>>, TError,{data?: CreateSalesDailyLogCommandDto}, TContext> => {

const mutationKey = ['adminCreateSalesDailyLog'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateSalesDailyLog>>, {data?: CreateSalesDailyLogCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateSalesDailyLog(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateSalesDailyLogMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateSalesDailyLog>>>
    export type AdminCreateSalesDailyLogMutationBody = CreateSalesDailyLogCommandDto | undefined
    export type AdminCreateSalesDailyLogMutationError = ProblemDetails

    /**
 * @summary Create a new daily sales log entry with associated demos.
 */
export const useAdminCreateSalesDailyLog = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateSalesDailyLog>>, TError,{data?: CreateSalesDailyLogCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateSalesDailyLog>>,
        TError,
        {data?: CreateSalesDailyLogCommandDto},
        TContext
      > => {
      return useMutation(getAdminCreateSalesDailyLogMutationOptions(options), queryClient);
    }

export const getAdminListSalesDailyLogsUrl = (params?: AdminListSalesDailyLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-sales/logs?${stringifiedParams}` : `/admin/admin-sales/logs`
}

/**
 * @summary List all daily sales logs across all sales persons.
 */
export const adminListSalesDailyLogs = async (params?: AdminListSalesDailyLogsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSalesDailyLogsResult> => {

  return fetchWithAuth<ListSalesDailyLogsResult>(getAdminListSalesDailyLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListSalesDailyLogsQueryKey = (params?: MaybeRefOrGetter<AdminListSalesDailyLogsParams>,) => {
    return [
    'admin','admin-sales','logs', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListSalesDailyLogsQueryOptions = <TData = Awaited<ReturnType<typeof adminListSalesDailyLogs>>, TError = unknown>(params?: MaybeRefOrGetter<AdminListSalesDailyLogsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSalesDailyLogs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListSalesDailyLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListSalesDailyLogs>>> = ({ signal }) => adminListSalesDailyLogs(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListSalesDailyLogs>>, TError, TData>
}

export type AdminListSalesDailyLogsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListSalesDailyLogs>>>
export type AdminListSalesDailyLogsQueryError = unknown


/**
 * @summary List all daily sales logs across all sales persons.
 */

export function useAdminListSalesDailyLogs<TData = Awaited<ReturnType<typeof adminListSalesDailyLogs>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminListSalesDailyLogsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSalesDailyLogs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListSalesDailyLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminGetSalesDailyLogUrl = (id: number,) => {




  return `/admin/admin-sales/logs/${id}`
}

/**
 * @summary Get a single daily sales log with full demo details (for editing).
 */
export const adminGetSalesDailyLog = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetSalesDailyLogLogDetailDto> => {

  return fetchWithAuth<GetSalesDailyLogLogDetailDto>(getAdminGetSalesDailyLogUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetSalesDailyLogQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','admin-sales','logs',id
    ] as const;
    }


export const getAdminGetSalesDailyLogQueryOptions = <TData = Awaited<ReturnType<typeof adminGetSalesDailyLog>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSalesDailyLog>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetSalesDailyLogQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetSalesDailyLog>>> = ({ signal }) => adminGetSalesDailyLog(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetSalesDailyLog>>, TError, TData>
}

export type AdminGetSalesDailyLogQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetSalesDailyLog>>>
export type AdminGetSalesDailyLogQueryError = ProblemDetails


/**
 * @summary Get a single daily sales log with full demo details (for editing).
 */

export function useAdminGetSalesDailyLog<TData = Awaited<ReturnType<typeof adminGetSalesDailyLog>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSalesDailyLog>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetSalesDailyLogQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminUpdateSalesDailyLogUrl = (id: number,) => {




  return `/admin/admin-sales/logs/${id}`
}

/**
 * @summary Update an existing daily sales log entry.
 */
export const adminUpdateSalesDailyLog = async (id: number,
    updateSalesDailyLogCommandDto?: UpdateSalesDailyLogCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getAdminUpdateSalesDailyLogUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSalesDailyLogCommandDto)
  }
);}





export const getAdminUpdateSalesDailyLogMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSalesDailyLog>>, TError,{id: number;data?: UpdateSalesDailyLogCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSalesDailyLog>>, TError,{id: number;data?: UpdateSalesDailyLogCommandDto}, TContext> => {

const mutationKey = ['adminUpdateSalesDailyLog'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateSalesDailyLog>>, {id: number;data?: UpdateSalesDailyLogCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateSalesDailyLog(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateSalesDailyLogMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateSalesDailyLog>>>
    export type AdminUpdateSalesDailyLogMutationBody = UpdateSalesDailyLogCommandDto | undefined
    export type AdminUpdateSalesDailyLogMutationError = ProblemDetails

    /**
 * @summary Update an existing daily sales log entry.
 */
export const useAdminUpdateSalesDailyLog = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSalesDailyLog>>, TError,{id: number;data?: UpdateSalesDailyLogCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateSalesDailyLog>>,
        TError,
        {id: number;data?: UpdateSalesDailyLogCommandDto},
        TContext
      > => {
      return useMutation(getAdminUpdateSalesDailyLogMutationOptions(options), queryClient);
    }

export const getAdminListMySalesDailyLogsUrl = (params?: AdminListMySalesDailyLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-sales/logs/my?${stringifiedParams}` : `/admin/admin-sales/logs/my`
}

/**
 * @summary List daily sales logs for the currently authenticated sales person.
 */
export const adminListMySalesDailyLogs = async (params?: AdminListMySalesDailyLogsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSalesDailyLogsResult> => {

  return fetchWithAuth<ListSalesDailyLogsResult>(getAdminListMySalesDailyLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListMySalesDailyLogsQueryKey = (params?: MaybeRefOrGetter<AdminListMySalesDailyLogsParams>,) => {
    return [
    'admin','admin-sales','logs','my', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListMySalesDailyLogsQueryOptions = <TData = Awaited<ReturnType<typeof adminListMySalesDailyLogs>>, TError = unknown>(params?: MaybeRefOrGetter<AdminListMySalesDailyLogsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListMySalesDailyLogs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListMySalesDailyLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListMySalesDailyLogs>>> = ({ signal }) => adminListMySalesDailyLogs(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListMySalesDailyLogs>>, TError, TData>
}

export type AdminListMySalesDailyLogsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListMySalesDailyLogs>>>
export type AdminListMySalesDailyLogsQueryError = unknown


/**
 * @summary List daily sales logs for the currently authenticated sales person.
 */

export function useAdminListMySalesDailyLogs<TData = Awaited<ReturnType<typeof adminListMySalesDailyLogs>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminListMySalesDailyLogsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListMySalesDailyLogs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListMySalesDailyLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminGetSalesStatsUrl = (params?: AdminGetSalesStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-sales/stats?${stringifiedParams}` : `/admin/admin-sales/stats`
}

/**
 * @summary Get aggregated sales statistics, optionally filtered to a sales person and date range.
 */
export const adminGetSalesStats = async (params?: AdminGetSalesStatsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetSalesStatsResult> => {

  return fetchWithAuth<GetSalesStatsResult>(getAdminGetSalesStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetSalesStatsQueryKey = (params?: MaybeRefOrGetter<AdminGetSalesStatsParams>,) => {
    return [
    'admin','admin-sales','stats', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminGetSalesStatsQueryOptions = <TData = Awaited<ReturnType<typeof adminGetSalesStats>>, TError = unknown>(params?: MaybeRefOrGetter<AdminGetSalesStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSalesStats>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetSalesStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetSalesStats>>> = ({ signal }) => adminGetSalesStats(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetSalesStats>>, TError, TData>
}

export type AdminGetSalesStatsQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetSalesStats>>>
export type AdminGetSalesStatsQueryError = unknown


/**
 * @summary Get aggregated sales statistics, optionally filtered to a sales person and date range.
 */

export function useAdminGetSalesStats<TData = Awaited<ReturnType<typeof adminGetSalesStats>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminGetSalesStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSalesStats>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetSalesStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminGetMySalesStatsUrl = (params?: AdminGetMySalesStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-sales/stats/my?${stringifiedParams}` : `/admin/admin-sales/stats/my`
}

/**
 * @summary Get aggregated sales statistics for the current user.
 */
export const adminGetMySalesStats = async (params?: AdminGetMySalesStatsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetSalesStatsResult> => {

  return fetchWithAuth<GetSalesStatsResult>(getAdminGetMySalesStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetMySalesStatsQueryKey = (params?: MaybeRefOrGetter<AdminGetMySalesStatsParams>,) => {
    return [
    'admin','admin-sales','stats','my', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminGetMySalesStatsQueryOptions = <TData = Awaited<ReturnType<typeof adminGetMySalesStats>>, TError = unknown>(params?: MaybeRefOrGetter<AdminGetMySalesStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetMySalesStats>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetMySalesStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetMySalesStats>>> = ({ signal }) => adminGetMySalesStats(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetMySalesStats>>, TError, TData>
}

export type AdminGetMySalesStatsQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetMySalesStats>>>
export type AdminGetMySalesStatsQueryError = unknown


/**
 * @summary Get aggregated sales statistics for the current user.
 */

export function useAdminGetMySalesStats<TData = Awaited<ReturnType<typeof adminGetMySalesStats>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminGetMySalesStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetMySalesStats>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetMySalesStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminListSalesDemosUrl = (params?: AdminListSalesDemosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["statuses","sources","potentialSubscriptionTypes"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-sales/demos?${stringifiedParams}` : `/admin/admin-sales/demos`
}

/**
 * @summary List sales demos with filtering, sorting and pagination.
 */
export const adminListSalesDemos = async (params?: AdminListSalesDemosParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSalesDemosResult> => {

  return fetchWithAuth<ListSalesDemosResult>(getAdminListSalesDemosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListSalesDemosQueryKey = (params?: MaybeRefOrGetter<AdminListSalesDemosParams>,) => {
    return [
    'admin','admin-sales','demos', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListSalesDemosQueryOptions = <TData = Awaited<ReturnType<typeof adminListSalesDemos>>, TError = unknown>(params?: MaybeRefOrGetter<AdminListSalesDemosParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSalesDemos>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListSalesDemosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListSalesDemos>>> = ({ signal }) => adminListSalesDemos(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListSalesDemos>>, TError, TData>
}

export type AdminListSalesDemosQueryResult = NonNullable<Awaited<ReturnType<typeof adminListSalesDemos>>>
export type AdminListSalesDemosQueryError = unknown


/**
 * @summary List sales demos with filtering, sorting and pagination.
 */

export function useAdminListSalesDemos<TData = Awaited<ReturnType<typeof adminListSalesDemos>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminListSalesDemosParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSalesDemos>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListSalesDemosQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminCreateSalesDemoUrl = () => {




  return `/admin/admin-sales/demos`
}

/**
 * @summary Create a single demo for the current sales person on a given day. Re-uses the daily log for that
day if one exists, otherwise creates one.
 */
export const adminCreateSalesDemo = async (createSalesDemoCommandDto?: CreateSalesDemoCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateSalesDemoResult> => {

  return fetchWithAuth<CreateSalesDemoResult>(getAdminCreateSalesDemoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSalesDemoCommandDto)
  }
);}





export const getAdminCreateSalesDemoMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateSalesDemo>>, TError,{data?: CreateSalesDemoCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateSalesDemo>>, TError,{data?: CreateSalesDemoCommandDto}, TContext> => {

const mutationKey = ['adminCreateSalesDemo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateSalesDemo>>, {data?: CreateSalesDemoCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateSalesDemo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateSalesDemoMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateSalesDemo>>>
    export type AdminCreateSalesDemoMutationBody = CreateSalesDemoCommandDto | undefined
    export type AdminCreateSalesDemoMutationError = ProblemDetails

    /**
 * @summary Create a single demo for the current sales person on a given day. Re-uses the daily log for that
day if one exists, otherwise creates one.
 */
export const useAdminCreateSalesDemo = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateSalesDemo>>, TError,{data?: CreateSalesDemoCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateSalesDemo>>,
        TError,
        {data?: CreateSalesDemoCommandDto},
        TContext
      > => {
      return useMutation(getAdminCreateSalesDemoMutationOptions(options), queryClient);
    }

export const getAdminUpdateSalesDemoUrl = (id: number,) => {




  return `/admin/admin-sales/demos/${id}`
}

/**
 * @summary Update the basic data of a sales demo (contact info, demo date, potential close date, delayed start date and subscription).
 */
export const adminUpdateSalesDemo = async (id: number,
    updateSalesDemoCommandDto?: UpdateSalesDemoCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUpdateSalesDemoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSalesDemoCommandDto)
  }
);}





export const getAdminUpdateSalesDemoMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSalesDemo>>, TError,{id: number;data?: UpdateSalesDemoCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSalesDemo>>, TError,{id: number;data?: UpdateSalesDemoCommandDto}, TContext> => {

const mutationKey = ['adminUpdateSalesDemo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateSalesDemo>>, {id: number;data?: UpdateSalesDemoCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateSalesDemo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateSalesDemoMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateSalesDemo>>>
    export type AdminUpdateSalesDemoMutationBody = UpdateSalesDemoCommandDto | undefined
    export type AdminUpdateSalesDemoMutationError = ProblemDetails

    /**
 * @summary Update the basic data of a sales demo (contact info, demo date, potential close date, delayed start date and subscription).
 */
export const useAdminUpdateSalesDemo = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSalesDemo>>, TError,{id: number;data?: UpdateSalesDemoCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateSalesDemo>>,
        TError,
        {id: number;data?: UpdateSalesDemoCommandDto},
        TContext
      > => {
      return useMutation(getAdminUpdateSalesDemoMutationOptions(options), queryClient);
    }

export const getAdminDeleteSalesDemoUrl = (id: number,) => {




  return `/admin/admin-sales/demos/${id}`
}

/**
 * @summary Delete a sales demo of the current sales person. The daily log's planned-demos counter is
decremented along with it.
 */
export const adminDeleteSalesDemo = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminDeleteSalesDemoUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminDeleteSalesDemoMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteSalesDemo>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteSalesDemo>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminDeleteSalesDemo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteSalesDemo>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminDeleteSalesDemo(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteSalesDemoMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteSalesDemo>>>

    export type AdminDeleteSalesDemoMutationError = ProblemDetails

    /**
 * @summary Delete a sales demo of the current sales person. The daily log's planned-demos counter is
decremented along with it.
 */
export const useAdminDeleteSalesDemo = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteSalesDemo>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminDeleteSalesDemo>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminDeleteSalesDemoMutationOptions(options), queryClient);
    }

export const getAdminUpdateSalesDemoStatusUrl = (id: number,) => {




  return `/admin/admin-sales/demos/${id}/status`
}

/**
 * @summary Update only the status of a sales demo. For a won deal, the user can also re-confirm
the expected onboarding date and the chosen subscription and trigger an onboarding invite.
 */
export const adminUpdateSalesDemoStatus = async (id: number,
    updateSalesDemoStatusCommandDto?: UpdateSalesDemoStatusCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUpdateSalesDemoStatusUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSalesDemoStatusCommandDto)
  }
);}





export const getAdminUpdateSalesDemoStatusMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSalesDemoStatus>>, TError,{id: number;data?: UpdateSalesDemoStatusCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSalesDemoStatus>>, TError,{id: number;data?: UpdateSalesDemoStatusCommandDto}, TContext> => {

const mutationKey = ['adminUpdateSalesDemoStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateSalesDemoStatus>>, {id: number;data?: UpdateSalesDemoStatusCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateSalesDemoStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateSalesDemoStatusMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateSalesDemoStatus>>>
    export type AdminUpdateSalesDemoStatusMutationBody = UpdateSalesDemoStatusCommandDto | undefined
    export type AdminUpdateSalesDemoStatusMutationError = ProblemDetails

    /**
 * @summary Update only the status of a sales demo. For a won deal, the user can also re-confirm
the expected onboarding date and the chosen subscription and trigger an onboarding invite.
 */
export const useAdminUpdateSalesDemoStatus = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSalesDemoStatus>>, TError,{id: number;data?: UpdateSalesDemoStatusCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateSalesDemoStatus>>,
        TError,
        {id: number;data?: UpdateSalesDemoStatusCommandDto},
        TContext
      > => {
      return useMutation(getAdminUpdateSalesDemoStatusMutationOptions(options), queryClient);
    }

export const getAdminListLinkableSalesDemosUrl = (params?: AdminListLinkableSalesDemosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-sales/demos/linkable?${stringifiedParams}` : `/admin/admin-sales/demos/linkable`
}

/**
 * @summary List the demos that never reached a company, so one can be attached to an existing company.
 */
export const adminListLinkableSalesDemos = async (params?: AdminListLinkableSalesDemosParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListLinkableSalesDemosResult> => {

  return fetchWithAuth<ListLinkableSalesDemosResult>(getAdminListLinkableSalesDemosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListLinkableSalesDemosQueryKey = (params?: MaybeRefOrGetter<AdminListLinkableSalesDemosParams>,) => {
    return [
    'admin','admin-sales','demos','linkable', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListLinkableSalesDemosQueryOptions = <TData = Awaited<ReturnType<typeof adminListLinkableSalesDemos>>, TError = unknown>(params?: MaybeRefOrGetter<AdminListLinkableSalesDemosParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLinkableSalesDemos>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListLinkableSalesDemosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListLinkableSalesDemos>>> = ({ signal }) => adminListLinkableSalesDemos(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListLinkableSalesDemos>>, TError, TData>
}

export type AdminListLinkableSalesDemosQueryResult = NonNullable<Awaited<ReturnType<typeof adminListLinkableSalesDemos>>>
export type AdminListLinkableSalesDemosQueryError = unknown


/**
 * @summary List the demos that never reached a company, so one can be attached to an existing company.
 */

export function useAdminListLinkableSalesDemos<TData = Awaited<ReturnType<typeof adminListLinkableSalesDemos>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminListLinkableSalesDemosParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLinkableSalesDemos>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListLinkableSalesDemosQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminListLinkableSalesInvitesUrl = (id: number,) => {




  return `/admin/admin-sales/demos/${id}/linkable-invites`
}

/**
 * @summary List the current sales person's sent invites that are not yet linked to a demo, so one can be
attached to the given demo.
 */
export const adminListLinkableSalesInvites = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListLinkableSalesInvitesResult> => {

  return fetchWithAuth<ListLinkableSalesInvitesResult>(getAdminListLinkableSalesInvitesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListLinkableSalesInvitesQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','admin-sales','demos',id,'linkable-invites'
    ] as const;
    }


export const getAdminListLinkableSalesInvitesQueryOptions = <TData = Awaited<ReturnType<typeof adminListLinkableSalesInvites>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLinkableSalesInvites>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListLinkableSalesInvitesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListLinkableSalesInvites>>> = ({ signal }) => adminListLinkableSalesInvites(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListLinkableSalesInvites>>, TError, TData>
}

export type AdminListLinkableSalesInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListLinkableSalesInvites>>>
export type AdminListLinkableSalesInvitesQueryError = ProblemDetails


/**
 * @summary List the current sales person's sent invites that are not yet linked to a demo, so one can be
attached to the given demo.
 */

export function useAdminListLinkableSalesInvites<TData = Awaited<ReturnType<typeof adminListLinkableSalesInvites>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLinkableSalesInvites>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListLinkableSalesInvitesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminListMyLinkableSalesInvitesUrl = () => {




  return `/admin/admin-sales/linkable-invites`
}

/**
 * @summary List the current sales person's sent invites that are not yet linked to any demo, so one can be
linked while creating a new demo.
 */
export const adminListMyLinkableSalesInvites = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListLinkableSalesInvitesResult> => {

  return fetchWithAuth<ListLinkableSalesInvitesResult>(getAdminListMyLinkableSalesInvitesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListMyLinkableSalesInvitesQueryKey = () => {
    return [
    'admin','admin-sales','linkable-invites'
    ] as const;
    }


export const getAdminListMyLinkableSalesInvitesQueryOptions = <TData = Awaited<ReturnType<typeof adminListMyLinkableSalesInvites>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListMyLinkableSalesInvites>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListMyLinkableSalesInvitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListMyLinkableSalesInvites>>> = ({ signal }) => adminListMyLinkableSalesInvites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListMyLinkableSalesInvites>>, TError, TData>
}

export type AdminListMyLinkableSalesInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListMyLinkableSalesInvites>>>
export type AdminListMyLinkableSalesInvitesQueryError = unknown


/**
 * @summary List the current sales person's sent invites that are not yet linked to any demo, so one can be
linked while creating a new demo.
 */

export function useAdminListMyLinkableSalesInvites<TData = Awaited<ReturnType<typeof adminListMyLinkableSalesInvites>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListMyLinkableSalesInvites>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListMyLinkableSalesInvitesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminLinkSalesDemoInviteUrl = (id: number,) => {




  return `/admin/admin-sales/demos/${id}/link-invite`
}

/**
 * @summary Attach an already-sent invite to a demo that has no invite yet.
 */
export const adminLinkSalesDemoInvite = async (id: number,
    linkSalesDemoInviteCommandDto?: LinkSalesDemoInviteCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminLinkSalesDemoInviteUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkSalesDemoInviteCommandDto)
  }
);}





export const getAdminLinkSalesDemoInviteMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLinkSalesDemoInvite>>, TError,{id: number;data?: LinkSalesDemoInviteCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminLinkSalesDemoInvite>>, TError,{id: number;data?: LinkSalesDemoInviteCommandDto}, TContext> => {

const mutationKey = ['adminLinkSalesDemoInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminLinkSalesDemoInvite>>, {id: number;data?: LinkSalesDemoInviteCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminLinkSalesDemoInvite(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminLinkSalesDemoInviteMutationResult = NonNullable<Awaited<ReturnType<typeof adminLinkSalesDemoInvite>>>
    export type AdminLinkSalesDemoInviteMutationBody = LinkSalesDemoInviteCommandDto | undefined
    export type AdminLinkSalesDemoInviteMutationError = ProblemDetails

    /**
 * @summary Attach an already-sent invite to a demo that has no invite yet.
 */
export const useAdminLinkSalesDemoInvite = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminLinkSalesDemoInvite>>, TError,{id: number;data?: LinkSalesDemoInviteCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminLinkSalesDemoInvite>>,
        TError,
        {id: number;data?: LinkSalesDemoInviteCommandDto},
        TContext
      > => {
      return useMutation(getAdminLinkSalesDemoInviteMutationOptions(options), queryClient);
    }

export const getAdminGetSalesForecastUrl = (params?: AdminGetSalesForecastParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-sales/forecast?${stringifiedParams}` : `/admin/admin-sales/forecast`
}

/**
 * @summary Get the sales forecast over the committed deals (written agreement / deal won) of a date range.
 */
export const adminGetSalesForecast = async (params?: AdminGetSalesForecastParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetSalesForecastResult> => {

  return fetchWithAuth<GetSalesForecastResult>(getAdminGetSalesForecastUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetSalesForecastQueryKey = (params?: MaybeRefOrGetter<AdminGetSalesForecastParams>,) => {
    return [
    'admin','admin-sales','forecast', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminGetSalesForecastQueryOptions = <TData = Awaited<ReturnType<typeof adminGetSalesForecast>>, TError = unknown>(params?: MaybeRefOrGetter<AdminGetSalesForecastParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSalesForecast>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetSalesForecastQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetSalesForecast>>> = ({ signal }) => adminGetSalesForecast(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetSalesForecast>>, TError, TData>
}

export type AdminGetSalesForecastQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetSalesForecast>>>
export type AdminGetSalesForecastQueryError = unknown


/**
 * @summary Get the sales forecast over the committed deals (written agreement / deal won) of a date range.
 */

export function useAdminGetSalesForecast<TData = Awaited<ReturnType<typeof adminGetSalesForecast>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminGetSalesForecastParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSalesForecast>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetSalesForecastQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminGetSubscriptionMetricsUrl = (params?: AdminGetSubscriptionMetricsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-sales/subscription-metrics?${stringifiedParams}` : `/admin/admin-sales/subscription-metrics`
}

/**
 * @summary Get the recurring-revenue overview of the running customer base: MRR/ARR totals plus the
company-by-company breakdown behind them.
 */
export const adminGetSubscriptionMetrics = async (params?: AdminGetSubscriptionMetricsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetSubscriptionMetricsResult> => {

  return fetchWithAuth<GetSubscriptionMetricsResult>(getAdminGetSubscriptionMetricsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetSubscriptionMetricsQueryKey = (params?: MaybeRefOrGetter<AdminGetSubscriptionMetricsParams>,) => {
    return [
    'admin','admin-sales','subscription-metrics', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminGetSubscriptionMetricsQueryOptions = <TData = Awaited<ReturnType<typeof adminGetSubscriptionMetrics>>, TError = unknown>(params?: MaybeRefOrGetter<AdminGetSubscriptionMetricsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSubscriptionMetrics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetSubscriptionMetricsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetSubscriptionMetrics>>> = ({ signal }) => adminGetSubscriptionMetrics(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetSubscriptionMetrics>>, TError, TData>
}

export type AdminGetSubscriptionMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetSubscriptionMetrics>>>
export type AdminGetSubscriptionMetricsQueryError = unknown


/**
 * @summary Get the recurring-revenue overview of the running customer base: MRR/ARR totals plus the
company-by-company breakdown behind them.
 */

export function useAdminGetSubscriptionMetrics<TData = Awaited<ReturnType<typeof adminGetSubscriptionMetrics>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminGetSubscriptionMetricsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSubscriptionMetrics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetSubscriptionMetricsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminListSalesSubscriptionPlansUrl = () => {




  return `/admin/admin-sales/subscriptions`
}

/**
 * @summary List all available subscription plans (for VacancySlots selector).
 */
export const adminListSalesSubscriptionPlans = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminSubscriptionPlansResult> => {

  return fetchWithAuth<ListAdminSubscriptionPlansResult>(getAdminListSalesSubscriptionPlansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListSalesSubscriptionPlansQueryKey = () => {
    return [
    'admin','admin-sales','subscriptions'
    ] as const;
    }


export const getAdminListSalesSubscriptionPlansQueryOptions = <TData = Awaited<ReturnType<typeof adminListSalesSubscriptionPlans>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSalesSubscriptionPlans>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListSalesSubscriptionPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListSalesSubscriptionPlans>>> = ({ signal }) => adminListSalesSubscriptionPlans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListSalesSubscriptionPlans>>, TError, TData>
}

export type AdminListSalesSubscriptionPlansQueryResult = NonNullable<Awaited<ReturnType<typeof adminListSalesSubscriptionPlans>>>
export type AdminListSalesSubscriptionPlansQueryError = unknown


/**
 * @summary List all available subscription plans (for VacancySlots selector).
 */

export function useAdminListSalesSubscriptionPlans<TData = Awaited<ReturnType<typeof adminListSalesSubscriptionPlans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSalesSubscriptionPlans>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListSalesSubscriptionPlansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminCreateSalesGoalUrl = () => {




  return `/admin/admin-sales/goals`
}

/**
 * @summary Create a new sales/customer-success goal for a person and quarter.
 */
export const adminCreateSalesGoal = async (createSalesGoalCommandDto?: CreateSalesGoalCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateSalesGoalResult> => {

  return fetchWithAuth<CreateSalesGoalResult>(getAdminCreateSalesGoalUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSalesGoalCommandDto)
  }
);}





export const getAdminCreateSalesGoalMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateSalesGoal>>, TError,{data?: CreateSalesGoalCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateSalesGoal>>, TError,{data?: CreateSalesGoalCommandDto}, TContext> => {

const mutationKey = ['adminCreateSalesGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateSalesGoal>>, {data?: CreateSalesGoalCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateSalesGoal(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateSalesGoalMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateSalesGoal>>>
    export type AdminCreateSalesGoalMutationBody = CreateSalesGoalCommandDto | undefined
    export type AdminCreateSalesGoalMutationError = ProblemDetails

    /**
 * @summary Create a new sales/customer-success goal for a person and quarter.
 */
export const useAdminCreateSalesGoal = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateSalesGoal>>, TError,{data?: CreateSalesGoalCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateSalesGoal>>,
        TError,
        {data?: CreateSalesGoalCommandDto},
        TContext
      > => {
      return useMutation(getAdminCreateSalesGoalMutationOptions(options), queryClient);
    }

export const getAdminListSalesGoalsUrl = (params?: AdminListSalesGoalsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["types"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-sales/goals?${stringifiedParams}` : `/admin/admin-sales/goals`
}

/**
 * @summary List goals across all persons, with optional filters.
 */
export const adminListSalesGoals = async (params?: AdminListSalesGoalsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSalesGoalsResult> => {

  return fetchWithAuth<ListSalesGoalsResult>(getAdminListSalesGoalsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListSalesGoalsQueryKey = (params?: MaybeRefOrGetter<AdminListSalesGoalsParams>,) => {
    return [
    'admin','admin-sales','goals', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListSalesGoalsQueryOptions = <TData = Awaited<ReturnType<typeof adminListSalesGoals>>, TError = unknown>(params?: MaybeRefOrGetter<AdminListSalesGoalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSalesGoals>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListSalesGoalsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListSalesGoals>>> = ({ signal }) => adminListSalesGoals(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListSalesGoals>>, TError, TData>
}

export type AdminListSalesGoalsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListSalesGoals>>>
export type AdminListSalesGoalsQueryError = unknown


/**
 * @summary List goals across all persons, with optional filters.
 */

export function useAdminListSalesGoals<TData = Awaited<ReturnType<typeof adminListSalesGoals>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminListSalesGoalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListSalesGoals>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListSalesGoalsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminUpdateSalesGoalUrl = (id: number,) => {




  return `/admin/admin-sales/goals/${id}`
}

/**
 * @summary Update an existing goal (target, type and/or quarter).
 */
export const adminUpdateSalesGoal = async (id: number,
    updateSalesGoalCommandDto?: UpdateSalesGoalCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUpdateSalesGoalUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSalesGoalCommandDto)
  }
);}





export const getAdminUpdateSalesGoalMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSalesGoal>>, TError,{id: number;data?: UpdateSalesGoalCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSalesGoal>>, TError,{id: number;data?: UpdateSalesGoalCommandDto}, TContext> => {

const mutationKey = ['adminUpdateSalesGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateSalesGoal>>, {id: number;data?: UpdateSalesGoalCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateSalesGoal(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateSalesGoalMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateSalesGoal>>>
    export type AdminUpdateSalesGoalMutationBody = UpdateSalesGoalCommandDto | undefined
    export type AdminUpdateSalesGoalMutationError = ProblemDetails

    /**
 * @summary Update an existing goal (target, type and/or quarter).
 */
export const useAdminUpdateSalesGoal = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateSalesGoal>>, TError,{id: number;data?: UpdateSalesGoalCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateSalesGoal>>,
        TError,
        {id: number;data?: UpdateSalesGoalCommandDto},
        TContext
      > => {
      return useMutation(getAdminUpdateSalesGoalMutationOptions(options), queryClient);
    }

export const getAdminDeleteSalesGoalUrl = (id: number,) => {




  return `/admin/admin-sales/goals/${id}`
}

/**
 * @summary Delete a goal.
 */
export const adminDeleteSalesGoal = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminDeleteSalesGoalUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminDeleteSalesGoalMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteSalesGoal>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteSalesGoal>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminDeleteSalesGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteSalesGoal>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminDeleteSalesGoal(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteSalesGoalMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteSalesGoal>>>

    export type AdminDeleteSalesGoalMutationError = ProblemDetails

    /**
 * @summary Delete a goal.
 */
export const useAdminDeleteSalesGoal = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteSalesGoal>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminDeleteSalesGoal>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminDeleteSalesGoalMutationOptions(options), queryClient);
    }

export const getAdminAddSalesGoalRealizedCompanyUrl = (id: number,) => {




  return `/admin/admin-sales/goals/${id}/realized-companies`
}

/**
 * @summary Manually link a company's revenue contribution to a goal (adds to its realised value).
 */
export const adminAddSalesGoalRealizedCompany = async (id: number,
    addSalesGoalRealizedCompanyCommandDto?: AddSalesGoalRealizedCompanyCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminAddSalesGoalRealizedCompanyUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addSalesGoalRealizedCompanyCommandDto)
  }
);}





export const getAdminAddSalesGoalRealizedCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAddSalesGoalRealizedCompany>>, TError,{id: number;data?: AddSalesGoalRealizedCompanyCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAddSalesGoalRealizedCompany>>, TError,{id: number;data?: AddSalesGoalRealizedCompanyCommandDto}, TContext> => {

const mutationKey = ['adminAddSalesGoalRealizedCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAddSalesGoalRealizedCompany>>, {id: number;data?: AddSalesGoalRealizedCompanyCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminAddSalesGoalRealizedCompany(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAddSalesGoalRealizedCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof adminAddSalesGoalRealizedCompany>>>
    export type AdminAddSalesGoalRealizedCompanyMutationBody = AddSalesGoalRealizedCompanyCommandDto | undefined
    export type AdminAddSalesGoalRealizedCompanyMutationError = ProblemDetails

    /**
 * @summary Manually link a company's revenue contribution to a goal (adds to its realised value).
 */
export const useAdminAddSalesGoalRealizedCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAddSalesGoalRealizedCompany>>, TError,{id: number;data?: AddSalesGoalRealizedCompanyCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminAddSalesGoalRealizedCompany>>,
        TError,
        {id: number;data?: AddSalesGoalRealizedCompanyCommandDto},
        TContext
      > => {
      return useMutation(getAdminAddSalesGoalRealizedCompanyMutationOptions(options), queryClient);
    }

export const getAdminMoveSalesGoalRealizedCompanyUrl = (id: number,) => {




  return `/admin/admin-sales/goals/${id}/realized-companies/move`
}

/**
 * @summary Move a single realised-company contribution to another person's goal for the same type and quarter.
 */
export const adminMoveSalesGoalRealizedCompany = async (id: number,
    moveSalesGoalRealizedCompanyCommandDto?: MoveSalesGoalRealizedCompanyCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminMoveSalesGoalRealizedCompanyUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(moveSalesGoalRealizedCompanyCommandDto)
  }
);}





export const getAdminMoveSalesGoalRealizedCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMoveSalesGoalRealizedCompany>>, TError,{id: number;data?: MoveSalesGoalRealizedCompanyCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMoveSalesGoalRealizedCompany>>, TError,{id: number;data?: MoveSalesGoalRealizedCompanyCommandDto}, TContext> => {

const mutationKey = ['adminMoveSalesGoalRealizedCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMoveSalesGoalRealizedCompany>>, {id: number;data?: MoveSalesGoalRealizedCompanyCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminMoveSalesGoalRealizedCompany(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMoveSalesGoalRealizedCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof adminMoveSalesGoalRealizedCompany>>>
    export type AdminMoveSalesGoalRealizedCompanyMutationBody = MoveSalesGoalRealizedCompanyCommandDto | undefined
    export type AdminMoveSalesGoalRealizedCompanyMutationError = ProblemDetails

    /**
 * @summary Move a single realised-company contribution to another person's goal for the same type and quarter.
 */
export const useAdminMoveSalesGoalRealizedCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMoveSalesGoalRealizedCompany>>, TError,{id: number;data?: MoveSalesGoalRealizedCompanyCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminMoveSalesGoalRealizedCompany>>,
        TError,
        {id: number;data?: MoveSalesGoalRealizedCompanyCommandDto},
        TContext
      > => {
      return useMutation(getAdminMoveSalesGoalRealizedCompanyMutationOptions(options), queryClient);
    }

export const getAdminDeleteSalesGoalRealizedCompanyUrl = (id: number,
    index: number,) => {




  return `/admin/admin-sales/goals/${id}/realized-companies/${index}`
}

/**
 * @summary Remove a single realised-company contribution from a goal (subtracts from its realised value).
 */
export const adminDeleteSalesGoalRealizedCompany = async (id: number,
    index: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminDeleteSalesGoalRealizedCompanyUrl(id,index),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminDeleteSalesGoalRealizedCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteSalesGoalRealizedCompany>>, TError,{id: number;index: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteSalesGoalRealizedCompany>>, TError,{id: number;index: number}, TContext> => {

const mutationKey = ['adminDeleteSalesGoalRealizedCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteSalesGoalRealizedCompany>>, {id: number;index: number}> = (props) => {
          const {id,index} = props ?? {};

          return  adminDeleteSalesGoalRealizedCompany(id,index,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteSalesGoalRealizedCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteSalesGoalRealizedCompany>>>

    export type AdminDeleteSalesGoalRealizedCompanyMutationError = ProblemDetails

    /**
 * @summary Remove a single realised-company contribution from a goal (subtracts from its realised value).
 */
export const useAdminDeleteSalesGoalRealizedCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteSalesGoalRealizedCompany>>, TError,{id: number;index: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminDeleteSalesGoalRealizedCompany>>,
        TError,
        {id: number;index: number},
        TContext
      > => {
      return useMutation(getAdminDeleteSalesGoalRealizedCompanyMutationOptions(options), queryClient);
    }

export const getAdminListMySalesGoalsUrl = (params?: AdminListMySalesGoalsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["types"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-sales/goals/my?${stringifiedParams}` : `/admin/admin-sales/goals/my`
}

/**
 * @summary List goals for the currently authenticated person.
 */
export const adminListMySalesGoals = async (params?: AdminListMySalesGoalsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSalesGoalsResult> => {

  return fetchWithAuth<ListSalesGoalsResult>(getAdminListMySalesGoalsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListMySalesGoalsQueryKey = (params?: MaybeRefOrGetter<AdminListMySalesGoalsParams>,) => {
    return [
    'admin','admin-sales','goals','my', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListMySalesGoalsQueryOptions = <TData = Awaited<ReturnType<typeof adminListMySalesGoals>>, TError = unknown>(params?: MaybeRefOrGetter<AdminListMySalesGoalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListMySalesGoals>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListMySalesGoalsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListMySalesGoals>>> = ({ signal }) => adminListMySalesGoals(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListMySalesGoals>>, TError, TData>
}

export type AdminListMySalesGoalsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListMySalesGoals>>>
export type AdminListMySalesGoalsQueryError = unknown


/**
 * @summary List goals for the currently authenticated person.
 */

export function useAdminListMySalesGoals<TData = Awaited<ReturnType<typeof adminListMySalesGoals>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminListMySalesGoalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListMySalesGoals>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListMySalesGoalsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminGetSalesGoalStatsUrl = (params?: AdminGetSalesGoalStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["types"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-sales/goals/stats?${stringifiedParams}` : `/admin/admin-sales/goals/stats`
}

/**
 * @summary Get aggregated goal statistics, optionally filtered.
 */
export const adminGetSalesGoalStats = async (params?: AdminGetSalesGoalStatsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetSalesGoalStatsResult> => {

  return fetchWithAuth<GetSalesGoalStatsResult>(getAdminGetSalesGoalStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetSalesGoalStatsQueryKey = (params?: MaybeRefOrGetter<AdminGetSalesGoalStatsParams>,) => {
    return [
    'admin','admin-sales','goals','stats', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminGetSalesGoalStatsQueryOptions = <TData = Awaited<ReturnType<typeof adminGetSalesGoalStats>>, TError = unknown>(params?: MaybeRefOrGetter<AdminGetSalesGoalStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSalesGoalStats>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetSalesGoalStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetSalesGoalStats>>> = ({ signal }) => adminGetSalesGoalStats(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetSalesGoalStats>>, TError, TData>
}

export type AdminGetSalesGoalStatsQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetSalesGoalStats>>>
export type AdminGetSalesGoalStatsQueryError = unknown


/**
 * @summary Get aggregated goal statistics, optionally filtered.
 */

export function useAdminGetSalesGoalStats<TData = Awaited<ReturnType<typeof adminGetSalesGoalStats>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminGetSalesGoalStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetSalesGoalStats>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetSalesGoalStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminListReferralSourcesUrl = () => {




  return `/admin/admin-referral-source`
}

export const adminListReferralSources = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminReferralSourceCrudListResult> => {

  return fetchWithAuth<AdminReferralSourceCrudListResult>(getAdminListReferralSourcesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListReferralSourcesQueryKey = () => {
    return [
    'admin','admin-referral-source'
    ] as const;
    }


export const getAdminListReferralSourcesQueryOptions = <TData = Awaited<ReturnType<typeof adminListReferralSources>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListReferralSources>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListReferralSourcesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListReferralSources>>> = ({ signal }) => adminListReferralSources({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListReferralSources>>, TError, TData>
}

export type AdminListReferralSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListReferralSources>>>
export type AdminListReferralSourcesQueryError = unknown



export function useAdminListReferralSources<TData = Awaited<ReturnType<typeof adminListReferralSources>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListReferralSources>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListReferralSourcesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminCreateReferralSourceUrl = () => {




  return `/admin/admin-referral-source`
}

export const adminCreateReferralSource = async (adminReferralSourceCrudCreateCommand?: AdminReferralSourceCrudCreateCommand, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminReferralSourceCrudReferralSourceDto> => {

  return fetchWithAuth<AdminReferralSourceCrudReferralSourceDto>(getAdminCreateReferralSourceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminReferralSourceCrudCreateCommand)
  }
);}





export const getAdminCreateReferralSourceMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateReferralSource>>, TError,{data?: AdminReferralSourceCrudCreateCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateReferralSource>>, TError,{data?: AdminReferralSourceCrudCreateCommand}, TContext> => {

const mutationKey = ['adminCreateReferralSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateReferralSource>>, {data?: AdminReferralSourceCrudCreateCommand}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateReferralSource(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateReferralSourceMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateReferralSource>>>
    export type AdminCreateReferralSourceMutationBody = AdminReferralSourceCrudCreateCommand | undefined
    export type AdminCreateReferralSourceMutationError = ProblemDetails

    export const useAdminCreateReferralSource = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateReferralSource>>, TError,{data?: AdminReferralSourceCrudCreateCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateReferralSource>>,
        TError,
        {data?: AdminReferralSourceCrudCreateCommand},
        TContext
      > => {
      return useMutation(getAdminCreateReferralSourceMutationOptions(options), queryClient);
    }

export const getAdminUpdateReferralSourceUrl = () => {




  return `/admin/admin-referral-source`
}

export const adminUpdateReferralSource = async (adminReferralSourceCrudUpdateCommand?: AdminReferralSourceCrudUpdateCommand, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUpdateReferralSourceUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminReferralSourceCrudUpdateCommand)
  }
);}





export const getAdminUpdateReferralSourceMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateReferralSource>>, TError,{data?: AdminReferralSourceCrudUpdateCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateReferralSource>>, TError,{data?: AdminReferralSourceCrudUpdateCommand}, TContext> => {

const mutationKey = ['adminUpdateReferralSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateReferralSource>>, {data?: AdminReferralSourceCrudUpdateCommand}> = (props) => {
          const {data} = props ?? {};

          return  adminUpdateReferralSource(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateReferralSourceMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateReferralSource>>>
    export type AdminUpdateReferralSourceMutationBody = AdminReferralSourceCrudUpdateCommand | undefined
    export type AdminUpdateReferralSourceMutationError = ProblemDetails

    export const useAdminUpdateReferralSource = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateReferralSource>>, TError,{data?: AdminReferralSourceCrudUpdateCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateReferralSource>>,
        TError,
        {data?: AdminReferralSourceCrudUpdateCommand},
        TContext
      > => {
      return useMutation(getAdminUpdateReferralSourceMutationOptions(options), queryClient);
    }

export const getAdminListLinkItemsUrl = (params?: AdminListLinkItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/link-items?${stringifiedParams}` : `/admin/link-items`
}

/**
 * @summary List configurable link items (dashboards/iframes/uris), optionally filtered by category and type.
 */
export const adminListLinkItems = async (params?: AdminListLinkItemsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListLinkItemsResult> => {

  return fetchWithAuth<ListLinkItemsResult>(getAdminListLinkItemsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListLinkItemsQueryKey = (params?: MaybeRefOrGetter<AdminListLinkItemsParams>,) => {
    return [
    'admin','link-items', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListLinkItemsQueryOptions = <TData = Awaited<ReturnType<typeof adminListLinkItems>>, TError = unknown>(params?: MaybeRefOrGetter<AdminListLinkItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLinkItems>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListLinkItemsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListLinkItems>>> = ({ signal }) => adminListLinkItems(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListLinkItems>>, TError, TData>
}

export type AdminListLinkItemsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListLinkItems>>>
export type AdminListLinkItemsQueryError = unknown


/**
 * @summary List configurable link items (dashboards/iframes/uris), optionally filtered by category and type.
 */

export function useAdminListLinkItems<TData = Awaited<ReturnType<typeof adminListLinkItems>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminListLinkItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLinkItems>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListLinkItemsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminListLinkCategoriesUrl = () => {




  return `/admin/link-items/categories`
}

/**
 * @summary All categories (entity-backed), used to drive the form multi-select and the menu/CRUD filters.
 */
export const adminListLinkCategories = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCategoriesResult> => {

  return fetchWithAuth<ListCategoriesResult>(getAdminListLinkCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListLinkCategoriesQueryKey = () => {
    return [
    'admin','link-items','categories'
    ] as const;
    }


export const getAdminListLinkCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof adminListLinkCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLinkCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListLinkCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListLinkCategories>>> = ({ signal }) => adminListLinkCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListLinkCategories>>, TError, TData>
}

export type AdminListLinkCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListLinkCategories>>>
export type AdminListLinkCategoriesQueryError = unknown


/**
 * @summary All categories (entity-backed), used to drive the form multi-select and the menu/CRUD filters.
 */

export function useAdminListLinkCategories<TData = Awaited<ReturnType<typeof adminListLinkCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListLinkCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListLinkCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminCreateLinkCategoryUrl = () => {




  return `/admin/link-items/categories`
}

/**
 * @summary Create a category (used for inline creation from the link-item form).
 */
export const adminCreateLinkCategory = async (createCategoryCommandDto?: CreateCategoryCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateCategoryResult> => {

  return fetchWithAuth<CreateCategoryResult>(getAdminCreateLinkCategoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCategoryCommandDto)
  }
);}





export const getAdminCreateLinkCategoryMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateLinkCategory>>, TError,{data?: CreateCategoryCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateLinkCategory>>, TError,{data?: CreateCategoryCommandDto}, TContext> => {

const mutationKey = ['adminCreateLinkCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateLinkCategory>>, {data?: CreateCategoryCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateLinkCategory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateLinkCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateLinkCategory>>>
    export type AdminCreateLinkCategoryMutationBody = CreateCategoryCommandDto | undefined
    export type AdminCreateLinkCategoryMutationError = ProblemDetails

    /**
 * @summary Create a category (used for inline creation from the link-item form).
 */
export const useAdminCreateLinkCategory = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateLinkCategory>>, TError,{data?: CreateCategoryCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateLinkCategory>>,
        TError,
        {data?: CreateCategoryCommandDto},
        TContext
      > => {
      return useMutation(getAdminCreateLinkCategoryMutationOptions(options), queryClient);
    }

export const getAdminReorderLinkCategoriesUrl = () => {




  return `/admin/link-items/categories/order`
}

/**
 * @summary Reorder the top-level categories (menu/dashboard ordering).
 */
export const adminReorderLinkCategories = async (reorderCategoriesCommandDto?: ReorderCategoriesCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminReorderLinkCategoriesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reorderCategoriesCommandDto)
  }
);}





export const getAdminReorderLinkCategoriesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReorderLinkCategories>>, TError,{data?: ReorderCategoriesCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReorderLinkCategories>>, TError,{data?: ReorderCategoriesCommandDto}, TContext> => {

const mutationKey = ['adminReorderLinkCategories'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReorderLinkCategories>>, {data?: ReorderCategoriesCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminReorderLinkCategories(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReorderLinkCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof adminReorderLinkCategories>>>
    export type AdminReorderLinkCategoriesMutationBody = ReorderCategoriesCommandDto | undefined
    export type AdminReorderLinkCategoriesMutationError = unknown

    /**
 * @summary Reorder the top-level categories (menu/dashboard ordering).
 */
export const useAdminReorderLinkCategories = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReorderLinkCategories>>, TError,{data?: ReorderCategoriesCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminReorderLinkCategories>>,
        TError,
        {data?: ReorderCategoriesCommandDto},
        TContext
      > => {
      return useMutation(getAdminReorderLinkCategoriesMutationOptions(options), queryClient);
    }

export const getAdminReorderCategoryContentsUrl = (categoryId: number,) => {




  return `/admin/link-items/categories/${categoryId}/order`
}

/**
 * @summary Reorder the subcategories and items within a single category.
 */
export const adminReorderCategoryContents = async (categoryId: number,
    reorderCategoryContentsCommandDto?: ReorderCategoryContentsCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminReorderCategoryContentsUrl(categoryId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reorderCategoryContentsCommandDto)
  }
);}





export const getAdminReorderCategoryContentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReorderCategoryContents>>, TError,{categoryId: number;data?: ReorderCategoryContentsCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReorderCategoryContents>>, TError,{categoryId: number;data?: ReorderCategoryContentsCommandDto}, TContext> => {

const mutationKey = ['adminReorderCategoryContents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReorderCategoryContents>>, {categoryId: number;data?: ReorderCategoryContentsCommandDto}> = (props) => {
          const {categoryId,data} = props ?? {};

          return  adminReorderCategoryContents(categoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReorderCategoryContentsMutationResult = NonNullable<Awaited<ReturnType<typeof adminReorderCategoryContents>>>
    export type AdminReorderCategoryContentsMutationBody = ReorderCategoryContentsCommandDto | undefined
    export type AdminReorderCategoryContentsMutationError = unknown

    /**
 * @summary Reorder the subcategories and items within a single category.
 */
export const useAdminReorderCategoryContents = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReorderCategoryContents>>, TError,{categoryId: number;data?: ReorderCategoryContentsCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminReorderCategoryContents>>,
        TError,
        {categoryId: number;data?: ReorderCategoryContentsCommandDto},
        TContext
      > => {
      return useMutation(getAdminReorderCategoryContentsMutationOptions(options), queryClient);
    }

export const getAdminGetLinkItemUrl = (id: number,) => {




  return `/admin/link-items/${id}`
}

/**
 * @summary Get a single link item by id.
 */
export const adminGetLinkItem = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<LinkItemDto> => {

  return fetchWithAuth<LinkItemDto>(getAdminGetLinkItemUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetLinkItemQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','link-items',id
    ] as const;
    }


export const getAdminGetLinkItemQueryOptions = <TData = Awaited<ReturnType<typeof adminGetLinkItem>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLinkItem>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetLinkItemQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetLinkItem>>> = ({ signal }) => adminGetLinkItem(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetLinkItem>>, TError, TData>
}

export type AdminGetLinkItemQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetLinkItem>>>
export type AdminGetLinkItemQueryError = ProblemDetails


/**
 * @summary Get a single link item by id.
 */

export function useAdminGetLinkItem<TData = Awaited<ReturnType<typeof adminGetLinkItem>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetLinkItem>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetLinkItemQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminDeleteLinkItemUrl = (id: number,) => {




  return `/admin/link-items/${id}`
}

/**
 * @summary Delete any link item by id.
 */
export const adminDeleteLinkItem = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminDeleteLinkItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminDeleteLinkItemMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteLinkItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteLinkItem>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminDeleteLinkItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteLinkItem>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminDeleteLinkItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteLinkItemMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteLinkItem>>>

    export type AdminDeleteLinkItemMutationError = ProblemDetails

    /**
 * @summary Delete any link item by id.
 */
export const useAdminDeleteLinkItem = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteLinkItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminDeleteLinkItem>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminDeleteLinkItemMutationOptions(options), queryClient);
    }

export const getAdminGetMetabaseIframeUrlUrl = () => {




  return `/admin/link-items/metabase-iframe-url`
}

/**
 * @summary Sign a short-lived Metabase static-embed iframe URL for the given resource.
 */
export const adminGetMetabaseIframeUrl = async (getMetabaseIframeUrlQueryDto?: GetMetabaseIframeUrlQueryDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetMetabaseIframeUrlResult> => {

  return fetchWithAuth<GetMetabaseIframeUrlResult>(getAdminGetMetabaseIframeUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(getMetabaseIframeUrlQueryDto)
  }
);}





export const getAdminGetMetabaseIframeUrlMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGetMetabaseIframeUrl>>, TError,{data?: GetMetabaseIframeUrlQueryDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminGetMetabaseIframeUrl>>, TError,{data?: GetMetabaseIframeUrlQueryDto}, TContext> => {

const mutationKey = ['adminGetMetabaseIframeUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminGetMetabaseIframeUrl>>, {data?: GetMetabaseIframeUrlQueryDto}> = (props) => {
          const {data} = props ?? {};

          return  adminGetMetabaseIframeUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminGetMetabaseIframeUrlMutationResult = NonNullable<Awaited<ReturnType<typeof adminGetMetabaseIframeUrl>>>
    export type AdminGetMetabaseIframeUrlMutationBody = GetMetabaseIframeUrlQueryDto | undefined
    export type AdminGetMetabaseIframeUrlMutationError = unknown

    /**
 * @summary Sign a short-lived Metabase static-embed iframe URL for the given resource.
 */
export const useAdminGetMetabaseIframeUrl = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGetMetabaseIframeUrl>>, TError,{data?: GetMetabaseIframeUrlQueryDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminGetMetabaseIframeUrl>>,
        TError,
        {data?: GetMetabaseIframeUrlQueryDto},
        TContext
      > => {
      return useMutation(getAdminGetMetabaseIframeUrlMutationOptions(options), queryClient);
    }

export const getAdminCreateMetabaseIframeLinkUrl = () => {




  return `/admin/link-items/metabase-iframe`
}

/**
 * @summary Create a Metabase iframe link item.
 */
export const adminCreateMetabaseIframeLink = async (createMetabaseIframeLinkCommandDto?: CreateMetabaseIframeLinkCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateMetabaseIframeLinkResult> => {

  return fetchWithAuth<CreateMetabaseIframeLinkResult>(getAdminCreateMetabaseIframeLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMetabaseIframeLinkCommandDto)
  }
);}





export const getAdminCreateMetabaseIframeLinkMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateMetabaseIframeLink>>, TError,{data?: CreateMetabaseIframeLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateMetabaseIframeLink>>, TError,{data?: CreateMetabaseIframeLinkCommandDto}, TContext> => {

const mutationKey = ['adminCreateMetabaseIframeLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateMetabaseIframeLink>>, {data?: CreateMetabaseIframeLinkCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateMetabaseIframeLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateMetabaseIframeLinkMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateMetabaseIframeLink>>>
    export type AdminCreateMetabaseIframeLinkMutationBody = CreateMetabaseIframeLinkCommandDto | undefined
    export type AdminCreateMetabaseIframeLinkMutationError = ProblemDetails

    /**
 * @summary Create a Metabase iframe link item.
 */
export const useAdminCreateMetabaseIframeLink = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateMetabaseIframeLink>>, TError,{data?: CreateMetabaseIframeLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateMetabaseIframeLink>>,
        TError,
        {data?: CreateMetabaseIframeLinkCommandDto},
        TContext
      > => {
      return useMutation(getAdminCreateMetabaseIframeLinkMutationOptions(options), queryClient);
    }

export const getAdminCreateIframeLinkUrl = () => {




  return `/admin/link-items/iframe`
}

/**
 * @summary Create a plain iframe link item.
 */
export const adminCreateIframeLink = async (createIframeLinkCommandDto?: CreateIframeLinkCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateIframeLinkResult> => {

  return fetchWithAuth<CreateIframeLinkResult>(getAdminCreateIframeLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createIframeLinkCommandDto)
  }
);}





export const getAdminCreateIframeLinkMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateIframeLink>>, TError,{data?: CreateIframeLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateIframeLink>>, TError,{data?: CreateIframeLinkCommandDto}, TContext> => {

const mutationKey = ['adminCreateIframeLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateIframeLink>>, {data?: CreateIframeLinkCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateIframeLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateIframeLinkMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateIframeLink>>>
    export type AdminCreateIframeLinkMutationBody = CreateIframeLinkCommandDto | undefined
    export type AdminCreateIframeLinkMutationError = ProblemDetails

    /**
 * @summary Create a plain iframe link item.
 */
export const useAdminCreateIframeLink = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateIframeLink>>, TError,{data?: CreateIframeLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateIframeLink>>,
        TError,
        {data?: CreateIframeLinkCommandDto},
        TContext
      > => {
      return useMutation(getAdminCreateIframeLinkMutationOptions(options), queryClient);
    }

export const getAdminCreateUriLinkUrl = () => {




  return `/admin/link-items/uri`
}

/**
 * @summary Create an external uri link item.
 */
export const adminCreateUriLink = async (createUriLinkCommandDto?: CreateUriLinkCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateUriLinkResult> => {

  return fetchWithAuth<CreateUriLinkResult>(getAdminCreateUriLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createUriLinkCommandDto)
  }
);}





export const getAdminCreateUriLinkMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateUriLink>>, TError,{data?: CreateUriLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateUriLink>>, TError,{data?: CreateUriLinkCommandDto}, TContext> => {

const mutationKey = ['adminCreateUriLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateUriLink>>, {data?: CreateUriLinkCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateUriLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateUriLinkMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateUriLink>>>
    export type AdminCreateUriLinkMutationBody = CreateUriLinkCommandDto | undefined
    export type AdminCreateUriLinkMutationError = ProblemDetails

    /**
 * @summary Create an external uri link item.
 */
export const useAdminCreateUriLink = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateUriLink>>, TError,{data?: CreateUriLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateUriLink>>,
        TError,
        {data?: CreateUriLinkCommandDto},
        TContext
      > => {
      return useMutation(getAdminCreateUriLinkMutationOptions(options), queryClient);
    }

export const getAdminCreateInternalLinkUrl = () => {




  return `/admin/link-items/internal-link`
}

/**
 * @summary Create an internal link item (links to a named router route inside the admin portal).
 */
export const adminCreateInternalLink = async (createInternalLinkCommandDto?: CreateInternalLinkCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateInternalLinkResult> => {

  return fetchWithAuth<CreateInternalLinkResult>(getAdminCreateInternalLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createInternalLinkCommandDto)
  }
);}





export const getAdminCreateInternalLinkMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateInternalLink>>, TError,{data?: CreateInternalLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateInternalLink>>, TError,{data?: CreateInternalLinkCommandDto}, TContext> => {

const mutationKey = ['adminCreateInternalLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateInternalLink>>, {data?: CreateInternalLinkCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateInternalLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateInternalLinkMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateInternalLink>>>
    export type AdminCreateInternalLinkMutationBody = CreateInternalLinkCommandDto | undefined
    export type AdminCreateInternalLinkMutationError = ProblemDetails

    /**
 * @summary Create an internal link item (links to a named router route inside the admin portal).
 */
export const useAdminCreateInternalLink = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateInternalLink>>, TError,{data?: CreateInternalLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateInternalLink>>,
        TError,
        {data?: CreateInternalLinkCommandDto},
        TContext
      > => {
      return useMutation(getAdminCreateInternalLinkMutationOptions(options), queryClient);
    }

export const getAdminUpdateMetabaseIframeLinkUrl = (id: number,) => {




  return `/admin/link-items/metabase-iframe/${id}`
}

/**
 * @summary Update a Metabase iframe link item.
 */
export const adminUpdateMetabaseIframeLink = async (id: number,
    updateMetabaseIframeLinkCommandDto?: UpdateMetabaseIframeLinkCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUpdateMetabaseIframeLinkUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateMetabaseIframeLinkCommandDto)
  }
);}





export const getAdminUpdateMetabaseIframeLinkMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateMetabaseIframeLink>>, TError,{id: number;data?: UpdateMetabaseIframeLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateMetabaseIframeLink>>, TError,{id: number;data?: UpdateMetabaseIframeLinkCommandDto}, TContext> => {

const mutationKey = ['adminUpdateMetabaseIframeLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateMetabaseIframeLink>>, {id: number;data?: UpdateMetabaseIframeLinkCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateMetabaseIframeLink(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateMetabaseIframeLinkMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateMetabaseIframeLink>>>
    export type AdminUpdateMetabaseIframeLinkMutationBody = UpdateMetabaseIframeLinkCommandDto | undefined
    export type AdminUpdateMetabaseIframeLinkMutationError = ProblemDetails

    /**
 * @summary Update a Metabase iframe link item.
 */
export const useAdminUpdateMetabaseIframeLink = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateMetabaseIframeLink>>, TError,{id: number;data?: UpdateMetabaseIframeLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateMetabaseIframeLink>>,
        TError,
        {id: number;data?: UpdateMetabaseIframeLinkCommandDto},
        TContext
      > => {
      return useMutation(getAdminUpdateMetabaseIframeLinkMutationOptions(options), queryClient);
    }

export const getAdminUpdateIframeLinkUrl = (id: number,) => {




  return `/admin/link-items/iframe/${id}`
}

/**
 * @summary Update a plain iframe link item.
 */
export const adminUpdateIframeLink = async (id: number,
    updateIframeLinkCommandDto?: UpdateIframeLinkCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUpdateIframeLinkUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateIframeLinkCommandDto)
  }
);}





export const getAdminUpdateIframeLinkMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateIframeLink>>, TError,{id: number;data?: UpdateIframeLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateIframeLink>>, TError,{id: number;data?: UpdateIframeLinkCommandDto}, TContext> => {

const mutationKey = ['adminUpdateIframeLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateIframeLink>>, {id: number;data?: UpdateIframeLinkCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateIframeLink(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateIframeLinkMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateIframeLink>>>
    export type AdminUpdateIframeLinkMutationBody = UpdateIframeLinkCommandDto | undefined
    export type AdminUpdateIframeLinkMutationError = ProblemDetails

    /**
 * @summary Update a plain iframe link item.
 */
export const useAdminUpdateIframeLink = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateIframeLink>>, TError,{id: number;data?: UpdateIframeLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateIframeLink>>,
        TError,
        {id: number;data?: UpdateIframeLinkCommandDto},
        TContext
      > => {
      return useMutation(getAdminUpdateIframeLinkMutationOptions(options), queryClient);
    }

export const getAdminUpdateUriLinkUrl = (id: number,) => {




  return `/admin/link-items/uri/${id}`
}

/**
 * @summary Update an external uri link item.
 */
export const adminUpdateUriLink = async (id: number,
    updateUriLinkCommandDto?: UpdateUriLinkCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUpdateUriLinkUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateUriLinkCommandDto)
  }
);}





export const getAdminUpdateUriLinkMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateUriLink>>, TError,{id: number;data?: UpdateUriLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateUriLink>>, TError,{id: number;data?: UpdateUriLinkCommandDto}, TContext> => {

const mutationKey = ['adminUpdateUriLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateUriLink>>, {id: number;data?: UpdateUriLinkCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateUriLink(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateUriLinkMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateUriLink>>>
    export type AdminUpdateUriLinkMutationBody = UpdateUriLinkCommandDto | undefined
    export type AdminUpdateUriLinkMutationError = ProblemDetails

    /**
 * @summary Update an external uri link item.
 */
export const useAdminUpdateUriLink = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateUriLink>>, TError,{id: number;data?: UpdateUriLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateUriLink>>,
        TError,
        {id: number;data?: UpdateUriLinkCommandDto},
        TContext
      > => {
      return useMutation(getAdminUpdateUriLinkMutationOptions(options), queryClient);
    }

export const getAdminUpdateInternalLinkUrl = (id: number,) => {




  return `/admin/link-items/internal-link/${id}`
}

/**
 * @summary Update an internal link item.
 */
export const adminUpdateInternalLink = async (id: number,
    updateInternalLinkCommandDto?: UpdateInternalLinkCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUpdateInternalLinkUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateInternalLinkCommandDto)
  }
);}





export const getAdminUpdateInternalLinkMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateInternalLink>>, TError,{id: number;data?: UpdateInternalLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateInternalLink>>, TError,{id: number;data?: UpdateInternalLinkCommandDto}, TContext> => {

const mutationKey = ['adminUpdateInternalLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateInternalLink>>, {id: number;data?: UpdateInternalLinkCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateInternalLink(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateInternalLinkMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateInternalLink>>>
    export type AdminUpdateInternalLinkMutationBody = UpdateInternalLinkCommandDto | undefined
    export type AdminUpdateInternalLinkMutationError = ProblemDetails

    /**
 * @summary Update an internal link item.
 */
export const useAdminUpdateInternalLink = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateInternalLink>>, TError,{id: number;data?: UpdateInternalLinkCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateInternalLink>>,
        TError,
        {id: number;data?: UpdateInternalLinkCommandDto},
        TContext
      > => {
      return useMutation(getAdminUpdateInternalLinkMutationOptions(options), queryClient);
    }

export const getAdminPreviewSuggestedJobFunctionsUrl = () => {




  return `/admin/admin-job-function/suggestions/preview`
}

export const adminPreviewSuggestedJobFunctions = async (previewSuggestedJobFunctionsQueryDto?: PreviewSuggestedJobFunctionsQueryDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<PreviewSuggestedJobFunctionsResult> => {

  return fetchWithAuth<PreviewSuggestedJobFunctionsResult>(getAdminPreviewSuggestedJobFunctionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(previewSuggestedJobFunctionsQueryDto)
  }
);}





export const getAdminPreviewSuggestedJobFunctionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPreviewSuggestedJobFunctions>>, TError,{data?: PreviewSuggestedJobFunctionsQueryDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPreviewSuggestedJobFunctions>>, TError,{data?: PreviewSuggestedJobFunctionsQueryDto}, TContext> => {

const mutationKey = ['adminPreviewSuggestedJobFunctions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPreviewSuggestedJobFunctions>>, {data?: PreviewSuggestedJobFunctionsQueryDto}> = (props) => {
          const {data} = props ?? {};

          return  adminPreviewSuggestedJobFunctions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPreviewSuggestedJobFunctionsMutationResult = NonNullable<Awaited<ReturnType<typeof adminPreviewSuggestedJobFunctions>>>
    export type AdminPreviewSuggestedJobFunctionsMutationBody = PreviewSuggestedJobFunctionsQueryDto | undefined
    export type AdminPreviewSuggestedJobFunctionsMutationError = unknown

    export const useAdminPreviewSuggestedJobFunctions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPreviewSuggestedJobFunctions>>, TError,{data?: PreviewSuggestedJobFunctionsQueryDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminPreviewSuggestedJobFunctions>>,
        TError,
        {data?: PreviewSuggestedJobFunctionsQueryDto},
        TContext
      > => {
      return useMutation(getAdminPreviewSuggestedJobFunctionsMutationOptions(options), queryClient);
    }

export const getAdminListJobFunctionsUrl = (params?: AdminListJobFunctionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["jobCategoryIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-job-function?${stringifiedParams}` : `/admin/admin-job-function`
}

export const adminListJobFunctions = async (params?: AdminListJobFunctionsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminJobFunctionCrudListResult> => {

  return fetchWithAuth<AdminJobFunctionCrudListResult>(getAdminListJobFunctionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListJobFunctionsQueryKey = (params?: MaybeRefOrGetter<AdminListJobFunctionsParams>,) => {
    return [
    'admin','admin-job-function', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListJobFunctionsQueryOptions = <TData = Awaited<ReturnType<typeof adminListJobFunctions>>, TError = unknown>(params?: MaybeRefOrGetter<AdminListJobFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListJobFunctions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListJobFunctionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListJobFunctions>>> = ({ signal }) => adminListJobFunctions(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListJobFunctions>>, TError, TData>
}

export type AdminListJobFunctionsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListJobFunctions>>>
export type AdminListJobFunctionsQueryError = unknown



export function useAdminListJobFunctions<TData = Awaited<ReturnType<typeof adminListJobFunctions>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminListJobFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListJobFunctions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListJobFunctionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminCreateJobFunctionUrl = () => {




  return `/admin/admin-job-function`
}

export const adminCreateJobFunction = async (adminJobFunctionCrudCreateCommand?: AdminJobFunctionCrudCreateCommand, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminJobFunctionCrudJobFunctionDto> => {

  return fetchWithAuth<AdminJobFunctionCrudJobFunctionDto>(getAdminCreateJobFunctionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminJobFunctionCrudCreateCommand)
  }
);}





export const getAdminCreateJobFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateJobFunction>>, TError,{data?: AdminJobFunctionCrudCreateCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateJobFunction>>, TError,{data?: AdminJobFunctionCrudCreateCommand}, TContext> => {

const mutationKey = ['adminCreateJobFunction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateJobFunction>>, {data?: AdminJobFunctionCrudCreateCommand}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateJobFunction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateJobFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateJobFunction>>>
    export type AdminCreateJobFunctionMutationBody = AdminJobFunctionCrudCreateCommand | undefined
    export type AdminCreateJobFunctionMutationError = ProblemDetails

    export const useAdminCreateJobFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateJobFunction>>, TError,{data?: AdminJobFunctionCrudCreateCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateJobFunction>>,
        TError,
        {data?: AdminJobFunctionCrudCreateCommand},
        TContext
      > => {
      return useMutation(getAdminCreateJobFunctionMutationOptions(options), queryClient);
    }

export const getAdminUpdateJobFunctionUrl = () => {




  return `/admin/admin-job-function`
}

export const adminUpdateJobFunction = async (adminJobFunctionCrudUpdateCommand?: AdminJobFunctionCrudUpdateCommand, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUpdateJobFunctionUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminJobFunctionCrudUpdateCommand)
  }
);}





export const getAdminUpdateJobFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateJobFunction>>, TError,{data?: AdminJobFunctionCrudUpdateCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateJobFunction>>, TError,{data?: AdminJobFunctionCrudUpdateCommand}, TContext> => {

const mutationKey = ['adminUpdateJobFunction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateJobFunction>>, {data?: AdminJobFunctionCrudUpdateCommand}> = (props) => {
          const {data} = props ?? {};

          return  adminUpdateJobFunction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateJobFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateJobFunction>>>
    export type AdminUpdateJobFunctionMutationBody = AdminJobFunctionCrudUpdateCommand | undefined
    export type AdminUpdateJobFunctionMutationError = ProblemDetails

    export const useAdminUpdateJobFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateJobFunction>>, TError,{data?: AdminJobFunctionCrudUpdateCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateJobFunction>>,
        TError,
        {data?: AdminJobFunctionCrudUpdateCommand},
        TContext
      > => {
      return useMutation(getAdminUpdateJobFunctionMutationOptions(options), queryClient);
    }

export const getAdminRenameJobFunctionUrl = (id: number,) => {




  return `/admin/admin-job-function/${id}/rename`
}

export const adminRenameJobFunction = async (id: number,
    adminJobFunctionCrudRenameRequestBody?: AdminJobFunctionCrudRenameRequestBody, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminRenameJobFunctionUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminJobFunctionCrudRenameRequestBody)
  }
);}





export const getAdminRenameJobFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRenameJobFunction>>, TError,{id: number;data?: AdminJobFunctionCrudRenameRequestBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRenameJobFunction>>, TError,{id: number;data?: AdminJobFunctionCrudRenameRequestBody}, TContext> => {

const mutationKey = ['adminRenameJobFunction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRenameJobFunction>>, {id: number;data?: AdminJobFunctionCrudRenameRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  adminRenameJobFunction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRenameJobFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof adminRenameJobFunction>>>
    export type AdminRenameJobFunctionMutationBody = AdminJobFunctionCrudRenameRequestBody | undefined
    export type AdminRenameJobFunctionMutationError = ProblemDetails

    export const useAdminRenameJobFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRenameJobFunction>>, TError,{id: number;data?: AdminJobFunctionCrudRenameRequestBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminRenameJobFunction>>,
        TError,
        {id: number;data?: AdminJobFunctionCrudRenameRequestBody},
        TContext
      > => {
      return useMutation(getAdminRenameJobFunctionMutationOptions(options), queryClient);
    }

export const getAdminHideJobFunctionUrl = (id: number,) => {




  return `/admin/admin-job-function/${id}/hide`
}

export const adminHideJobFunction = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminHideJobFunctionUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getAdminHideJobFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminHideJobFunction>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminHideJobFunction>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminHideJobFunction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminHideJobFunction>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminHideJobFunction(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminHideJobFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof adminHideJobFunction>>>

    export type AdminHideJobFunctionMutationError = ProblemDetails

    export const useAdminHideJobFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminHideJobFunction>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminHideJobFunction>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminHideJobFunctionMutationOptions(options), queryClient);
    }

export const getAdminUnhideJobFunctionUrl = (id: number,) => {




  return `/admin/admin-job-function/${id}/unhide`
}

export const adminUnhideJobFunction = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAdminUnhideJobFunctionUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getAdminUnhideJobFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUnhideJobFunction>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUnhideJobFunction>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminUnhideJobFunction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUnhideJobFunction>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminUnhideJobFunction(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUnhideJobFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof adminUnhideJobFunction>>>

    export type AdminUnhideJobFunctionMutationError = ProblemDetails

    export const useAdminUnhideJobFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUnhideJobFunction>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUnhideJobFunction>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminUnhideJobFunctionMutationOptions(options), queryClient);
    }

export const getAdminPreviewJobFunctionMergeUrl = (id: number,
    params?: AdminPreviewJobFunctionMergeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-job-function/${id}/merge-preview?${stringifiedParams}` : `/admin/admin-job-function/${id}/merge-preview`
}

export const adminPreviewJobFunctionMerge = async (id: number,
    params?: AdminPreviewJobFunctionMergeParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<PreviewJobFunctionMergeResult> => {

  return fetchWithAuth<PreviewJobFunctionMergeResult>(getAdminPreviewJobFunctionMergeUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPreviewJobFunctionMergeQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<AdminPreviewJobFunctionMergeParams>,) => {
    return [
    'admin','admin-job-function',id,'merge-preview', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminPreviewJobFunctionMergeQueryOptions = <TData = Awaited<ReturnType<typeof adminPreviewJobFunctionMerge>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<AdminPreviewJobFunctionMergeParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPreviewJobFunctionMerge>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminPreviewJobFunctionMergeQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPreviewJobFunctionMerge>>> = ({ signal }) => adminPreviewJobFunctionMerge(toValue(id),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPreviewJobFunctionMerge>>, TError, TData>
}

export type AdminPreviewJobFunctionMergeQueryResult = NonNullable<Awaited<ReturnType<typeof adminPreviewJobFunctionMerge>>>
export type AdminPreviewJobFunctionMergeQueryError = ProblemDetails



export function useAdminPreviewJobFunctionMerge<TData = Awaited<ReturnType<typeof adminPreviewJobFunctionMerge>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<AdminPreviewJobFunctionMergeParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPreviewJobFunctionMerge>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPreviewJobFunctionMergeQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminMergeJobFunctionUrl = (id: number,) => {




  return `/admin/admin-job-function/${id}/merge`
}

export const adminMergeJobFunction = async (id: number,
    mergeJobFunctionsRequestBody?: MergeJobFunctionsRequestBody, options?: Parameters<typeof fetchWithAuth>[1]): Promise<MergeJobFunctionsResult> => {

  return fetchWithAuth<MergeJobFunctionsResult>(getAdminMergeJobFunctionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mergeJobFunctionsRequestBody)
  }
);}





export const getAdminMergeJobFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMergeJobFunction>>, TError,{id: number;data?: MergeJobFunctionsRequestBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMergeJobFunction>>, TError,{id: number;data?: MergeJobFunctionsRequestBody}, TContext> => {

const mutationKey = ['adminMergeJobFunction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMergeJobFunction>>, {id: number;data?: MergeJobFunctionsRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  adminMergeJobFunction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMergeJobFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof adminMergeJobFunction>>>
    export type AdminMergeJobFunctionMutationBody = MergeJobFunctionsRequestBody | undefined
    export type AdminMergeJobFunctionMutationError = ProblemDetails

    export const useAdminMergeJobFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMergeJobFunction>>, TError,{id: number;data?: MergeJobFunctionsRequestBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminMergeJobFunction>>,
        TError,
        {id: number;data?: MergeJobFunctionsRequestBody},
        TContext
      > => {
      return useMutation(getAdminMergeJobFunctionMutationOptions(options), queryClient);
    }

export const getAdminClassifyJobFunctionIscoUrl = (id: number,) => {




  return `/admin/admin-job-function/${id}/isco-classification`
}

export const adminClassifyJobFunctionIsco = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<JobFunctionIscoClassifierResult> => {

  return fetchWithAuth<JobFunctionIscoClassifierResult>(getAdminClassifyJobFunctionIscoUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminClassifyJobFunctionIscoQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','admin-job-function',id,'isco-classification'
    ] as const;
    }


export const getAdminClassifyJobFunctionIscoQueryOptions = <TData = Awaited<ReturnType<typeof adminClassifyJobFunctionIsco>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassifyJobFunctionIsco>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminClassifyJobFunctionIscoQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminClassifyJobFunctionIsco>>> = ({ signal }) => adminClassifyJobFunctionIsco(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminClassifyJobFunctionIsco>>, TError, TData>
}

export type AdminClassifyJobFunctionIscoQueryResult = NonNullable<Awaited<ReturnType<typeof adminClassifyJobFunctionIsco>>>
export type AdminClassifyJobFunctionIscoQueryError = ProblemDetails



export function useAdminClassifyJobFunctionIsco<TData = Awaited<ReturnType<typeof adminClassifyJobFunctionIsco>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassifyJobFunctionIsco>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminClassifyJobFunctionIscoQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminSetJobFunctionIscoGroupUrl = (id: number,) => {




  return `/admin/admin-job-function/${id}/isco-group`
}

export const adminSetJobFunctionIscoGroup = async (id: number,
    setJobFunctionIscoGroupCommandRequestBody?: SetJobFunctionIscoGroupCommandRequestBody, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SetJobFunctionIscoGroupCommandResult> => {

  return fetchWithAuth<SetJobFunctionIscoGroupCommandResult>(getAdminSetJobFunctionIscoGroupUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setJobFunctionIscoGroupCommandRequestBody)
  }
);}





export const getAdminSetJobFunctionIscoGroupMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetJobFunctionIscoGroup>>, TError,{id: number;data?: SetJobFunctionIscoGroupCommandRequestBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSetJobFunctionIscoGroup>>, TError,{id: number;data?: SetJobFunctionIscoGroupCommandRequestBody}, TContext> => {

const mutationKey = ['adminSetJobFunctionIscoGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSetJobFunctionIscoGroup>>, {id: number;data?: SetJobFunctionIscoGroupCommandRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  adminSetJobFunctionIscoGroup(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSetJobFunctionIscoGroupMutationResult = NonNullable<Awaited<ReturnType<typeof adminSetJobFunctionIscoGroup>>>
    export type AdminSetJobFunctionIscoGroupMutationBody = SetJobFunctionIscoGroupCommandRequestBody | undefined
    export type AdminSetJobFunctionIscoGroupMutationError = ProblemDetails

    export const useAdminSetJobFunctionIscoGroup = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetJobFunctionIscoGroup>>, TError,{id: number;data?: SetJobFunctionIscoGroupCommandRequestBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminSetJobFunctionIscoGroup>>,
        TError,
        {id: number;data?: SetJobFunctionIscoGroupCommandRequestBody},
        TContext
      > => {
      return useMutation(getAdminSetJobFunctionIscoGroupMutationOptions(options), queryClient);
    }

export const getAdminListJobFunctionCustomsUrl = (params?: AdminListJobFunctionCustomsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-job-function-custom?${stringifiedParams}` : `/admin/admin-job-function-custom`
}

export const adminListJobFunctionCustoms = async (params?: AdminListJobFunctionCustomsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminListJobFunctionCustomResult> => {

  return fetchWithAuth<AdminListJobFunctionCustomResult>(getAdminListJobFunctionCustomsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListJobFunctionCustomsQueryKey = (params?: MaybeRefOrGetter<AdminListJobFunctionCustomsParams>,) => {
    return [
    'admin','admin-job-function-custom', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListJobFunctionCustomsQueryOptions = <TData = Awaited<ReturnType<typeof adminListJobFunctionCustoms>>, TError = unknown>(params?: MaybeRefOrGetter<AdminListJobFunctionCustomsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListJobFunctionCustoms>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListJobFunctionCustomsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListJobFunctionCustoms>>> = ({ signal }) => adminListJobFunctionCustoms(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListJobFunctionCustoms>>, TError, TData>
}

export type AdminListJobFunctionCustomsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListJobFunctionCustoms>>>
export type AdminListJobFunctionCustomsQueryError = unknown



export function useAdminListJobFunctionCustoms<TData = Awaited<ReturnType<typeof adminListJobFunctionCustoms>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminListJobFunctionCustomsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListJobFunctionCustoms>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListJobFunctionCustomsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminPromoteJobFunctionCustomUrl = (id: number,) => {




  return `/admin/admin-job-function-custom/${id}/promote`
}

export const adminPromoteJobFunctionCustom = async (id: number,
    promoteCustomJobFunctionRequestBody?: PromoteCustomJobFunctionRequestBody, options?: Parameters<typeof fetchWithAuth>[1]): Promise<PromoteCustomJobFunctionResult> => {

  return fetchWithAuth<PromoteCustomJobFunctionResult>(getAdminPromoteJobFunctionCustomUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(promoteCustomJobFunctionRequestBody)
  }
);}





export const getAdminPromoteJobFunctionCustomMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPromoteJobFunctionCustom>>, TError,{id: number;data?: PromoteCustomJobFunctionRequestBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPromoteJobFunctionCustom>>, TError,{id: number;data?: PromoteCustomJobFunctionRequestBody}, TContext> => {

const mutationKey = ['adminPromoteJobFunctionCustom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPromoteJobFunctionCustom>>, {id: number;data?: PromoteCustomJobFunctionRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  adminPromoteJobFunctionCustom(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPromoteJobFunctionCustomMutationResult = NonNullable<Awaited<ReturnType<typeof adminPromoteJobFunctionCustom>>>
    export type AdminPromoteJobFunctionCustomMutationBody = PromoteCustomJobFunctionRequestBody | undefined
    export type AdminPromoteJobFunctionCustomMutationError = ProblemDetails

    export const useAdminPromoteJobFunctionCustom = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPromoteJobFunctionCustom>>, TError,{id: number;data?: PromoteCustomJobFunctionRequestBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminPromoteJobFunctionCustom>>,
        TError,
        {id: number;data?: PromoteCustomJobFunctionRequestBody},
        TContext
      > => {
      return useMutation(getAdminPromoteJobFunctionCustomMutationOptions(options), queryClient);
    }

export const getAdminClassifyJobFunctionCustomIscoUrl = (id: number,) => {




  return `/admin/admin-job-function-custom/${id}/isco-classification`
}

export const adminClassifyJobFunctionCustomIsco = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<JobFunctionIscoClassifierResult> => {

  return fetchWithAuth<JobFunctionIscoClassifierResult>(getAdminClassifyJobFunctionCustomIscoUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminClassifyJobFunctionCustomIscoQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','admin-job-function-custom',id,'isco-classification'
    ] as const;
    }


export const getAdminClassifyJobFunctionCustomIscoQueryOptions = <TData = Awaited<ReturnType<typeof adminClassifyJobFunctionCustomIsco>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassifyJobFunctionCustomIsco>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminClassifyJobFunctionCustomIscoQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminClassifyJobFunctionCustomIsco>>> = ({ signal }) => adminClassifyJobFunctionCustomIsco(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminClassifyJobFunctionCustomIsco>>, TError, TData>
}

export type AdminClassifyJobFunctionCustomIscoQueryResult = NonNullable<Awaited<ReturnType<typeof adminClassifyJobFunctionCustomIsco>>>
export type AdminClassifyJobFunctionCustomIscoQueryError = ProblemDetails



export function useAdminClassifyJobFunctionCustomIsco<TData = Awaited<ReturnType<typeof adminClassifyJobFunctionCustomIsco>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassifyJobFunctionCustomIsco>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminClassifyJobFunctionCustomIscoQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminSetJobFunctionCustomIscoGroupUrl = (id: number,) => {




  return `/admin/admin-job-function-custom/${id}/isco-group`
}

export const adminSetJobFunctionCustomIscoGroup = async (id: number,
    setCustomJobFunctionIscoGroupRequestBody?: SetCustomJobFunctionIscoGroupRequestBody, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SetCustomJobFunctionIscoGroupResult> => {

  return fetchWithAuth<SetCustomJobFunctionIscoGroupResult>(getAdminSetJobFunctionCustomIscoGroupUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setCustomJobFunctionIscoGroupRequestBody)
  }
);}





export const getAdminSetJobFunctionCustomIscoGroupMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetJobFunctionCustomIscoGroup>>, TError,{id: number;data?: SetCustomJobFunctionIscoGroupRequestBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSetJobFunctionCustomIscoGroup>>, TError,{id: number;data?: SetCustomJobFunctionIscoGroupRequestBody}, TContext> => {

const mutationKey = ['adminSetJobFunctionCustomIscoGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSetJobFunctionCustomIscoGroup>>, {id: number;data?: SetCustomJobFunctionIscoGroupRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  adminSetJobFunctionCustomIscoGroup(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSetJobFunctionCustomIscoGroupMutationResult = NonNullable<Awaited<ReturnType<typeof adminSetJobFunctionCustomIscoGroup>>>
    export type AdminSetJobFunctionCustomIscoGroupMutationBody = SetCustomJobFunctionIscoGroupRequestBody | undefined
    export type AdminSetJobFunctionCustomIscoGroupMutationError = ProblemDetails

    export const useAdminSetJobFunctionCustomIscoGroup = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetJobFunctionCustomIscoGroup>>, TError,{id: number;data?: SetCustomJobFunctionIscoGroupRequestBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminSetJobFunctionCustomIscoGroup>>,
        TError,
        {id: number;data?: SetCustomJobFunctionIscoGroupRequestBody},
        TContext
      > => {
      return useMutation(getAdminSetJobFunctionCustomIscoGroupMutationOptions(options), queryClient);
    }

export const getAdminRejectJobFunctionCustomUrl = (id: number,) => {




  return `/admin/admin-job-function-custom/${id}/reject`
}

export const adminRejectJobFunctionCustom = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<RejectCustomJobFunctionResult> => {

  return fetchWithAuth<RejectCustomJobFunctionResult>(getAdminRejectJobFunctionCustomUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminRejectJobFunctionCustomMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRejectJobFunctionCustom>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRejectJobFunctionCustom>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminRejectJobFunctionCustom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRejectJobFunctionCustom>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminRejectJobFunctionCustom(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRejectJobFunctionCustomMutationResult = NonNullable<Awaited<ReturnType<typeof adminRejectJobFunctionCustom>>>

    export type AdminRejectJobFunctionCustomMutationError = ProblemDetails

    export const useAdminRejectJobFunctionCustom = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRejectJobFunctionCustom>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminRejectJobFunctionCustom>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminRejectJobFunctionCustomMutationOptions(options), queryClient);
    }

export const getAdminUnrejectJobFunctionCustomUrl = (id: number,) => {




  return `/admin/admin-job-function-custom/${id}/unreject`
}

export const adminUnrejectJobFunctionCustom = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<UnrejectCustomJobFunctionResult> => {

  return fetchWithAuth<UnrejectCustomJobFunctionResult>(getAdminUnrejectJobFunctionCustomUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminUnrejectJobFunctionCustomMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUnrejectJobFunctionCustom>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUnrejectJobFunctionCustom>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminUnrejectJobFunctionCustom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUnrejectJobFunctionCustom>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminUnrejectJobFunctionCustom(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUnrejectJobFunctionCustomMutationResult = NonNullable<Awaited<ReturnType<typeof adminUnrejectJobFunctionCustom>>>

    export type AdminUnrejectJobFunctionCustomMutationError = ProblemDetails

    export const useAdminUnrejectJobFunctionCustom = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUnrejectJobFunctionCustom>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUnrejectJobFunctionCustom>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminUnrejectJobFunctionCustomMutationOptions(options), queryClient);
    }

export const getAdminListIscoGroupsUrl = () => {




  return `/admin/admin-isco-group`
}

export const adminListIscoGroups = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminIscoGroupCrudListResult> => {

  return fetchWithAuth<AdminIscoGroupCrudListResult>(getAdminListIscoGroupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListIscoGroupsQueryKey = () => {
    return [
    'admin','admin-isco-group'
    ] as const;
    }


export const getAdminListIscoGroupsQueryOptions = <TData = Awaited<ReturnType<typeof adminListIscoGroups>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIscoGroups>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListIscoGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListIscoGroups>>> = ({ signal }) => adminListIscoGroups({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListIscoGroups>>, TError, TData>
}

export type AdminListIscoGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListIscoGroups>>>
export type AdminListIscoGroupsQueryError = unknown



export function useAdminListIscoGroups<TData = Awaited<ReturnType<typeof adminListIscoGroups>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIscoGroups>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListIscoGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminListIscoGroupJobsUrl = (params?: AdminListIscoGroupJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-isco-group/jobs?${stringifiedParams}` : `/admin/admin-isco-group/jobs`
}

export const adminListIscoGroupJobs = async (params?: AdminListIscoGroupJobsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminListJobsByFunctionResult> => {

  return fetchWithAuth<AdminListJobsByFunctionResult>(getAdminListIscoGroupJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListIscoGroupJobsQueryKey = (params?: MaybeRefOrGetter<AdminListIscoGroupJobsParams>,) => {
    return [
    'admin','admin-isco-group','jobs', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListIscoGroupJobsQueryOptions = <TData = Awaited<ReturnType<typeof adminListIscoGroupJobs>>, TError = void>(params?: MaybeRefOrGetter<AdminListIscoGroupJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIscoGroupJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListIscoGroupJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListIscoGroupJobs>>> = ({ signal }) => adminListIscoGroupJobs(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListIscoGroupJobs>>, TError, TData>
}

export type AdminListIscoGroupJobsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListIscoGroupJobs>>>
export type AdminListIscoGroupJobsQueryError = void



export function useAdminListIscoGroupJobs<TData = Awaited<ReturnType<typeof adminListIscoGroupJobs>>, TError = void>(
 params?: MaybeRefOrGetter<AdminListIscoGroupJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIscoGroupJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListIscoGroupJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminSetIscoUnitGroupIdealUrl = (code: string,) => {




  return `/admin/admin-isco-group/${code}/ideal`
}

export const adminSetIscoUnitGroupIdeal = async (code: string,
    setIscoUnitGroupIdealCommandDto?: SetIscoUnitGroupIdealCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SetIscoUnitGroupIdealResult> => {

  return fetchWithAuth<SetIscoUnitGroupIdealResult>(getAdminSetIscoUnitGroupIdealUrl(code),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setIscoUnitGroupIdealCommandDto)
  }
);}





export const getAdminSetIscoUnitGroupIdealMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetIscoUnitGroupIdeal>>, TError,{code: string;data?: SetIscoUnitGroupIdealCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSetIscoUnitGroupIdeal>>, TError,{code: string;data?: SetIscoUnitGroupIdealCommandDto}, TContext> => {

const mutationKey = ['adminSetIscoUnitGroupIdeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSetIscoUnitGroupIdeal>>, {code: string;data?: SetIscoUnitGroupIdealCommandDto}> = (props) => {
          const {code,data} = props ?? {};

          return  adminSetIscoUnitGroupIdeal(code,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSetIscoUnitGroupIdealMutationResult = NonNullable<Awaited<ReturnType<typeof adminSetIscoUnitGroupIdeal>>>
    export type AdminSetIscoUnitGroupIdealMutationBody = SetIscoUnitGroupIdealCommandDto | undefined
    export type AdminSetIscoUnitGroupIdealMutationError = ProblemDetails

    export const useAdminSetIscoUnitGroupIdeal = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetIscoUnitGroupIdeal>>, TError,{code: string;data?: SetIscoUnitGroupIdealCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminSetIscoUnitGroupIdeal>>,
        TError,
        {code: string;data?: SetIscoUnitGroupIdealCommandDto},
        TContext
      > => {
      return useMutation(getAdminSetIscoUnitGroupIdealMutationOptions(options), queryClient);
    }

export const getListAdminAtsJobsUrl = (connectionId: number,
    params?: ListAdminAtsJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-integration-connection/ats-jobs/${connectionId}?${stringifiedParams}` : `/admin/admin-integration-connection/ats-jobs/${connectionId}`
}

/**
 * @summary List all ATS jobs for a specific integration connection (admin, no company filter)
 */
export const listAdminAtsJobs = async (connectionId: number,
    params?: ListAdminAtsJobsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAtsJobsResult> => {

  return fetchWithAuth<ListAtsJobsResult>(getListAdminAtsJobsUrl(connectionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminAtsJobsQueryKey = (connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAdminAtsJobsParams>,) => {
    return [
    'admin','admin-integration-connection','ats-jobs',connectionId, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminAtsJobsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminAtsJobs>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAdminAtsJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminAtsJobsQueryKey(connectionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAtsJobs>>> = ({ signal }) => listAdminAtsJobs(toValue(connectionId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminAtsJobs>>, TError, TData>
}

export type ListAdminAtsJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminAtsJobs>>>
export type ListAdminAtsJobsQueryError = ProblemDetails


/**
 * @summary List all ATS jobs for a specific integration connection (admin, no company filter)
 */

export function useListAdminAtsJobs<TData = Awaited<ReturnType<typeof listAdminAtsJobs>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAdminAtsJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminAtsJobsQueryOptions(connectionId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminAtsJobUrl = (connectionId: number,
    externalJobId: string,
    params?: GetAdminAtsJobParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-integration-connection/${connectionId}/ats-jobs/${externalJobId}?${stringifiedParams}` : `/admin/admin-integration-connection/${connectionId}/ats-jobs/${externalJobId}`
}

/**
 * @summary Fetch the details of a single ATS job directly from the ATS (admin, no company filter)
 */
export const getAdminAtsJob = async (connectionId: number,
    externalJobId: string,
    params?: GetAdminAtsJobParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAtsJobResult> => {

  return fetchWithAuth<GetAtsJobResult>(getGetAdminAtsJobUrl(connectionId,externalJobId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAtsJobQueryKey = (connectionId: MaybeRefOrGetter<number>,
    externalJobId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAdminAtsJobParams>,) => {
    return [
    'admin','admin-integration-connection',connectionId,'ats-jobs',externalJobId, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminAtsJobQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAtsJob>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>,
    externalJobId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAdminAtsJobParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAtsJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminAtsJobQueryKey(connectionId,externalJobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAtsJob>>> = ({ signal }) => getAdminAtsJob(toValue(connectionId),toValue(externalJobId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined && toValue(externalJobId) !== null && toValue(externalJobId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAtsJob>>, TError, TData>
}

export type GetAdminAtsJobQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAtsJob>>>
export type GetAdminAtsJobQueryError = ProblemDetails


/**
 * @summary Fetch the details of a single ATS job directly from the ATS (admin, no company filter)
 */

export function useGetAdminAtsJob<TData = Awaited<ReturnType<typeof getAdminAtsJob>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>,
    externalJobId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAdminAtsJobParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAtsJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAtsJobQueryOptions(connectionId,externalJobId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getMapAdminJobWithAtsJobUrl = () => {




  return `/admin/admin-integration-connection/map-job`
}

/**
 * @summary Map a job to an ATS job (admin, looks up CompanyId from the job itself)
 */
export const mapAdminJobWithAtsJob = async (mapAdminJobWithAtsJobCommandDto?: MapAdminJobWithAtsJobCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getMapAdminJobWithAtsJobUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mapAdminJobWithAtsJobCommandDto)
  }
);}





export const getMapAdminJobWithAtsJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapAdminJobWithAtsJob>>, TError,{data?: MapAdminJobWithAtsJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof mapAdminJobWithAtsJob>>, TError,{data?: MapAdminJobWithAtsJobCommandDto}, TContext> => {

const mutationKey = ['mapAdminJobWithAtsJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mapAdminJobWithAtsJob>>, {data?: MapAdminJobWithAtsJobCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  mapAdminJobWithAtsJob(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MapAdminJobWithAtsJobMutationResult = NonNullable<Awaited<ReturnType<typeof mapAdminJobWithAtsJob>>>
    export type MapAdminJobWithAtsJobMutationBody = MapAdminJobWithAtsJobCommandDto | undefined
    export type MapAdminJobWithAtsJobMutationError = ProblemDetails

    /**
 * @summary Map a job to an ATS job (admin, looks up CompanyId from the job itself)
 */
export const useMapAdminJobWithAtsJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapAdminJobWithAtsJob>>, TError,{data?: MapAdminJobWithAtsJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof mapAdminJobWithAtsJob>>,
        TError,
        {data?: MapAdminJobWithAtsJobCommandDto},
        TContext
      > => {
      return useMutation(getMapAdminJobWithAtsJobMutationOptions(options), queryClient);
    }

export const getListCompanyIntegrationConnectionsFromAdminUrl = (companyId: number,) => {




  return `/admin/admin-integration-connection/company/${companyId}`
}

/**
 * @summary List all integration connections of a company, including inheritance info
and the eligible sub-companies a connection can still be copied to.
 */
export const listCompanyIntegrationConnectionsFromAdmin = async (companyId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCompanyIntegrationConnectionsFromAdminResult> => {

  return fetchWithAuth<ListCompanyIntegrationConnectionsFromAdminResult>(getListCompanyIntegrationConnectionsFromAdminUrl(companyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCompanyIntegrationConnectionsFromAdminQueryKey = (companyId: MaybeRefOrGetter<number>,) => {
    return [
    'admin','admin-integration-connection','company',companyId
    ] as const;
    }


export const getListCompanyIntegrationConnectionsFromAdminQueryOptions = <TData = Awaited<ReturnType<typeof listCompanyIntegrationConnectionsFromAdmin>>, TError = ProblemDetails>(companyId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyIntegrationConnectionsFromAdmin>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListCompanyIntegrationConnectionsFromAdminQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanyIntegrationConnectionsFromAdmin>>> = ({ signal }) => listCompanyIntegrationConnectionsFromAdmin(toValue(companyId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompanyIntegrationConnectionsFromAdmin>>, TError, TData>
}

export type ListCompanyIntegrationConnectionsFromAdminQueryResult = NonNullable<Awaited<ReturnType<typeof listCompanyIntegrationConnectionsFromAdmin>>>
export type ListCompanyIntegrationConnectionsFromAdminQueryError = ProblemDetails


/**
 * @summary List all integration connections of a company, including inheritance info
and the eligible sub-companies a connection can still be copied to.
 */

export function useListCompanyIntegrationConnectionsFromAdmin<TData = Awaited<ReturnType<typeof listCompanyIntegrationConnectionsFromAdmin>>, TError = ProblemDetails>(
 companyId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyIntegrationConnectionsFromAdmin>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCompanyIntegrationConnectionsFromAdminQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getCopyIntegrationConnectionToSubCompanyUrl = (connectionId: number,) => {




  return `/admin/admin-integration-connection/${connectionId}/copy-to-sub-company`
}

/**
 * @summary Copy an existing integration connection to a sub-company of the source connection's company.
The copy is marked as inherited so any future re-authentication on the source connection
propagates Secrets/Config/IsVerified to this copy automatically.
 */
export const copyIntegrationConnectionToSubCompany = async (connectionId: number,
    adminIntegrationConnectionControllerCopyToSubCompanyDto?: AdminIntegrationConnectionControllerCopyToSubCompanyDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<IntegrationConnectionDto> => {

  return fetchWithAuth<IntegrationConnectionDto>(getCopyIntegrationConnectionToSubCompanyUrl(connectionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminIntegrationConnectionControllerCopyToSubCompanyDto)
  }
);}





export const getCopyIntegrationConnectionToSubCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyIntegrationConnectionToSubCompany>>, TError,{connectionId: number;data?: AdminIntegrationConnectionControllerCopyToSubCompanyDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof copyIntegrationConnectionToSubCompany>>, TError,{connectionId: number;data?: AdminIntegrationConnectionControllerCopyToSubCompanyDto}, TContext> => {

const mutationKey = ['copyIntegrationConnectionToSubCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyIntegrationConnectionToSubCompany>>, {connectionId: number;data?: AdminIntegrationConnectionControllerCopyToSubCompanyDto}> = (props) => {
          const {connectionId,data} = props ?? {};

          return  copyIntegrationConnectionToSubCompany(connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyIntegrationConnectionToSubCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof copyIntegrationConnectionToSubCompany>>>
    export type CopyIntegrationConnectionToSubCompanyMutationBody = AdminIntegrationConnectionControllerCopyToSubCompanyDto | undefined
    export type CopyIntegrationConnectionToSubCompanyMutationError = ProblemDetails

    /**
 * @summary Copy an existing integration connection to a sub-company of the source connection's company.
The copy is marked as inherited so any future re-authentication on the source connection
propagates Secrets/Config/IsVerified to this copy automatically.
 */
export const useCopyIntegrationConnectionToSubCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyIntegrationConnectionToSubCompany>>, TError,{connectionId: number;data?: AdminIntegrationConnectionControllerCopyToSubCompanyDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof copyIntegrationConnectionToSubCompany>>,
        TError,
        {connectionId: number;data?: AdminIntegrationConnectionControllerCopyToSubCompanyDto},
        TContext
      > => {
      return useMutation(getCopyIntegrationConnectionToSubCompanyMutationOptions(options), queryClient);
    }

export const getResendAtsJobApplicationsUrl = (connectionId: number,) => {




  return `/admin/admin-integration-connection/${connectionId}/resend-open-candidates`
}

/**
 * @summary Re-send all open and errored candidates of an ATS integration connection back to the ATS.
 */
export const resendAtsJobApplications = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ResendAtsJobApplicationsResult> => {

  return fetchWithAuth<ResendAtsJobApplicationsResult>(getResendAtsJobApplicationsUrl(connectionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResendAtsJobApplicationsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAtsJobApplications>>, TError,{connectionId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof resendAtsJobApplications>>, TError,{connectionId: number}, TContext> => {

const mutationKey = ['resendAtsJobApplications'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendAtsJobApplications>>, {connectionId: number}> = (props) => {
          const {connectionId} = props ?? {};

          return  resendAtsJobApplications(connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendAtsJobApplicationsMutationResult = NonNullable<Awaited<ReturnType<typeof resendAtsJobApplications>>>

    export type ResendAtsJobApplicationsMutationError = ProblemDetails

    /**
 * @summary Re-send all open and errored candidates of an ATS integration connection back to the ATS.
 */
export const useResendAtsJobApplications = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAtsJobApplications>>, TError,{connectionId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resendAtsJobApplications>>,
        TError,
        {connectionId: number},
        TContext
      > => {
      return useMutation(getResendAtsJobApplicationsMutationOptions(options), queryClient);
    }

export const getGetAdminAtsIntegrationConnectionDetailUrl = (connectionId: number,) => {




  return `/admin/admin-integration-connection/${connectionId}/detail`
}

/**
 * @summary Full detail of a single ATS integration connection for the admin drill-down page: connection
meta, its configured send-as employer / default message, and every job mapping.
 */
export const getAdminAtsIntegrationConnectionDetail = async (connectionId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminAtsIntegrationConnectionDetailResult> => {

  return fetchWithAuth<GetAdminAtsIntegrationConnectionDetailResult>(getGetAdminAtsIntegrationConnectionDetailUrl(connectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAtsIntegrationConnectionDetailQueryKey = (connectionId: MaybeRefOrGetter<number>,) => {
    return [
    'admin','admin-integration-connection',connectionId,'detail'
    ] as const;
    }


export const getGetAdminAtsIntegrationConnectionDetailQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAtsIntegrationConnectionDetail>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAtsIntegrationConnectionDetail>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminAtsIntegrationConnectionDetailQueryKey(connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAtsIntegrationConnectionDetail>>> = ({ signal }) => getAdminAtsIntegrationConnectionDetail(toValue(connectionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAtsIntegrationConnectionDetail>>, TError, TData>
}

export type GetAdminAtsIntegrationConnectionDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAtsIntegrationConnectionDetail>>>
export type GetAdminAtsIntegrationConnectionDetailQueryError = ProblemDetails


/**
 * @summary Full detail of a single ATS integration connection for the admin drill-down page: connection
meta, its configured send-as employer / default message, and every job mapping.
 */

export function useGetAdminAtsIntegrationConnectionDetail<TData = Awaited<ReturnType<typeof getAdminAtsIntegrationConnectionDetail>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAtsIntegrationConnectionDetail>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAtsIntegrationConnectionDetailQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAtsJobApplicationsForConnectionUrl = (connectionId: number,
    params?: ListAtsJobApplicationsForConnectionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["statuses"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-integration-connection/${connectionId}/job-applications?${stringifiedParams}` : `/admin/admin-integration-connection/${connectionId}/job-applications`
}

/**
 * @summary Paged overview of every candidate sent to the ATS for one integration connection.
 */
export const listAtsJobApplicationsForConnection = async (connectionId: number,
    params?: ListAtsJobApplicationsForConnectionParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAtsJobApplicationsForConnectionResult> => {

  return fetchWithAuth<ListAtsJobApplicationsForConnectionResult>(getListAtsJobApplicationsForConnectionUrl(connectionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAtsJobApplicationsForConnectionQueryKey = (connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAtsJobApplicationsForConnectionParams>,) => {
    return [
    'admin','admin-integration-connection',connectionId,'job-applications', ...(params ? [params] : [])
    ] as const;
    }


export const getListAtsJobApplicationsForConnectionQueryOptions = <TData = Awaited<ReturnType<typeof listAtsJobApplicationsForConnection>>, TError = ProblemDetails>(connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAtsJobApplicationsForConnectionParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsJobApplicationsForConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAtsJobApplicationsForConnectionQueryKey(connectionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAtsJobApplicationsForConnection>>> = ({ signal }) => listAtsJobApplicationsForConnection(toValue(connectionId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(connectionId) !== null && toValue(connectionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAtsJobApplicationsForConnection>>, TError, TData>
}

export type ListAtsJobApplicationsForConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof listAtsJobApplicationsForConnection>>>
export type ListAtsJobApplicationsForConnectionQueryError = ProblemDetails


/**
 * @summary Paged overview of every candidate sent to the ATS for one integration connection.
 */

export function useListAtsJobApplicationsForConnection<TData = Awaited<ReturnType<typeof listAtsJobApplicationsForConnection>>, TError = ProblemDetails>(
 connectionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAtsJobApplicationsForConnectionParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsJobApplicationsForConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAtsJobApplicationsForConnectionQueryOptions(connectionId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getResendSingleAtsJobApplicationUrl = (connectionId: number,
    jobApplicationId: number,) => {




  return `/admin/admin-integration-connection/${connectionId}/job-applications/${jobApplicationId}/resend`
}

/**
 * @summary Re-send a single candidate (ATS job application) back to the ATS.
 */
export const resendSingleAtsJobApplication = async (connectionId: number,
    jobApplicationId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ResendAtsJobApplicationResult> => {

  return fetchWithAuth<ResendAtsJobApplicationResult>(getResendSingleAtsJobApplicationUrl(connectionId,jobApplicationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResendSingleAtsJobApplicationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendSingleAtsJobApplication>>, TError,{connectionId: number;jobApplicationId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof resendSingleAtsJobApplication>>, TError,{connectionId: number;jobApplicationId: number}, TContext> => {

const mutationKey = ['resendSingleAtsJobApplication'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendSingleAtsJobApplication>>, {connectionId: number;jobApplicationId: number}> = (props) => {
          const {connectionId,jobApplicationId} = props ?? {};

          return  resendSingleAtsJobApplication(connectionId,jobApplicationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendSingleAtsJobApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof resendSingleAtsJobApplication>>>

    export type ResendSingleAtsJobApplicationMutationError = ProblemDetails

    /**
 * @summary Re-send a single candidate (ATS job application) back to the ATS.
 */
export const useResendSingleAtsJobApplication = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendSingleAtsJobApplication>>, TError,{connectionId: number;jobApplicationId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resendSingleAtsJobApplication>>,
        TError,
        {connectionId: number;jobApplicationId: number},
        TContext
      > => {
      return useMutation(getResendSingleAtsJobApplicationMutationOptions(options), queryClient);
    }

export const getInvalidateCompanyStatisticsCacheUrl = (companyId: number,
    params?: InvalidateCompanyStatisticsCacheParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/cache/company-statistics/${companyId}?${stringifiedParams}` : `/admin/cache/company-statistics/${companyId}`
}

/**
 * @summary Invalidates the cached company statistics for the given range so the next request recomputes them.
 */
export const invalidateCompanyStatisticsCache = async (companyId: number,
    params?: InvalidateCompanyStatisticsCacheParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getInvalidateCompanyStatisticsCacheUrl(companyId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getInvalidateCompanyStatisticsCacheMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invalidateCompanyStatisticsCache>>, TError,{companyId: number;params?: InvalidateCompanyStatisticsCacheParams}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof invalidateCompanyStatisticsCache>>, TError,{companyId: number;params?: InvalidateCompanyStatisticsCacheParams}, TContext> => {

const mutationKey = ['invalidateCompanyStatisticsCache'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invalidateCompanyStatisticsCache>>, {companyId: number;params?: InvalidateCompanyStatisticsCacheParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  invalidateCompanyStatisticsCache(companyId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InvalidateCompanyStatisticsCacheMutationResult = NonNullable<Awaited<ReturnType<typeof invalidateCompanyStatisticsCache>>>

    export type InvalidateCompanyStatisticsCacheMutationError = unknown

    /**
 * @summary Invalidates the cached company statistics for the given range so the next request recomputes them.
 */
export const useInvalidateCompanyStatisticsCache = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invalidateCompanyStatisticsCache>>, TError,{companyId: number;params?: InvalidateCompanyStatisticsCacheParams}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof invalidateCompanyStatisticsCache>>,
        TError,
        {companyId: number;params?: InvalidateCompanyStatisticsCacheParams},
        TContext
      > => {
      return useMutation(getInvalidateCompanyStatisticsCacheMutationOptions(options), queryClient);
    }

export const getInvalidateMatchingSimulationStatisticsCacheUrl = (simulationId: number,
    params?: InvalidateMatchingSimulationStatisticsCacheParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["userSegmentIds","jobSegmentIds","companySegmentIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/cache/simulation-statistics/${simulationId}?${stringifiedParams}` : `/admin/cache/simulation-statistics/${simulationId}`
}

/**
 * @summary Invalidates the cached matching simulation statistics for the given filter combination so the next request recomputes them.
 */
export const invalidateMatchingSimulationStatisticsCache = async (simulationId: number,
    params?: InvalidateMatchingSimulationStatisticsCacheParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getInvalidateMatchingSimulationStatisticsCacheUrl(simulationId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getInvalidateMatchingSimulationStatisticsCacheMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invalidateMatchingSimulationStatisticsCache>>, TError,{simulationId: number;params?: InvalidateMatchingSimulationStatisticsCacheParams}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof invalidateMatchingSimulationStatisticsCache>>, TError,{simulationId: number;params?: InvalidateMatchingSimulationStatisticsCacheParams}, TContext> => {

const mutationKey = ['invalidateMatchingSimulationStatisticsCache'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invalidateMatchingSimulationStatisticsCache>>, {simulationId: number;params?: InvalidateMatchingSimulationStatisticsCacheParams}> = (props) => {
          const {simulationId,params} = props ?? {};

          return  invalidateMatchingSimulationStatisticsCache(simulationId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InvalidateMatchingSimulationStatisticsCacheMutationResult = NonNullable<Awaited<ReturnType<typeof invalidateMatchingSimulationStatisticsCache>>>

    export type InvalidateMatchingSimulationStatisticsCacheMutationError = unknown

    /**
 * @summary Invalidates the cached matching simulation statistics for the given filter combination so the next request recomputes them.
 */
export const useInvalidateMatchingSimulationStatisticsCache = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invalidateMatchingSimulationStatisticsCache>>, TError,{simulationId: number;params?: InvalidateMatchingSimulationStatisticsCacheParams}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof invalidateMatchingSimulationStatisticsCache>>,
        TError,
        {simulationId: number;params?: InvalidateMatchingSimulationStatisticsCacheParams},
        TContext
      > => {
      return useMutation(getInvalidateMatchingSimulationStatisticsCacheMutationOptions(options), queryClient);
    }

export const getExportCompanyJobsUrl = () => {




  return `/admin/admin-exports/company-jobs`
}

/**
 * @summary Export the job overview for a company to xlsx or csv.
 */
export const exportCompanyJobs = async (exportCompanyJobsQuery?: ExportCompanyJobsQuery, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Blob> => {

  return fetchWithAuth<Blob>(getExportCompanyJobsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(exportCompanyJobsQuery)
  }
);}





export const getExportCompanyJobsMutationOptions = <TError = Blob,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportCompanyJobs>>, TError,{data?: ExportCompanyJobsQuery}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof exportCompanyJobs>>, TError,{data?: ExportCompanyJobsQuery}, TContext> => {

const mutationKey = ['exportCompanyJobs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportCompanyJobs>>, {data?: ExportCompanyJobsQuery}> = (props) => {
          const {data} = props ?? {};

          return  exportCompanyJobs(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExportCompanyJobsMutationResult = NonNullable<Awaited<ReturnType<typeof exportCompanyJobs>>>
    export type ExportCompanyJobsMutationBody = ExportCompanyJobsQuery | undefined
    export type ExportCompanyJobsMutationError = Blob

    /**
 * @summary Export the job overview for a company to xlsx or csv.
 */
export const useExportCompanyJobs = <TError = Blob,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportCompanyJobs>>, TError,{data?: ExportCompanyJobsQuery}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof exportCompanyJobs>>,
        TError,
        {data?: ExportCompanyJobsQuery},
        TContext
      > => {
      return useMutation(getExportCompanyJobsMutationOptions(options), queryClient);
    }

export const getListAdminEmployersUrl = (params?: ListAdminEmployersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["accountTypes","inviteTypes"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-employer/employers?${stringifiedParams}` : `/admin/admin-employer/employers`
}

export const listAdminEmployers = async (params?: ListAdminEmployersParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminEmployersResult> => {

  return fetchWithAuth<ListAdminEmployersResult>(getListAdminEmployersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminEmployersQueryKey = (params?: MaybeRefOrGetter<ListAdminEmployersParams>,) => {
    return [
    'admin','admin-employer','employers', ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminEmployersQueryOptions = <TData = Awaited<ReturnType<typeof listAdminEmployers>>, TError = unknown>(params?: MaybeRefOrGetter<ListAdminEmployersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminEmployers>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminEmployersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminEmployers>>> = ({ signal }) => listAdminEmployers(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminEmployers>>, TError, TData>
}

export type ListAdminEmployersQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminEmployers>>>
export type ListAdminEmployersQueryError = unknown



export function useListAdminEmployers<TData = Awaited<ReturnType<typeof listAdminEmployers>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListAdminEmployersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminEmployers>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminEmployersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getCreateAdminInternalInviteUrl = () => {




  return `/admin/admin-employer/invite/internal`
}

export const createAdminInternalInvite = async (createEmployerInviteCommandDto?: CreateEmployerInviteCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getCreateAdminInternalInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createEmployerInviteCommandDto)
  }
);}





export const getCreateAdminInternalInviteMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminInternalInvite>>, TError,{data?: CreateEmployerInviteCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminInternalInvite>>, TError,{data?: CreateEmployerInviteCommandDto}, TContext> => {

const mutationKey = ['createAdminInternalInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminInternalInvite>>, {data?: CreateEmployerInviteCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  createAdminInternalInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminInternalInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminInternalInvite>>>
    export type CreateAdminInternalInviteMutationBody = CreateEmployerInviteCommandDto | undefined
    export type CreateAdminInternalInviteMutationError = ProblemDetails

    export const useCreateAdminInternalInvite = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminInternalInvite>>, TError,{data?: CreateEmployerInviteCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAdminInternalInvite>>,
        TError,
        {data?: CreateEmployerInviteCommandDto},
        TContext
      > => {
      return useMutation(getCreateAdminInternalInviteMutationOptions(options), queryClient);
    }

export const getCreateAdminTeammateInviteUrl = () => {




  return `/admin/admin-employer/invite/teammate`
}

export const createAdminTeammateInvite = async (createTeammateInviteCommandDto?: CreateTeammateInviteCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getCreateAdminTeammateInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTeammateInviteCommandDto)
  }
);}





export const getCreateAdminTeammateInviteMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminTeammateInvite>>, TError,{data?: CreateTeammateInviteCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminTeammateInvite>>, TError,{data?: CreateTeammateInviteCommandDto}, TContext> => {

const mutationKey = ['createAdminTeammateInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminTeammateInvite>>, {data?: CreateTeammateInviteCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  createAdminTeammateInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminTeammateInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminTeammateInvite>>>
    export type CreateAdminTeammateInviteMutationBody = CreateTeammateInviteCommandDto | undefined
    export type CreateAdminTeammateInviteMutationError = ProblemDetails

    export const useCreateAdminTeammateInvite = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminTeammateInvite>>, TError,{data?: CreateTeammateInviteCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAdminTeammateInvite>>,
        TError,
        {data?: CreateTeammateInviteCommandDto},
        TContext
      > => {
      return useMutation(getCreateAdminTeammateInviteMutationOptions(options), queryClient);
    }

export const getResendAdminEmployerInviteUrl = (inviteId: number,) => {




  return `/admin/admin-employer/invite/${inviteId}/resend`
}

export const resendAdminEmployerInvite = async (inviteId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getResendAdminEmployerInviteUrl(inviteId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResendAdminEmployerInviteMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAdminEmployerInvite>>, TError,{inviteId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof resendAdminEmployerInvite>>, TError,{inviteId: number}, TContext> => {

const mutationKey = ['resendAdminEmployerInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendAdminEmployerInvite>>, {inviteId: number}> = (props) => {
          const {inviteId} = props ?? {};

          return  resendAdminEmployerInvite(inviteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendAdminEmployerInviteMutationResult = NonNullable<Awaited<ReturnType<typeof resendAdminEmployerInvite>>>

    export type ResendAdminEmployerInviteMutationError = ProblemDetails

    export const useResendAdminEmployerInvite = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAdminEmployerInvite>>, TError,{inviteId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resendAdminEmployerInvite>>,
        TError,
        {inviteId: number},
        TContext
      > => {
      return useMutation(getResendAdminEmployerInviteMutationOptions(options), queryClient);
    }

export const getDeleteAdminEmployerInviteUrl = (inviteId: number,) => {




  return `/admin/admin-employer/invite/${inviteId}`
}

export const deleteAdminEmployerInvite = async (inviteId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getDeleteAdminEmployerInviteUrl(inviteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAdminEmployerInviteMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminEmployerInvite>>, TError,{inviteId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminEmployerInvite>>, TError,{inviteId: number}, TContext> => {

const mutationKey = ['deleteAdminEmployerInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminEmployerInvite>>, {inviteId: number}> = (props) => {
          const {inviteId} = props ?? {};

          return  deleteAdminEmployerInvite(inviteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminEmployerInviteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminEmployerInvite>>>

    export type DeleteAdminEmployerInviteMutationError = ProblemDetails

    export const useDeleteAdminEmployerInvite = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminEmployerInvite>>, TError,{inviteId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAdminEmployerInvite>>,
        TError,
        {inviteId: number},
        TContext
      > => {
      return useMutation(getDeleteAdminEmployerInviteMutationOptions(options), queryClient);
    }

export const getSetAdminEmployerCompanyRolesUrl = () => {




  return `/admin/admin-employer/employer/roles`
}

export const setAdminEmployerCompanyRoles = async (setEmployerCompanyRolesCommandDto?: SetEmployerCompanyRolesCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getSetAdminEmployerCompanyRolesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setEmployerCompanyRolesCommandDto)
  }
);}





export const getSetAdminEmployerCompanyRolesMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminEmployerCompanyRoles>>, TError,{data?: SetEmployerCompanyRolesCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminEmployerCompanyRoles>>, TError,{data?: SetEmployerCompanyRolesCommandDto}, TContext> => {

const mutationKey = ['setAdminEmployerCompanyRoles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminEmployerCompanyRoles>>, {data?: SetEmployerCompanyRolesCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  setAdminEmployerCompanyRoles(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminEmployerCompanyRolesMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminEmployerCompanyRoles>>>
    export type SetAdminEmployerCompanyRolesMutationBody = SetEmployerCompanyRolesCommandDto | undefined
    export type SetAdminEmployerCompanyRolesMutationError = ProblemDetails

    export const useSetAdminEmployerCompanyRoles = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminEmployerCompanyRoles>>, TError,{data?: SetEmployerCompanyRolesCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof setAdminEmployerCompanyRoles>>,
        TError,
        {data?: SetEmployerCompanyRolesCommandDto},
        TContext
      > => {
      return useMutation(getSetAdminEmployerCompanyRolesMutationOptions(options), queryClient);
    }

export const getAddLeadToCompanyUrl = () => {




  return `/admin/admin-employer/employer/add-lead`
}

export const addLeadToCompany = async (addLeadToCompanyCommandDto?: AddLeadToCompanyCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getAddLeadToCompanyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addLeadToCompanyCommandDto)
  }
);}





export const getAddLeadToCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLeadToCompany>>, TError,{data?: AddLeadToCompanyCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof addLeadToCompany>>, TError,{data?: AddLeadToCompanyCommandDto}, TContext> => {

const mutationKey = ['addLeadToCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addLeadToCompany>>, {data?: AddLeadToCompanyCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  addLeadToCompany(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddLeadToCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof addLeadToCompany>>>
    export type AddLeadToCompanyMutationBody = AddLeadToCompanyCommandDto | undefined
    export type AddLeadToCompanyMutationError = ProblemDetails

    export const useAddLeadToCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLeadToCompany>>, TError,{data?: AddLeadToCompanyCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addLeadToCompany>>,
        TError,
        {data?: AddLeadToCompanyCommandDto},
        TContext
      > => {
      return useMutation(getAddLeadToCompanyMutationOptions(options), queryClient);
    }

export const getSetLeadEmailEnabledUrl = (params?: SetLeadEmailEnabledParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-employer/lead/email-enabled?${stringifiedParams}` : `/admin/admin-employer/lead/email-enabled`
}

export const setLeadEmailEnabled = async (params?: SetLeadEmailEnabledParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getSetLeadEmailEnabledUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSetLeadEmailEnabledMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLeadEmailEnabled>>, TError,{params?: SetLeadEmailEnabledParams}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof setLeadEmailEnabled>>, TError,{params?: SetLeadEmailEnabledParams}, TContext> => {

const mutationKey = ['setLeadEmailEnabled'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLeadEmailEnabled>>, {params?: SetLeadEmailEnabledParams}> = (props) => {
          const {params} = props ?? {};

          return  setLeadEmailEnabled(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLeadEmailEnabledMutationResult = NonNullable<Awaited<ReturnType<typeof setLeadEmailEnabled>>>

    export type SetLeadEmailEnabledMutationError = ProblemDetails

    export const useSetLeadEmailEnabled = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLeadEmailEnabled>>, TError,{params?: SetLeadEmailEnabledParams}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof setLeadEmailEnabled>>,
        TError,
        {params?: SetLeadEmailEnabledParams},
        TContext
      > => {
      return useMutation(getSetLeadEmailEnabledMutationOptions(options), queryClient);
    }

export const getMoveInviteSubscriptionStartDateEarlierUrl = (inviteId: number,) => {




  return `/admin/admin-employer/invite/${inviteId}/subscription-start-date`
}

export const moveInviteSubscriptionStartDateEarlier = async (inviteId: number,
    moveInviteSubscriptionStartDateEarlierCommandDto?: MoveInviteSubscriptionStartDateEarlierCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getMoveInviteSubscriptionStartDateEarlierUrl(inviteId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(moveInviteSubscriptionStartDateEarlierCommandDto)
  }
);}





export const getMoveInviteSubscriptionStartDateEarlierMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveInviteSubscriptionStartDateEarlier>>, TError,{inviteId: number;data?: MoveInviteSubscriptionStartDateEarlierCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof moveInviteSubscriptionStartDateEarlier>>, TError,{inviteId: number;data?: MoveInviteSubscriptionStartDateEarlierCommandDto}, TContext> => {

const mutationKey = ['moveInviteSubscriptionStartDateEarlier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveInviteSubscriptionStartDateEarlier>>, {inviteId: number;data?: MoveInviteSubscriptionStartDateEarlierCommandDto}> = (props) => {
          const {inviteId,data} = props ?? {};

          return  moveInviteSubscriptionStartDateEarlier(inviteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveInviteSubscriptionStartDateEarlierMutationResult = NonNullable<Awaited<ReturnType<typeof moveInviteSubscriptionStartDateEarlier>>>
    export type MoveInviteSubscriptionStartDateEarlierMutationBody = MoveInviteSubscriptionStartDateEarlierCommandDto | undefined
    export type MoveInviteSubscriptionStartDateEarlierMutationError = ProblemDetails

    export const useMoveInviteSubscriptionStartDateEarlier = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveInviteSubscriptionStartDateEarlier>>, TError,{inviteId: number;data?: MoveInviteSubscriptionStartDateEarlierCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof moveInviteSubscriptionStartDateEarlier>>,
        TError,
        {inviteId: number;data?: MoveInviteSubscriptionStartDateEarlierCommandDto},
        TContext
      > => {
      return useMutation(getMoveInviteSubscriptionStartDateEarlierMutationOptions(options), queryClient);
    }

export const getSetTeammateInviteCompaniesUrl = (inviteId: number,) => {




  return `/admin/admin-employer/invite/${inviteId}/companies`
}

export const setTeammateInviteCompanies = async (inviteId: number,
    setTeammateInviteCompaniesCommandDto?: SetTeammateInviteCompaniesCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getSetTeammateInviteCompaniesUrl(inviteId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setTeammateInviteCompaniesCommandDto)
  }
);}





export const getSetTeammateInviteCompaniesMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTeammateInviteCompanies>>, TError,{inviteId: number;data?: SetTeammateInviteCompaniesCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof setTeammateInviteCompanies>>, TError,{inviteId: number;data?: SetTeammateInviteCompaniesCommandDto}, TContext> => {

const mutationKey = ['setTeammateInviteCompanies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTeammateInviteCompanies>>, {inviteId: number;data?: SetTeammateInviteCompaniesCommandDto}> = (props) => {
          const {inviteId,data} = props ?? {};

          return  setTeammateInviteCompanies(inviteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetTeammateInviteCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof setTeammateInviteCompanies>>>
    export type SetTeammateInviteCompaniesMutationBody = SetTeammateInviteCompaniesCommandDto | undefined
    export type SetTeammateInviteCompaniesMutationError = ProblemDetails

    export const useSetTeammateInviteCompanies = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTeammateInviteCompanies>>, TError,{inviteId: number;data?: SetTeammateInviteCompaniesCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof setTeammateInviteCompanies>>,
        TError,
        {inviteId: number;data?: SetTeammateInviteCompaniesCommandDto},
        TContext
      > => {
      return useMutation(getSetTeammateInviteCompaniesMutationOptions(options), queryClient);
    }

export const getDeleteEmployerUrl = () => {




  return `/admin/admin-employer/employer`
}

export const deleteEmployer = async (deleteEmployerCommandDto?: DeleteEmployerCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getDeleteEmployerUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deleteEmployerCommandDto)
  }
);}





export const getDeleteEmployerMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployer>>, TError,{data?: DeleteEmployerCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployer>>, TError,{data?: DeleteEmployerCommandDto}, TContext> => {

const mutationKey = ['deleteEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployer>>, {data?: DeleteEmployerCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  deleteEmployer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployer>>>
    export type DeleteEmployerMutationBody = DeleteEmployerCommandDto | undefined
    export type DeleteEmployerMutationError = ProblemDetails

    export const useDeleteEmployer = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployer>>, TError,{data?: DeleteEmployerCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteEmployer>>,
        TError,
        {data?: DeleteEmployerCommandDto},
        TContext
      > => {
      return useMutation(getDeleteEmployerMutationOptions(options), queryClient);
    }

export const getGetEmployerInviteLinkUrl = (params?: GetEmployerInviteLinkParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-employer/employer/invite-link?${stringifiedParams}` : `/admin/admin-employer/employer/invite-link`
}

export const getEmployerInviteLink = async (params?: GetEmployerInviteLinkParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetEmployerInviteLinkResult> => {

  return fetchWithAuth<GetEmployerInviteLinkResult>(getGetEmployerInviteLinkUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmployerInviteLinkQueryKey = (params?: MaybeRefOrGetter<GetEmployerInviteLinkParams>,) => {
    return [
    'admin','admin-employer','employer','invite-link', ...(params ? [params] : [])
    ] as const;
    }


export const getGetEmployerInviteLinkQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerInviteLink>>, TError = ProblemDetails>(params?: MaybeRefOrGetter<GetEmployerInviteLinkParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerInviteLink>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetEmployerInviteLinkQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerInviteLink>>> = ({ signal }) => getEmployerInviteLink(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerInviteLink>>, TError, TData>
}

export type GetEmployerInviteLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerInviteLink>>>
export type GetEmployerInviteLinkQueryError = ProblemDetails



export function useGetEmployerInviteLink<TData = Awaited<ReturnType<typeof getEmployerInviteLink>>, TError = ProblemDetails>(
 params?: MaybeRefOrGetter<GetEmployerInviteLinkParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerInviteLink>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployerInviteLinkQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminAccessUrl = () => {




  return `/admin/access`
}

export const getAdminAccess = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminAccessResult> => {

  return fetchWithAuth<GetAdminAccessResult>(getGetAdminAccessUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAccessQueryKey = () => {
    return [
    'admin','access'
    ] as const;
    }


export const getGetAdminAccessQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAccess>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAccess>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminAccessQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAccess>>> = ({ signal }) => getAdminAccess({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAccess>>, TError, TData>
}

export type GetAdminAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAccess>>>
export type GetAdminAccessQueryError = ProblemDetails



export function useGetAdminAccess<TData = Awaited<ReturnType<typeof getAdminAccess>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAccess>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAccessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getSyncMyInternalRolesUrl = () => {




  return `/admin/sync-roles`
}

/**
 * @summary Reconciles the calling internal employee's role assignments with the roles carried in their access
token: existing roles present in the token are (kept and) added, roles no longer in the token are
removed. Self-service, so any authenticated admin may call it for themselves. The frontend calls this
when the token roles diverge from Swipe4Work.Admin.Application.Auth.Queries.GetAdminAccess and then reloads.
 */
export const syncMyInternalRoles = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getSyncMyInternalRolesUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncMyInternalRolesMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncMyInternalRoles>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof syncMyInternalRoles>>, TError,void, TContext> => {

const mutationKey = ['syncMyInternalRoles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncMyInternalRoles>>, void> = () => {


          return  syncMyInternalRoles(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncMyInternalRolesMutationResult = NonNullable<Awaited<ReturnType<typeof syncMyInternalRoles>>>

    export type SyncMyInternalRolesMutationError = ProblemDetails

    /**
 * @summary Reconciles the calling internal employee's role assignments with the roles carried in their access
token: existing roles present in the token are (kept and) added, roles no longer in the token are
removed. Self-service, so any authenticated admin may call it for themselves. The frontend calls this
when the token roles diverge from Swipe4Work.Admin.Application.Auth.Queries.GetAdminAccess and then reloads.
 */
export const useSyncMyInternalRoles = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncMyInternalRoles>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof syncMyInternalRoles>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncMyInternalRolesMutationOptions(options), queryClient);
    }

export const getListInternalRolesUrl = () => {




  return `/admin/internal-roles`
}

export const listInternalRoles = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListInternalRolesResult> => {

  return fetchWithAuth<ListInternalRolesResult>(getListInternalRolesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInternalRolesQueryKey = () => {
    return [
    'admin','internal-roles'
    ] as const;
    }


export const getListInternalRolesQueryOptions = <TData = Awaited<ReturnType<typeof listInternalRoles>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInternalRoles>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListInternalRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInternalRoles>>> = ({ signal }) => listInternalRoles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInternalRoles>>, TError, TData>
}

export type ListInternalRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listInternalRoles>>>
export type ListInternalRolesQueryError = unknown



export function useListInternalRoles<TData = Awaited<ReturnType<typeof listInternalRoles>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInternalRoles>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInternalRolesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminPermissionsUrl = () => {




  return `/admin/authorization/permissions`
}

export const listAdminPermissions = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminPermissionsResult> => {

  return fetchWithAuth<ListAdminPermissionsResult>(getListAdminPermissionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminPermissionsQueryKey = () => {
    return [
    'admin','authorization','permissions'
    ] as const;
    }


export const getListAdminPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminPermissions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminPermissionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminPermissions>>> = ({ signal }) => listAdminPermissions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminPermissions>>, TError, TData>
}

export type ListAdminPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminPermissions>>>
export type ListAdminPermissionsQueryError = unknown



export function useListAdminPermissions<TData = Awaited<ReturnType<typeof listAdminPermissions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminPermissionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListInternalRolesDetailedUrl = () => {




  return `/admin/authorization/roles`
}

export const listInternalRolesDetailed = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListInternalRolesDetailedResult> => {

  return fetchWithAuth<ListInternalRolesDetailedResult>(getListInternalRolesDetailedUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInternalRolesDetailedQueryKey = () => {
    return [
    'admin','authorization','roles'
    ] as const;
    }


export const getListInternalRolesDetailedQueryOptions = <TData = Awaited<ReturnType<typeof listInternalRolesDetailed>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInternalRolesDetailed>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListInternalRolesDetailedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInternalRolesDetailed>>> = ({ signal }) => listInternalRolesDetailed({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInternalRolesDetailed>>, TError, TData>
}

export type ListInternalRolesDetailedQueryResult = NonNullable<Awaited<ReturnType<typeof listInternalRolesDetailed>>>
export type ListInternalRolesDetailedQueryError = unknown



export function useListInternalRolesDetailed<TData = Awaited<ReturnType<typeof listInternalRolesDetailed>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInternalRolesDetailed>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInternalRolesDetailedQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getUpdateInternalRoleUrl = () => {




  return `/admin/authorization/roles`
}

export const updateInternalRole = async (updateInternalRoleCommandDto?: UpdateInternalRoleCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getUpdateInternalRoleUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateInternalRoleCommandDto)
  }
);}





export const getUpdateInternalRoleMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInternalRole>>, TError,{data?: UpdateInternalRoleCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInternalRole>>, TError,{data?: UpdateInternalRoleCommandDto}, TContext> => {

const mutationKey = ['updateInternalRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInternalRole>>, {data?: UpdateInternalRoleCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  updateInternalRole(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInternalRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateInternalRole>>>
    export type UpdateInternalRoleMutationBody = UpdateInternalRoleCommandDto | undefined
    export type UpdateInternalRoleMutationError = ProblemDetails

    export const useUpdateInternalRole = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInternalRole>>, TError,{data?: UpdateInternalRoleCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateInternalRole>>,
        TError,
        {data?: UpdateInternalRoleCommandDto},
        TContext
      > => {
      return useMutation(getUpdateInternalRoleMutationOptions(options), queryClient);
    }

export const getListInternalEmployersUrl = (params?: ListInternalEmployersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["departments"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/internal-employees?${stringifiedParams}` : `/admin/internal-employees`
}

export const listInternalEmployers = async (params?: ListInternalEmployersParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListInternalEmployersResult> => {

  return fetchWithAuth<ListInternalEmployersResult>(getListInternalEmployersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInternalEmployersQueryKey = (params?: MaybeRefOrGetter<ListInternalEmployersParams>,) => {
    return [
    'admin','internal-employees', ...(params ? [params] : [])
    ] as const;
    }


export const getListInternalEmployersQueryOptions = <TData = Awaited<ReturnType<typeof listInternalEmployers>>, TError = unknown>(params?: MaybeRefOrGetter<ListInternalEmployersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInternalEmployers>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListInternalEmployersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInternalEmployers>>> = ({ signal }) => listInternalEmployers(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInternalEmployers>>, TError, TData>
}

export type ListInternalEmployersQueryResult = NonNullable<Awaited<ReturnType<typeof listInternalEmployers>>>
export type ListInternalEmployersQueryError = unknown



export function useListInternalEmployers<TData = Awaited<ReturnType<typeof listInternalEmployers>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListInternalEmployersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInternalEmployers>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInternalEmployersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getSetInternalEmployerRolesUrl = () => {




  return `/admin/internal-employees/roles`
}

export const setInternalEmployerRoles = async (setInternalEmployerRolesCommandDto?: SetInternalEmployerRolesCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getSetInternalEmployerRolesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setInternalEmployerRolesCommandDto)
  }
);}





export const getSetInternalEmployerRolesMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setInternalEmployerRoles>>, TError,{data?: SetInternalEmployerRolesCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof setInternalEmployerRoles>>, TError,{data?: SetInternalEmployerRolesCommandDto}, TContext> => {

const mutationKey = ['setInternalEmployerRoles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setInternalEmployerRoles>>, {data?: SetInternalEmployerRolesCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  setInternalEmployerRoles(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetInternalEmployerRolesMutationResult = NonNullable<Awaited<ReturnType<typeof setInternalEmployerRoles>>>
    export type SetInternalEmployerRolesMutationBody = SetInternalEmployerRolesCommandDto | undefined
    export type SetInternalEmployerRolesMutationError = ProblemDetails

    export const useSetInternalEmployerRoles = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setInternalEmployerRoles>>, TError,{data?: SetInternalEmployerRolesCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof setInternalEmployerRoles>>,
        TError,
        {data?: SetInternalEmployerRolesCommandDto},
        TContext
      > => {
      return useMutation(getSetInternalEmployerRolesMutationOptions(options), queryClient);
    }

export const getAdminListAiJobsUrl = (params?: AdminListAiJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["companyIds","statuses","ratings"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/ai-jobs?${stringifiedParams}` : `/admin/ai-jobs`
}

/**
 * @summary Paged, filterable overview of saved AiJobs.
 */
export const adminListAiJobs = async (params?: AdminListAiJobsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminAiJobsResult> => {

  return fetchWithAuth<ListAdminAiJobsResult>(getAdminListAiJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListAiJobsQueryKey = (params?: MaybeRefOrGetter<AdminListAiJobsParams>,) => {
    return [
    'admin','ai-jobs', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListAiJobsQueryOptions = <TData = Awaited<ReturnType<typeof adminListAiJobs>>, TError = unknown>(params?: MaybeRefOrGetter<AdminListAiJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListAiJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListAiJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListAiJobs>>> = ({ signal }) => adminListAiJobs(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListAiJobs>>, TError, TData>
}

export type AdminListAiJobsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListAiJobs>>>
export type AdminListAiJobsQueryError = unknown


/**
 * @summary Paged, filterable overview of saved AiJobs.
 */

export function useAdminListAiJobs<TData = Awaited<ReturnType<typeof adminListAiJobs>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminListAiJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListAiJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListAiJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminCreateAiJobUrl = () => {




  return `/admin/ai-jobs`
}

/**
 * @summary Saves the composed vacancy of the AI-agents page as a new AiJob.
 */
export const adminCreateAiJob = async (createAiJobCommandDto?: CreateAiJobCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

  return fetchWithAuth<number>(getAdminCreateAiJobUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAiJobCommandDto)
  }
);}





export const getAdminCreateAiJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateAiJob>>, TError,{data?: CreateAiJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateAiJob>>, TError,{data?: CreateAiJobCommandDto}, TContext> => {

const mutationKey = ['adminCreateAiJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateAiJob>>, {data?: CreateAiJobCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateAiJob(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateAiJobMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateAiJob>>>
    export type AdminCreateAiJobMutationBody = CreateAiJobCommandDto | undefined
    export type AdminCreateAiJobMutationError = ProblemDetails

    /**
 * @summary Saves the composed vacancy of the AI-agents page as a new AiJob.
 */
export const useAdminCreateAiJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateAiJob>>, TError,{data?: CreateAiJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateAiJob>>,
        TError,
        {data?: CreateAiJobCommandDto},
        TContext
      > => {
      return useMutation(getAdminCreateAiJobMutationOptions(options), queryClient);
    }

export const getAdminGetAiJobUrl = (id: number,) => {




  return `/admin/ai-jobs/${id}`
}

/**
 * @summary Full detail of one AiJob, including the saved content for the AI-agents page.
 */
export const adminGetAiJob = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminAiJobResult> => {

  return fetchWithAuth<GetAdminAiJobResult>(getAdminGetAiJobUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetAiJobQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','ai-jobs',id
    ] as const;
    }


export const getAdminGetAiJobQueryOptions = <TData = Awaited<ReturnType<typeof adminGetAiJob>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetAiJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetAiJobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetAiJob>>> = ({ signal }) => adminGetAiJob(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetAiJob>>, TError, TData>
}

export type AdminGetAiJobQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetAiJob>>>
export type AdminGetAiJobQueryError = ProblemDetails


/**
 * @summary Full detail of one AiJob, including the saved content for the AI-agents page.
 */

export function useAdminGetAiJob<TData = Awaited<ReturnType<typeof adminGetAiJob>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetAiJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetAiJobQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminUpdateAiJobUrl = (id: number,) => {




  return `/admin/ai-jobs/${id}`
}

/**
 * @summary Overwrites a draft AiJob with the refined result of the AI-agents page.
 */
export const adminUpdateAiJob = async (id: number,
    aiJobContentDto?: AiJobContentDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

  return fetchWithAuth<number>(getAdminUpdateAiJobUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(aiJobContentDto)
  }
);}





export const getAdminUpdateAiJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateAiJob>>, TError,{id: number;data?: AiJobContentDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateAiJob>>, TError,{id: number;data?: AiJobContentDto}, TContext> => {

const mutationKey = ['adminUpdateAiJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateAiJob>>, {id: number;data?: AiJobContentDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateAiJob(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateAiJobMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateAiJob>>>
    export type AdminUpdateAiJobMutationBody = AiJobContentDto | undefined
    export type AdminUpdateAiJobMutationError = ProblemDetails

    /**
 * @summary Overwrites a draft AiJob with the refined result of the AI-agents page.
 */
export const useAdminUpdateAiJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateAiJob>>, TError,{id: number;data?: AiJobContentDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateAiJob>>,
        TError,
        {id: number;data?: AiJobContentDto},
        TContext
      > => {
      return useMutation(getAdminUpdateAiJobMutationOptions(options), queryClient);
    }

export const getAdminDeleteAiJobUrl = (id: number,) => {




  return `/admin/ai-jobs/${id}`
}

/**
 * @summary Deletes a saved AiJob; a job it was converted into stays.
 */
export const adminDeleteAiJob = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<boolean> => {

  return fetchWithAuth<boolean>(getAdminDeleteAiJobUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminDeleteAiJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteAiJob>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteAiJob>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminDeleteAiJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteAiJob>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminDeleteAiJob(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteAiJobMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteAiJob>>>

    export type AdminDeleteAiJobMutationError = ProblemDetails

    /**
 * @summary Deletes a saved AiJob; a job it was converted into stays.
 */
export const useAdminDeleteAiJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteAiJob>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminDeleteAiJob>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminDeleteAiJobMutationOptions(options), queryClient);
    }

export const getAdminConvertAiJobToJobUrl = (id: number,) => {




  return `/admin/ai-jobs/${id}/convert`
}

/**
 * @summary Converts a draft AiJob into a draft job for its company; returns the new job id.
 */
export const adminConvertAiJobToJob = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

  return fetchWithAuth<number>(getAdminConvertAiJobToJobUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminConvertAiJobToJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminConvertAiJobToJob>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminConvertAiJobToJob>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminConvertAiJobToJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminConvertAiJobToJob>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminConvertAiJobToJob(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminConvertAiJobToJobMutationResult = NonNullable<Awaited<ReturnType<typeof adminConvertAiJobToJob>>>

    export type AdminConvertAiJobToJobMutationError = ProblemDetails

    /**
 * @summary Converts a draft AiJob into a draft job for its company; returns the new job id.
 */
export const useAdminConvertAiJobToJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminConvertAiJobToJob>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminConvertAiJobToJob>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminConvertAiJobToJobMutationOptions(options), queryClient);
    }

export const getAdminReviewAiJobUrl = (id: number,) => {




  return `/admin/ai-jobs/${id}/review`
}

/**
 * @summary Gives the AiJob a thumbs up/down (with reasons and an optional remark), replacing an earlier review.
 */
export const adminReviewAiJob = async (id: number,
    reviewAiJobCommandDto?: ReviewAiJobCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<boolean> => {

  return fetchWithAuth<boolean>(getAdminReviewAiJobUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reviewAiJobCommandDto)
  }
);}





export const getAdminReviewAiJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReviewAiJob>>, TError,{id: number;data?: ReviewAiJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReviewAiJob>>, TError,{id: number;data?: ReviewAiJobCommandDto}, TContext> => {

const mutationKey = ['adminReviewAiJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReviewAiJob>>, {id: number;data?: ReviewAiJobCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminReviewAiJob(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReviewAiJobMutationResult = NonNullable<Awaited<ReturnType<typeof adminReviewAiJob>>>
    export type AdminReviewAiJobMutationBody = ReviewAiJobCommandDto | undefined
    export type AdminReviewAiJobMutationError = ProblemDetails

    /**
 * @summary Gives the AiJob a thumbs up/down (with reasons and an optional remark), replacing an earlier review.
 */
export const useAdminReviewAiJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReviewAiJob>>, TError,{id: number;data?: ReviewAiJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminReviewAiJob>>,
        TError,
        {id: number;data?: ReviewAiJobCommandDto},
        TContext
      > => {
      return useMutation(getAdminReviewAiJobMutationOptions(options), queryClient);
    }

export const getAdminClearAiJobReviewUrl = (id: number,) => {




  return `/admin/ai-jobs/${id}/review`
}

/**
 * @summary Removes the review from the AiJob.
 */
export const adminClearAiJobReview = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<boolean> => {

  return fetchWithAuth<boolean>(getAdminClearAiJobReviewUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminClearAiJobReviewMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClearAiJobReview>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminClearAiJobReview>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminClearAiJobReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminClearAiJobReview>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminClearAiJobReview(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminClearAiJobReviewMutationResult = NonNullable<Awaited<ReturnType<typeof adminClearAiJobReview>>>

    export type AdminClearAiJobReviewMutationError = ProblemDetails

    /**
 * @summary Removes the review from the AiJob.
 */
export const useAdminClearAiJobReview = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClearAiJobReview>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminClearAiJobReview>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminClearAiJobReviewMutationOptions(options), queryClient);
    }

export const getAdminDetermineJobDataUrl = () => {




  return `/admin/ai-agents/job-agent/determine-data`
}

export const adminDetermineJobData = async (adminAiAgentControllerDetermineJobDataDto?: AdminAiAgentControllerDetermineJobDataDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminAiAgentControllerDetermineJobDataResultDto> => {

  return fetchWithAuth<AdminAiAgentControllerDetermineJobDataResultDto>(getAdminDetermineJobDataUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminAiAgentControllerDetermineJobDataDto)
  }
);}





export const getAdminDetermineJobDataMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDetermineJobData>>, TError,{data?: AdminAiAgentControllerDetermineJobDataDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDetermineJobData>>, TError,{data?: AdminAiAgentControllerDetermineJobDataDto}, TContext> => {

const mutationKey = ['adminDetermineJobData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDetermineJobData>>, {data?: AdminAiAgentControllerDetermineJobDataDto}> = (props) => {
          const {data} = props ?? {};

          return  adminDetermineJobData(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDetermineJobDataMutationResult = NonNullable<Awaited<ReturnType<typeof adminDetermineJobData>>>
    export type AdminDetermineJobDataMutationBody = AdminAiAgentControllerDetermineJobDataDto | undefined
    export type AdminDetermineJobDataMutationError = ProblemDetails

    export const useAdminDetermineJobData = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDetermineJobData>>, TError,{data?: AdminAiAgentControllerDetermineJobDataDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminDetermineJobData>>,
        TError,
        {data?: AdminAiAgentControllerDetermineJobDataDto},
        TContext
      > => {
      return useMutation(getAdminDetermineJobDataMutationOptions(options), queryClient);
    }

export const getAdminComposeJobUrl = () => {




  return `/admin/ai-agents/job-agent/compose`
}

export const adminComposeJob = async (adminAiAgentControllerComposeJobDto?: AdminAiAgentControllerComposeJobDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminAiAgentControllerComposeJobResultDto> => {

  return fetchWithAuth<AdminAiAgentControllerComposeJobResultDto>(getAdminComposeJobUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminAiAgentControllerComposeJobDto)
  }
);}





export const getAdminComposeJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminComposeJob>>, TError,{data?: AdminAiAgentControllerComposeJobDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminComposeJob>>, TError,{data?: AdminAiAgentControllerComposeJobDto}, TContext> => {

const mutationKey = ['adminComposeJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminComposeJob>>, {data?: AdminAiAgentControllerComposeJobDto}> = (props) => {
          const {data} = props ?? {};

          return  adminComposeJob(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminComposeJobMutationResult = NonNullable<Awaited<ReturnType<typeof adminComposeJob>>>
    export type AdminComposeJobMutationBody = AdminAiAgentControllerComposeJobDto | undefined
    export type AdminComposeJobMutationError = ProblemDetails

    export const useAdminComposeJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminComposeJob>>, TError,{data?: AdminAiAgentControllerComposeJobDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminComposeJob>>,
        TError,
        {data?: AdminAiAgentControllerComposeJobDto},
        TContext
      > => {
      return useMutation(getAdminComposeJobMutationOptions(options), queryClient);
    }

export const getAdminChatWithJobAgentUrl = () => {




  return `/admin/ai-agents/job-agent/chat`
}

export const adminChatWithJobAgent = async (adminAiAgentControllerJobAgentChatDto?: AdminAiAgentControllerJobAgentChatDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminAiAgentControllerJobAgentChatResultDto> => {

  return fetchWithAuth<AdminAiAgentControllerJobAgentChatResultDto>(getAdminChatWithJobAgentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminAiAgentControllerJobAgentChatDto)
  }
);}





export const getAdminChatWithJobAgentMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminChatWithJobAgent>>, TError,{data?: AdminAiAgentControllerJobAgentChatDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminChatWithJobAgent>>, TError,{data?: AdminAiAgentControllerJobAgentChatDto}, TContext> => {

const mutationKey = ['adminChatWithJobAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminChatWithJobAgent>>, {data?: AdminAiAgentControllerJobAgentChatDto}> = (props) => {
          const {data} = props ?? {};

          return  adminChatWithJobAgent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminChatWithJobAgentMutationResult = NonNullable<Awaited<ReturnType<typeof adminChatWithJobAgent>>>
    export type AdminChatWithJobAgentMutationBody = AdminAiAgentControllerJobAgentChatDto | undefined
    export type AdminChatWithJobAgentMutationError = ProblemDetails

    export const useAdminChatWithJobAgent = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminChatWithJobAgent>>, TError,{data?: AdminAiAgentControllerJobAgentChatDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminChatWithJobAgent>>,
        TError,
        {data?: AdminAiAgentControllerJobAgentChatDto},
        TContext
      > => {
      return useMutation(getAdminChatWithJobAgentMutationOptions(options), queryClient);
    }

export const getAdminWriteJobDescriptionUrl = () => {




  return `/admin/ai-agents/job-agent/write`
}

export const adminWriteJobDescription = async (adminAiAgentControllerWriteJobDescriptionDto?: AdminAiAgentControllerWriteJobDescriptionDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminAiAgentControllerJobDescriptionResultDto> => {

  return fetchWithAuth<AdminAiAgentControllerJobDescriptionResultDto>(getAdminWriteJobDescriptionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminAiAgentControllerWriteJobDescriptionDto)
  }
);}





export const getAdminWriteJobDescriptionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminWriteJobDescription>>, TError,{data?: AdminAiAgentControllerWriteJobDescriptionDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminWriteJobDescription>>, TError,{data?: AdminAiAgentControllerWriteJobDescriptionDto}, TContext> => {

const mutationKey = ['adminWriteJobDescription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminWriteJobDescription>>, {data?: AdminAiAgentControllerWriteJobDescriptionDto}> = (props) => {
          const {data} = props ?? {};

          return  adminWriteJobDescription(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminWriteJobDescriptionMutationResult = NonNullable<Awaited<ReturnType<typeof adminWriteJobDescription>>>
    export type AdminWriteJobDescriptionMutationBody = AdminAiAgentControllerWriteJobDescriptionDto | undefined
    export type AdminWriteJobDescriptionMutationError = ProblemDetails

    export const useAdminWriteJobDescription = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminWriteJobDescription>>, TError,{data?: AdminAiAgentControllerWriteJobDescriptionDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminWriteJobDescription>>,
        TError,
        {data?: AdminAiAgentControllerWriteJobDescriptionDto},
        TContext
      > => {
      return useMutation(getAdminWriteJobDescriptionMutationOptions(options), queryClient);
    }

export const getAdminRewriteJobDescriptionUrl = () => {




  return `/admin/ai-agents/job-agent/rewrite`
}

export const adminRewriteJobDescription = async (adminAiAgentControllerRewriteJobDescriptionDto?: AdminAiAgentControllerRewriteJobDescriptionDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminAiAgentControllerRewriteJobDescriptionResultDto> => {

  return fetchWithAuth<AdminAiAgentControllerRewriteJobDescriptionResultDto>(getAdminRewriteJobDescriptionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminAiAgentControllerRewriteJobDescriptionDto)
  }
);}





export const getAdminRewriteJobDescriptionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRewriteJobDescription>>, TError,{data?: AdminAiAgentControllerRewriteJobDescriptionDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRewriteJobDescription>>, TError,{data?: AdminAiAgentControllerRewriteJobDescriptionDto}, TContext> => {

const mutationKey = ['adminRewriteJobDescription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRewriteJobDescription>>, {data?: AdminAiAgentControllerRewriteJobDescriptionDto}> = (props) => {
          const {data} = props ?? {};

          return  adminRewriteJobDescription(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRewriteJobDescriptionMutationResult = NonNullable<Awaited<ReturnType<typeof adminRewriteJobDescription>>>
    export type AdminRewriteJobDescriptionMutationBody = AdminAiAgentControllerRewriteJobDescriptionDto | undefined
    export type AdminRewriteJobDescriptionMutationError = ProblemDetails

    export const useAdminRewriteJobDescription = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRewriteJobDescription>>, TError,{data?: AdminAiAgentControllerRewriteJobDescriptionDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminRewriteJobDescription>>,
        TError,
        {data?: AdminAiAgentControllerRewriteJobDescriptionDto},
        TContext
      > => {
      return useMutation(getAdminRewriteJobDescriptionMutationOptions(options), queryClient);
    }

export const getAdminInvokeJobDataToolUrl = () => {




  return `/admin/ai-agents/job-agent/tools/invoke`
}

export const adminInvokeJobDataTool = async (adminAiAgentControllerInvokeJobDataToolDto?: AdminAiAgentControllerInvokeJobDataToolDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminAiAgentControllerInvokeJobDataToolResultDto> => {

  return fetchWithAuth<AdminAiAgentControllerInvokeJobDataToolResultDto>(getAdminInvokeJobDataToolUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminAiAgentControllerInvokeJobDataToolDto)
  }
);}





export const getAdminInvokeJobDataToolMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvokeJobDataTool>>, TError,{data?: AdminAiAgentControllerInvokeJobDataToolDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminInvokeJobDataTool>>, TError,{data?: AdminAiAgentControllerInvokeJobDataToolDto}, TContext> => {

const mutationKey = ['adminInvokeJobDataTool'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInvokeJobDataTool>>, {data?: AdminAiAgentControllerInvokeJobDataToolDto}> = (props) => {
          const {data} = props ?? {};

          return  adminInvokeJobDataTool(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminInvokeJobDataToolMutationResult = NonNullable<Awaited<ReturnType<typeof adminInvokeJobDataTool>>>
    export type AdminInvokeJobDataToolMutationBody = AdminAiAgentControllerInvokeJobDataToolDto | undefined
    export type AdminInvokeJobDataToolMutationError = ProblemDetails

    export const useAdminInvokeJobDataTool = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInvokeJobDataTool>>, TError,{data?: AdminAiAgentControllerInvokeJobDataToolDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminInvokeJobDataTool>>,
        TError,
        {data?: AdminAiAgentControllerInvokeJobDataToolDto},
        TContext
      > => {
      return useMutation(getAdminInvokeJobDataToolMutationOptions(options), queryClient);
    }

export const getGenerateSandboxDataUrl = () => {




  return `/admin/company/generate-sandbox-data`
}

export const generateSandboxData = async (generateSandboxDataCommand?: GenerateSandboxDataCommand, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getGenerateSandboxDataUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(generateSandboxDataCommand)
  }
);}





export const getGenerateSandboxDataMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateSandboxData>>, TError,{data?: GenerateSandboxDataCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof generateSandboxData>>, TError,{data?: GenerateSandboxDataCommand}, TContext> => {

const mutationKey = ['generateSandboxData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateSandboxData>>, {data?: GenerateSandboxDataCommand}> = (props) => {
          const {data} = props ?? {};

          return  generateSandboxData(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateSandboxDataMutationResult = NonNullable<Awaited<ReturnType<typeof generateSandboxData>>>
    export type GenerateSandboxDataMutationBody = GenerateSandboxDataCommand | undefined
    export type GenerateSandboxDataMutationError = ProblemDetails

    export const useGenerateSandboxData = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateSandboxData>>, TError,{data?: GenerateSandboxDataCommand}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof generateSandboxData>>,
        TError,
        {data?: GenerateSandboxDataCommand},
        TContext
      > => {
      return useMutation(getGenerateSandboxDataMutationOptions(options), queryClient);
    }

export const getGetExactOnlineAuthorizeUrlUrl = () => {




  return `/admin/exact-online/authorize-url`
}

export const getExactOnlineAuthorizeUrl = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ExactOnlineControllerGetExactOnlineAuthorizeUrlResult> => {

  return fetchWithAuth<ExactOnlineControllerGetExactOnlineAuthorizeUrlResult>(getGetExactOnlineAuthorizeUrlUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExactOnlineAuthorizeUrlQueryKey = () => {
    return [
    'admin','exact-online','authorize-url'
    ] as const;
    }


export const getGetExactOnlineAuthorizeUrlQueryOptions = <TData = Awaited<ReturnType<typeof getExactOnlineAuthorizeUrl>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExactOnlineAuthorizeUrl>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetExactOnlineAuthorizeUrlQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExactOnlineAuthorizeUrl>>> = ({ signal }) => getExactOnlineAuthorizeUrl({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExactOnlineAuthorizeUrl>>, TError, TData>
}

export type GetExactOnlineAuthorizeUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getExactOnlineAuthorizeUrl>>>
export type GetExactOnlineAuthorizeUrlQueryError = unknown



export function useGetExactOnlineAuthorizeUrl<TData = Awaited<ReturnType<typeof getExactOnlineAuthorizeUrl>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExactOnlineAuthorizeUrl>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExactOnlineAuthorizeUrlQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetExactOnlineConnectionStatusUrl = () => {




  return `/admin/exact-online/status`
}

export const getExactOnlineConnectionStatus = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetExactOnlineConnectionStatusResult> => {

  return fetchWithAuth<GetExactOnlineConnectionStatusResult>(getGetExactOnlineConnectionStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExactOnlineConnectionStatusQueryKey = () => {
    return [
    'admin','exact-online','status'
    ] as const;
    }


export const getGetExactOnlineConnectionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getExactOnlineConnectionStatus>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExactOnlineConnectionStatus>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetExactOnlineConnectionStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExactOnlineConnectionStatus>>> = ({ signal }) => getExactOnlineConnectionStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExactOnlineConnectionStatus>>, TError, TData>
}

export type GetExactOnlineConnectionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getExactOnlineConnectionStatus>>>
export type GetExactOnlineConnectionStatusQueryError = unknown



export function useGetExactOnlineConnectionStatus<TData = Awaited<ReturnType<typeof getExactOnlineConnectionStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExactOnlineConnectionStatus>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExactOnlineConnectionStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getSetManagedCompanyUrl = (params?: SetManagedCompanyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/user/set-managed-company?${stringifiedParams}` : `/admin/user/set-managed-company`
}

export const setManagedCompany = async (params?: SetManagedCompanyParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getSetManagedCompanyUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSetManagedCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setManagedCompany>>, TError,{params?: SetManagedCompanyParams}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof setManagedCompany>>, TError,{params?: SetManagedCompanyParams}, TContext> => {

const mutationKey = ['setManagedCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setManagedCompany>>, {params?: SetManagedCompanyParams}> = (props) => {
          const {params} = props ?? {};

          return  setManagedCompany(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetManagedCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof setManagedCompany>>>

    export type SetManagedCompanyMutationError = unknown

    export const useSetManagedCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setManagedCompany>>, TError,{params?: SetManagedCompanyParams}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof setManagedCompany>>,
        TError,
        {params?: SetManagedCompanyParams},
        TContext
      > => {
      return useMutation(getSetManagedCompanyMutationOptions(options), queryClient);
    }

export const getCreateAdminUserUrl = () => {




  return `/admin/user`
}

export const createAdminUser = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getCreateAdminUserUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateAdminUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminUser>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminUser>>, TError,void, TContext> => {

const mutationKey = ['createAdminUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminUser>>, void> = () => {


          return  createAdminUser(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminUserMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminUser>>>

    export type CreateAdminUserMutationError = unknown

    export const useCreateAdminUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminUser>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAdminUser>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateAdminUserMutationOptions(options), queryClient);
    }

export const getListAdminUsersUrl = () => {




  return `/admin/user`
}

export const listAdminUsers = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminUsersResult> => {

  return fetchWithAuth<ListAdminUsersResult>(getListAdminUsersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminUsersQueryKey = () => {
    return [
    'admin','user'
    ] as const;
    }


export const getListAdminUsersQueryOptions = <TData = Awaited<ReturnType<typeof listAdminUsers>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminUsers>>> = ({ signal }) => listAdminUsers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData>
}

export type ListAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminUsers>>>
export type ListAdminUsersQueryError = ProblemDetails



export function useListAdminUsers<TData = Awaited<ReturnType<typeof listAdminUsers>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getDeleteEmployeeAccountUrl = (params?: DeleteEmployeeAccountParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/user?${stringifiedParams}` : `/admin/user`
}

export const deleteEmployeeAccount = async (params?: DeleteEmployeeAccountParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getDeleteEmployeeAccountUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteEmployeeAccountMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeAccount>>, TError,{params?: DeleteEmployeeAccountParams}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeAccount>>, TError,{params?: DeleteEmployeeAccountParams}, TContext> => {

const mutationKey = ['deleteEmployeeAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployeeAccount>>, {params?: DeleteEmployeeAccountParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteEmployeeAccount(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployeeAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployeeAccount>>>

    export type DeleteEmployeeAccountMutationError = ProblemDetails

    export const useDeleteEmployeeAccount = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployeeAccount>>, TError,{params?: DeleteEmployeeAccountParams}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteEmployeeAccount>>,
        TError,
        {params?: DeleteEmployeeAccountParams},
        TContext
      > => {
      return useMutation(getDeleteEmployeeAccountMutationOptions(options), queryClient);
    }

export const getListAdminMatchingJobCategoriesUrl = () => {




  return `/admin/matching/job-categories`
}

export const listAdminMatchingJobCategories = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminMatchingJobCategoriesResult> => {

  return fetchWithAuth<ListAdminMatchingJobCategoriesResult>(getListAdminMatchingJobCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminMatchingJobCategoriesQueryKey = () => {
    return [
    'admin','matching','job-categories'
    ] as const;
    }


export const getListAdminMatchingJobCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminMatchingJobCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMatchingJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminMatchingJobCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminMatchingJobCategories>>> = ({ signal }) => listAdminMatchingJobCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminMatchingJobCategories>>, TError, TData>
}

export type ListAdminMatchingJobCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminMatchingJobCategories>>>
export type ListAdminMatchingJobCategoriesQueryError = unknown



export function useListAdminMatchingJobCategories<TData = Awaited<ReturnType<typeof listAdminMatchingJobCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMatchingJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminMatchingJobCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminMatchingJobFunctionsUrl = () => {




  return `/admin/matching/job-functions`
}

export const listAdminMatchingJobFunctions = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminMatchingJobFunctionsResult> => {

  return fetchWithAuth<ListAdminMatchingJobFunctionsResult>(getListAdminMatchingJobFunctionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminMatchingJobFunctionsQueryKey = () => {
    return [
    'admin','matching','job-functions'
    ] as const;
    }


export const getListAdminMatchingJobFunctionsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminMatchingJobFunctions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMatchingJobFunctions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminMatchingJobFunctionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminMatchingJobFunctions>>> = ({ signal }) => listAdminMatchingJobFunctions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminMatchingJobFunctions>>, TError, TData>
}

export type ListAdminMatchingJobFunctionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminMatchingJobFunctions>>>
export type ListAdminMatchingJobFunctionsQueryError = unknown



export function useListAdminMatchingJobFunctions<TData = Awaited<ReturnType<typeof listAdminMatchingJobFunctions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMatchingJobFunctions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminMatchingJobFunctionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminSuggestSkillsUrl = () => {




  return `/admin/skill-suggestion`
}

export const adminSuggestSkills = async (adminSkillSuggestionControllerSuggestSkillsRequest?: AdminSkillSuggestionControllerSuggestSkillsRequest, options?: Parameters<typeof fetchWithAuth>[1]): Promise<AdminSkillSuggestionControllerSuggestSkillsResponse> => {

  return fetchWithAuth<AdminSkillSuggestionControllerSuggestSkillsResponse>(getAdminSuggestSkillsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminSkillSuggestionControllerSuggestSkillsRequest)
  }
);}





export const getAdminSuggestSkillsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSuggestSkills>>, TError,{data?: AdminSkillSuggestionControllerSuggestSkillsRequest}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSuggestSkills>>, TError,{data?: AdminSkillSuggestionControllerSuggestSkillsRequest}, TContext> => {

const mutationKey = ['adminSuggestSkills'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSuggestSkills>>, {data?: AdminSkillSuggestionControllerSuggestSkillsRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminSuggestSkills(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSuggestSkillsMutationResult = NonNullable<Awaited<ReturnType<typeof adminSuggestSkills>>>
    export type AdminSuggestSkillsMutationBody = AdminSkillSuggestionControllerSuggestSkillsRequest | undefined
    export type AdminSuggestSkillsMutationError = unknown

    export const useAdminSuggestSkills = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSuggestSkills>>, TError,{data?: AdminSkillSuggestionControllerSuggestSkillsRequest}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminSuggestSkills>>,
        TError,
        {data?: AdminSkillSuggestionControllerSuggestSkillsRequest},
        TContext
      > => {
      return useMutation(getAdminSuggestSkillsMutationOptions(options), queryClient);
    }

export const getAdminScoreSkillSuggestionUrl = (traceId: string,) => {




  return `/admin/skill-suggestion/${traceId}/score`
}

export const adminScoreSkillSuggestion = async (traceId: string,
    adminSkillSuggestionControllerScoreSkillsRequest?: AdminSkillSuggestionControllerScoreSkillsRequest, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getAdminScoreSkillSuggestionUrl(traceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminSkillSuggestionControllerScoreSkillsRequest)
  }
);}





export const getAdminScoreSkillSuggestionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminScoreSkillSuggestion>>, TError,{traceId: string;data?: AdminSkillSuggestionControllerScoreSkillsRequest}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminScoreSkillSuggestion>>, TError,{traceId: string;data?: AdminSkillSuggestionControllerScoreSkillsRequest}, TContext> => {

const mutationKey = ['adminScoreSkillSuggestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminScoreSkillSuggestion>>, {traceId: string;data?: AdminSkillSuggestionControllerScoreSkillsRequest}> = (props) => {
          const {traceId,data} = props ?? {};

          return  adminScoreSkillSuggestion(traceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminScoreSkillSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof adminScoreSkillSuggestion>>>
    export type AdminScoreSkillSuggestionMutationBody = AdminSkillSuggestionControllerScoreSkillsRequest | undefined
    export type AdminScoreSkillSuggestionMutationError = unknown

    export const useAdminScoreSkillSuggestion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminScoreSkillSuggestion>>, TError,{traceId: string;data?: AdminSkillSuggestionControllerScoreSkillsRequest}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminScoreSkillSuggestion>>,
        TError,
        {traceId: string;data?: AdminSkillSuggestionControllerScoreSkillsRequest},
        TContext
      > => {
      return useMutation(getAdminScoreSkillSuggestionMutationOptions(options), queryClient);
    }

export const getAdminGetUserSkillSuggestionContextUrl = (userId: number,) => {




  return `/admin/skill-suggestion/candidates/${userId}`
}

export const adminGetUserSkillSuggestionContext = async (userId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminUserSkillSuggestionContextResult> => {

  return fetchWithAuth<GetAdminUserSkillSuggestionContextResult>(getAdminGetUserSkillSuggestionContextUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetUserSkillSuggestionContextQueryKey = (userId: MaybeRefOrGetter<number>,) => {
    return [
    'admin','skill-suggestion','candidates',userId
    ] as const;
    }


export const getAdminGetUserSkillSuggestionContextQueryOptions = <TData = Awaited<ReturnType<typeof adminGetUserSkillSuggestionContext>>, TError = ProblemDetails>(userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetUserSkillSuggestionContext>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetUserSkillSuggestionContextQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetUserSkillSuggestionContext>>> = ({ signal }) => adminGetUserSkillSuggestionContext(toValue(userId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetUserSkillSuggestionContext>>, TError, TData>
}

export type AdminGetUserSkillSuggestionContextQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetUserSkillSuggestionContext>>>
export type AdminGetUserSkillSuggestionContextQueryError = ProblemDetails



export function useAdminGetUserSkillSuggestionContext<TData = Awaited<ReturnType<typeof adminGetUserSkillSuggestionContext>>, TError = ProblemDetails>(
 userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetUserSkillSuggestionContext>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetUserSkillSuggestionContextQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminStandInPairUrl = (params?: GetAdminStandInPairParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/stand-in/pair?${stringifiedParams}` : `/admin/stand-in/pair`
}

/**
 * @summary The current state of a (User × Job) pair and the Stand-in Actions available for it.
 */
export const getAdminStandInPair = async (params?: GetAdminStandInPairParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetStandInPairResult> => {

  return fetchWithAuth<GetStandInPairResult>(getGetAdminStandInPairUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminStandInPairQueryKey = (params?: MaybeRefOrGetter<GetAdminStandInPairParams>,) => {
    return [
    'admin','stand-in','pair', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminStandInPairQueryOptions = <TData = Awaited<ReturnType<typeof getAdminStandInPair>>, TError = ProblemDetails>(params?: MaybeRefOrGetter<GetAdminStandInPairParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStandInPair>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminStandInPairQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStandInPair>>> = ({ signal }) => getAdminStandInPair(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminStandInPair>>, TError, TData>
}

export type GetAdminStandInPairQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminStandInPair>>>
export type GetAdminStandInPairQueryError = ProblemDetails


/**
 * @summary The current state of a (User × Job) pair and the Stand-in Actions available for it.
 */

export function useGetAdminStandInPair<TData = Awaited<ReturnType<typeof getAdminStandInPair>>, TError = ProblemDetails>(
 params?: MaybeRefOrGetter<GetAdminStandInPairParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStandInPair>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminStandInPairQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getPerformAdminStandInActionUrl = () => {




  return `/admin/stand-in/actions`
}

/**
 * @summary Performs a Stand-in Action. A failure carries the product's own (Dutch) error message.
 */
export const performAdminStandInAction = async (performStandInActionCommandDto?: PerformStandInActionCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<PerformStandInActionResult> => {

  return fetchWithAuth<PerformStandInActionResult>(getPerformAdminStandInActionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(performStandInActionCommandDto)
  }
);}





export const getPerformAdminStandInActionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof performAdminStandInAction>>, TError,{data?: PerformStandInActionCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof performAdminStandInAction>>, TError,{data?: PerformStandInActionCommandDto}, TContext> => {

const mutationKey = ['performAdminStandInAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof performAdminStandInAction>>, {data?: PerformStandInActionCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  performAdminStandInAction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PerformAdminStandInActionMutationResult = NonNullable<Awaited<ReturnType<typeof performAdminStandInAction>>>
    export type PerformAdminStandInActionMutationBody = PerformStandInActionCommandDto | undefined
    export type PerformAdminStandInActionMutationError = ProblemDetails

    /**
 * @summary Performs a Stand-in Action. A failure carries the product's own (Dutch) error message.
 */
export const usePerformAdminStandInAction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof performAdminStandInAction>>, TError,{data?: PerformStandInActionCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof performAdminStandInAction>>,
        TError,
        {data?: PerformStandInActionCommandDto},
        TContext
      > => {
      return useMutation(getPerformAdminStandInActionMutationOptions(options), queryClient);
    }

export const getListSegmentsUrl = (params?: ListSegmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/segments?${stringifiedParams}` : `/admin/segments`
}

export const listSegments = async (params?: ListSegmentsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSegmentsResult> => {

  return fetchWithAuth<ListSegmentsResult>(getListSegmentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSegmentsQueryKey = (params?: MaybeRefOrGetter<ListSegmentsParams>,) => {
    return [
    'admin','segments', ...(params ? [params] : [])
    ] as const;
    }


export const getListSegmentsQueryOptions = <TData = Awaited<ReturnType<typeof listSegments>>, TError = unknown>(params?: MaybeRefOrGetter<ListSegmentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSegments>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListSegmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSegments>>> = ({ signal }) => listSegments(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSegments>>, TError, TData>
}

export type ListSegmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listSegments>>>
export type ListSegmentsQueryError = unknown



export function useListSegments<TData = Awaited<ReturnType<typeof listSegments>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListSegmentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSegments>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSegmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getCreateSegmentUrl = () => {




  return `/admin/segments`
}

export const createSegment = async (createSegmentCommandDto?: CreateSegmentCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateSegmentResult> => {

  return fetchWithAuth<CreateSegmentResult>(getCreateSegmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSegmentCommandDto)
  }
);}





export const getCreateSegmentMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSegment>>, TError,{data?: CreateSegmentCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createSegment>>, TError,{data?: CreateSegmentCommandDto}, TContext> => {

const mutationKey = ['createSegment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSegment>>, {data?: CreateSegmentCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  createSegment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSegmentMutationResult = NonNullable<Awaited<ReturnType<typeof createSegment>>>
    export type CreateSegmentMutationBody = CreateSegmentCommandDto | undefined
    export type CreateSegmentMutationError = ProblemDetails

    export const useCreateSegment = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSegment>>, TError,{data?: CreateSegmentCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createSegment>>,
        TError,
        {data?: CreateSegmentCommandDto},
        TContext
      > => {
      return useMutation(getCreateSegmentMutationOptions(options), queryClient);
    }

export const getGetSegmentUrl = (id: number,) => {




  return `/admin/segments/${id}`
}

export const getSegment = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetSegmentResult> => {

  return fetchWithAuth<GetSegmentResult>(getGetSegmentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSegmentQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','segments',id
    ] as const;
    }


export const getGetSegmentQueryOptions = <TData = Awaited<ReturnType<typeof getSegment>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSegment>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetSegmentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSegment>>> = ({ signal }) => getSegment(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSegment>>, TError, TData>
}

export type GetSegmentQueryResult = NonNullable<Awaited<ReturnType<typeof getSegment>>>
export type GetSegmentQueryError = ProblemDetails



export function useGetSegment<TData = Awaited<ReturnType<typeof getSegment>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSegment>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSegmentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getUpdateSegmentUrl = (id: number,) => {




  return `/admin/segments/${id}`
}

export const updateSegment = async (id: number,
    updateSegmentCommandDto?: UpdateSegmentCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<UpdateSegmentResult> => {

  return fetchWithAuth<UpdateSegmentResult>(getUpdateSegmentUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSegmentCommandDto)
  }
);}





export const getUpdateSegmentMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSegment>>, TError,{id: number;data?: UpdateSegmentCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSegment>>, TError,{id: number;data?: UpdateSegmentCommandDto}, TContext> => {

const mutationKey = ['updateSegment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSegment>>, {id: number;data?: UpdateSegmentCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSegment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSegmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateSegment>>>
    export type UpdateSegmentMutationBody = UpdateSegmentCommandDto | undefined
    export type UpdateSegmentMutationError = ProblemDetails

    export const useUpdateSegment = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSegment>>, TError,{id: number;data?: UpdateSegmentCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateSegment>>,
        TError,
        {id: number;data?: UpdateSegmentCommandDto},
        TContext
      > => {
      return useMutation(getUpdateSegmentMutationOptions(options), queryClient);
    }

export const getDeleteSegmentUrl = (id: number,) => {




  return `/admin/segments/${id}`
}

export const deleteSegment = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getDeleteSegmentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSegmentMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSegment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSegment>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSegment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSegment>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSegment(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSegmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSegment>>>

    export type DeleteSegmentMutationError = ProblemDetails

    export const useDeleteSegment = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSegment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteSegment>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSegmentMutationOptions(options), queryClient);
    }

export const getGetSegmentAudienceCountUrl = () => {




  return `/admin/segments/audience-count`
}

export const getSegmentAudienceCount = async (getSegmentAudienceCountQueryDto?: GetSegmentAudienceCountQueryDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetSegmentAudienceCountResult> => {

  return fetchWithAuth<GetSegmentAudienceCountResult>(getGetSegmentAudienceCountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(getSegmentAudienceCountQueryDto)
  }
);}





export const getGetSegmentAudienceCountMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSegmentAudienceCount>>, TError,{data?: GetSegmentAudienceCountQueryDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof getSegmentAudienceCount>>, TError,{data?: GetSegmentAudienceCountQueryDto}, TContext> => {

const mutationKey = ['getSegmentAudienceCount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSegmentAudienceCount>>, {data?: GetSegmentAudienceCountQueryDto}> = (props) => {
          const {data} = props ?? {};

          return  getSegmentAudienceCount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSegmentAudienceCountMutationResult = NonNullable<Awaited<ReturnType<typeof getSegmentAudienceCount>>>
    export type GetSegmentAudienceCountMutationBody = GetSegmentAudienceCountQueryDto | undefined
    export type GetSegmentAudienceCountMutationError = ProblemDetails

    export const useGetSegmentAudienceCount = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSegmentAudienceCount>>, TError,{data?: GetSegmentAudienceCountQueryDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof getSegmentAudienceCount>>,
        TError,
        {data?: GetSegmentAudienceCountQueryDto},
        TContext
      > => {
      return useMutation(getGetSegmentAudienceCountMutationOptions(options), queryClient);
    }

export const getSearchCandidatesForSegmentUrl = (params?: SearchCandidatesForSegmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/segments/candidates/search?${stringifiedParams}` : `/admin/segments/candidates/search`
}

export const searchCandidatesForSegment = async (params?: SearchCandidatesForSegmentParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SearchCandidatesForSegmentResult> => {

  return fetchWithAuth<SearchCandidatesForSegmentResult>(getSearchCandidatesForSegmentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchCandidatesForSegmentQueryKey = (params?: MaybeRefOrGetter<SearchCandidatesForSegmentParams>,) => {
    return [
    'admin','segments','candidates','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchCandidatesForSegmentQueryOptions = <TData = Awaited<ReturnType<typeof searchCandidatesForSegment>>, TError = unknown>(params?: MaybeRefOrGetter<SearchCandidatesForSegmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCandidatesForSegment>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSearchCandidatesForSegmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCandidatesForSegment>>> = ({ signal }) => searchCandidatesForSegment(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCandidatesForSegment>>, TError, TData>
}

export type SearchCandidatesForSegmentQueryResult = NonNullable<Awaited<ReturnType<typeof searchCandidatesForSegment>>>
export type SearchCandidatesForSegmentQueryError = unknown



export function useSearchCandidatesForSegment<TData = Awaited<ReturnType<typeof searchCandidatesForSegment>>, TError = unknown>(
 params?: MaybeRefOrGetter<SearchCandidatesForSegmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCandidatesForSegment>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchCandidatesForSegmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getSearchJobsForSegmentUrl = (params?: SearchJobsForSegmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/segments/jobs/search?${stringifiedParams}` : `/admin/segments/jobs/search`
}

export const searchJobsForSegment = async (params?: SearchJobsForSegmentParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SearchJobsForSegmentResult> => {

  return fetchWithAuth<SearchJobsForSegmentResult>(getSearchJobsForSegmentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchJobsForSegmentQueryKey = (params?: MaybeRefOrGetter<SearchJobsForSegmentParams>,) => {
    return [
    'admin','segments','jobs','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchJobsForSegmentQueryOptions = <TData = Awaited<ReturnType<typeof searchJobsForSegment>>, TError = unknown>(params?: MaybeRefOrGetter<SearchJobsForSegmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchJobsForSegment>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSearchJobsForSegmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchJobsForSegment>>> = ({ signal }) => searchJobsForSegment(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchJobsForSegment>>, TError, TData>
}

export type SearchJobsForSegmentQueryResult = NonNullable<Awaited<ReturnType<typeof searchJobsForSegment>>>
export type SearchJobsForSegmentQueryError = unknown



export function useSearchJobsForSegment<TData = Awaited<ReturnType<typeof searchJobsForSegment>>, TError = unknown>(
 params?: MaybeRefOrGetter<SearchJobsForSegmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchJobsForSegment>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchJobsForSegmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getSearchCompaniesForSegmentUrl = (params?: SearchCompaniesForSegmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/segments/companies/search?${stringifiedParams}` : `/admin/segments/companies/search`
}

export const searchCompaniesForSegment = async (params?: SearchCompaniesForSegmentParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SearchCompaniesForSegmentResult> => {

  return fetchWithAuth<SearchCompaniesForSegmentResult>(getSearchCompaniesForSegmentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchCompaniesForSegmentQueryKey = (params?: MaybeRefOrGetter<SearchCompaniesForSegmentParams>,) => {
    return [
    'admin','segments','companies','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchCompaniesForSegmentQueryOptions = <TData = Awaited<ReturnType<typeof searchCompaniesForSegment>>, TError = unknown>(params?: MaybeRefOrGetter<SearchCompaniesForSegmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCompaniesForSegment>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSearchCompaniesForSegmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCompaniesForSegment>>> = ({ signal }) => searchCompaniesForSegment(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCompaniesForSegment>>, TError, TData>
}

export type SearchCompaniesForSegmentQueryResult = NonNullable<Awaited<ReturnType<typeof searchCompaniesForSegment>>>
export type SearchCompaniesForSegmentQueryError = unknown



export function useSearchCompaniesForSegment<TData = Awaited<ReturnType<typeof searchCompaniesForSegment>>, TError = unknown>(
 params?: MaybeRefOrGetter<SearchCompaniesForSegmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCompaniesForSegment>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchCompaniesForSegmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminGetPersonaImportOptionsUrl = () => {




  return `/admin/persona-import/options`
}

export const adminGetPersonaImportOptions = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<PersonaImportOptions> => {

  return fetchWithAuth<PersonaImportOptions>(getAdminGetPersonaImportOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetPersonaImportOptionsQueryKey = () => {
    return [
    'admin','persona-import','options'
    ] as const;
    }


export const getAdminGetPersonaImportOptionsQueryOptions = <TData = Awaited<ReturnType<typeof adminGetPersonaImportOptions>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetPersonaImportOptions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetPersonaImportOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetPersonaImportOptions>>> = ({ signal }) => adminGetPersonaImportOptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetPersonaImportOptions>>, TError, TData>
}

export type AdminGetPersonaImportOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetPersonaImportOptions>>>
export type AdminGetPersonaImportOptionsQueryError = ProblemDetails



export function useAdminGetPersonaImportOptions<TData = Awaited<ReturnType<typeof adminGetPersonaImportOptions>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetPersonaImportOptions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetPersonaImportOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminInspectPersonaCsvUrl = () => {




  return `/admin/persona-import/inspect`
}

export const adminInspectPersonaCsv = async (adminInspectPersonaCsvBody?: AdminInspectPersonaCsvBody, options?: Parameters<typeof fetchWithAuth>[1]): Promise<PersonaImportInspectResult> => {
    const formData = new FormData();
if(adminInspectPersonaCsvBody?.Csv !== undefined) {
 formData.append(`Csv`, adminInspectPersonaCsvBody.Csv);
 }

  return fetchWithAuth<PersonaImportInspectResult>(getAdminInspectPersonaCsvUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAdminInspectPersonaCsvMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInspectPersonaCsv>>, TError,{data?: AdminInspectPersonaCsvBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminInspectPersonaCsv>>, TError,{data?: AdminInspectPersonaCsvBody}, TContext> => {

const mutationKey = ['adminInspectPersonaCsv'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminInspectPersonaCsv>>, {data?: AdminInspectPersonaCsvBody}> = (props) => {
          const {data} = props ?? {};

          return  adminInspectPersonaCsv(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminInspectPersonaCsvMutationResult = NonNullable<Awaited<ReturnType<typeof adminInspectPersonaCsv>>>
    export type AdminInspectPersonaCsvMutationBody = AdminInspectPersonaCsvBody | undefined
    export type AdminInspectPersonaCsvMutationError = ProblemDetails

    export const useAdminInspectPersonaCsv = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminInspectPersonaCsv>>, TError,{data?: AdminInspectPersonaCsvBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminInspectPersonaCsv>>,
        TError,
        {data?: AdminInspectPersonaCsvBody},
        TContext
      > => {
      return useMutation(getAdminInspectPersonaCsvMutationOptions(options), queryClient);
    }

export const getAdminImportPersonasUrl = () => {




  return `/admin/persona-import/import`
}

export const adminImportPersonas = async (adminImportPersonasBody?: AdminImportPersonasBody, options?: Parameters<typeof fetchWithAuth>[1]): Promise<PersonaImportResult> => {
    const formData = new FormData();
if(adminImportPersonasBody?.Csv !== undefined) {
 formData.append(`Csv`, adminImportPersonasBody.Csv);
 }
if(adminImportPersonasBody?.Mapping !== undefined) {
 formData.append(`Mapping`, adminImportPersonasBody.Mapping);
 }

  return fetchWithAuth<PersonaImportResult>(getAdminImportPersonasUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAdminImportPersonasMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminImportPersonas>>, TError,{data?: AdminImportPersonasBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminImportPersonas>>, TError,{data?: AdminImportPersonasBody}, TContext> => {

const mutationKey = ['adminImportPersonas'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminImportPersonas>>, {data?: AdminImportPersonasBody}> = (props) => {
          const {data} = props ?? {};

          return  adminImportPersonas(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminImportPersonasMutationResult = NonNullable<Awaited<ReturnType<typeof adminImportPersonas>>>
    export type AdminImportPersonasMutationBody = AdminImportPersonasBody | undefined
    export type AdminImportPersonasMutationError = ProblemDetails

    export const useAdminImportPersonas = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminImportPersonas>>, TError,{data?: AdminImportPersonasBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminImportPersonas>>,
        TError,
        {data?: AdminImportPersonasBody},
        TContext
      > => {
      return useMutation(getAdminImportPersonasMutationOptions(options), queryClient);
    }

export const getListMatchingSimulationsUrl = () => {




  return `/admin/matching/simulations`
}

export const listMatchingSimulations = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListMatchingSimulationsResult> => {

  return fetchWithAuth<ListMatchingSimulationsResult>(getListMatchingSimulationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMatchingSimulationsQueryKey = () => {
    return [
    'admin','matching','simulations'
    ] as const;
    }


export const getListMatchingSimulationsQueryOptions = <TData = Awaited<ReturnType<typeof listMatchingSimulations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchingSimulations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListMatchingSimulationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMatchingSimulations>>> = ({ signal }) => listMatchingSimulations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMatchingSimulations>>, TError, TData>
}

export type ListMatchingSimulationsQueryResult = NonNullable<Awaited<ReturnType<typeof listMatchingSimulations>>>
export type ListMatchingSimulationsQueryError = unknown



export function useListMatchingSimulations<TData = Awaited<ReturnType<typeof listMatchingSimulations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchingSimulations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMatchingSimulationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getCreateMatchingSimulationUrl = () => {




  return `/admin/matching/simulations`
}

export const createMatchingSimulation = async (createMatchingSimulationCommandDto?: CreateMatchingSimulationCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateMatchingSimulationResult> => {

  return fetchWithAuth<CreateMatchingSimulationResult>(getCreateMatchingSimulationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMatchingSimulationCommandDto)
  }
);}





export const getCreateMatchingSimulationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMatchingSimulation>>, TError,{data?: CreateMatchingSimulationCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createMatchingSimulation>>, TError,{data?: CreateMatchingSimulationCommandDto}, TContext> => {

const mutationKey = ['createMatchingSimulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMatchingSimulation>>, {data?: CreateMatchingSimulationCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  createMatchingSimulation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMatchingSimulationMutationResult = NonNullable<Awaited<ReturnType<typeof createMatchingSimulation>>>
    export type CreateMatchingSimulationMutationBody = CreateMatchingSimulationCommandDto | undefined
    export type CreateMatchingSimulationMutationError = ProblemDetails

    export const useCreateMatchingSimulation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMatchingSimulation>>, TError,{data?: CreateMatchingSimulationCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMatchingSimulation>>,
        TError,
        {data?: CreateMatchingSimulationCommandDto},
        TContext
      > => {
      return useMutation(getCreateMatchingSimulationMutationOptions(options), queryClient);
    }

export const getGetMatchingSimulationUrl = (id: number,) => {




  return `/admin/matching/simulations/${id}`
}

export const getMatchingSimulation = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetMatchingSimulationResult> => {

  return fetchWithAuth<GetMatchingSimulationResult>(getGetMatchingSimulationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMatchingSimulationQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','matching','simulations',id
    ] as const;
    }


export const getGetMatchingSimulationQueryOptions = <TData = Awaited<ReturnType<typeof getMatchingSimulation>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchingSimulation>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMatchingSimulationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchingSimulation>>> = ({ signal }) => getMatchingSimulation(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMatchingSimulation>>, TError, TData>
}

export type GetMatchingSimulationQueryResult = NonNullable<Awaited<ReturnType<typeof getMatchingSimulation>>>
export type GetMatchingSimulationQueryError = ProblemDetails



export function useGetMatchingSimulation<TData = Awaited<ReturnType<typeof getMatchingSimulation>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchingSimulation>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMatchingSimulationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getDeleteMatchingSimulationUrl = (id: number,) => {




  return `/admin/matching/simulations/${id}`
}

export const deleteMatchingSimulation = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getDeleteMatchingSimulationUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteMatchingSimulationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMatchingSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMatchingSimulation>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteMatchingSimulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMatchingSimulation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteMatchingSimulation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMatchingSimulationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMatchingSimulation>>>

    export type DeleteMatchingSimulationMutationError = ProblemDetails

    export const useDeleteMatchingSimulation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMatchingSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteMatchingSimulation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteMatchingSimulationMutationOptions(options), queryClient);
    }

export const getRunMatchingSimulationUrl = (id: number,) => {




  return `/admin/matching/simulations/${id}/run`
}

export const runMatchingSimulation = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getRunMatchingSimulationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRunMatchingSimulationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runMatchingSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof runMatchingSimulation>>, TError,{id: number}, TContext> => {

const mutationKey = ['runMatchingSimulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runMatchingSimulation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  runMatchingSimulation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunMatchingSimulationMutationResult = NonNullable<Awaited<ReturnType<typeof runMatchingSimulation>>>

    export type RunMatchingSimulationMutationError = ProblemDetails

    export const useRunMatchingSimulation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runMatchingSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof runMatchingSimulation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRunMatchingSimulationMutationOptions(options), queryClient);
    }

export const getDeleteMatchingSimulationScoresUrl = (id: number,) => {




  return `/admin/matching/simulations/${id}/scores`
}

export const deleteMatchingSimulationScores = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<DeleteMatchingSimulationScoresResult> => {

  return fetchWithAuth<DeleteMatchingSimulationScoresResult>(getDeleteMatchingSimulationScoresUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteMatchingSimulationScoresMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMatchingSimulationScores>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMatchingSimulationScores>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteMatchingSimulationScores'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMatchingSimulationScores>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteMatchingSimulationScores(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMatchingSimulationScoresMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMatchingSimulationScores>>>

    export type DeleteMatchingSimulationScoresMutationError = ProblemDetails

    export const useDeleteMatchingSimulationScores = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMatchingSimulationScores>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteMatchingSimulationScores>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteMatchingSimulationScoresMutationOptions(options), queryClient);
    }

export const getCancelMatchingSimulationUrl = (id: number,) => {




  return `/admin/matching/simulations/${id}/cancel`
}

export const cancelMatchingSimulation = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CancelMatchingSimulationResult> => {

  return fetchWithAuth<CancelMatchingSimulationResult>(getCancelMatchingSimulationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelMatchingSimulationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelMatchingSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelMatchingSimulation>>, TError,{id: number}, TContext> => {

const mutationKey = ['cancelMatchingSimulation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelMatchingSimulation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  cancelMatchingSimulation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelMatchingSimulationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelMatchingSimulation>>>

    export type CancelMatchingSimulationMutationError = ProblemDetails

    export const useCancelMatchingSimulation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelMatchingSimulation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelMatchingSimulation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCancelMatchingSimulationMutationOptions(options), queryClient);
    }

export const getGetMatchingSimulationStatusUrl = (id: number,) => {




  return `/admin/matching/simulations/${id}/status`
}

export const getMatchingSimulationStatus = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetMatchingSimulationStatusResult> => {

  return fetchWithAuth<GetMatchingSimulationStatusResult>(getGetMatchingSimulationStatusUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMatchingSimulationStatusQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','matching','simulations',id,'status'
    ] as const;
    }


export const getGetMatchingSimulationStatusQueryOptions = <TData = Awaited<ReturnType<typeof getMatchingSimulationStatus>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchingSimulationStatus>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMatchingSimulationStatusQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchingSimulationStatus>>> = ({ signal }) => getMatchingSimulationStatus(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMatchingSimulationStatus>>, TError, TData>
}

export type GetMatchingSimulationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getMatchingSimulationStatus>>>
export type GetMatchingSimulationStatusQueryError = ProblemDetails



export function useGetMatchingSimulationStatus<TData = Awaited<ReturnType<typeof getMatchingSimulationStatus>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchingSimulationStatus>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMatchingSimulationStatusQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminSimulationMatchScoresUrl = (id: number,
    params?: ListAdminSimulationMatchScoresParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/matching/simulations/${id}/match-scores?${stringifiedParams}` : `/admin/matching/simulations/${id}/match-scores`
}

export const listAdminSimulationMatchScores = async (id: number,
    params?: ListAdminSimulationMatchScoresParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminSimulationMatchScoresResult> => {

  return fetchWithAuth<ListAdminSimulationMatchScoresResult>(getListAdminSimulationMatchScoresUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminSimulationMatchScoresQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAdminSimulationMatchScoresParams>,) => {
    return [
    'admin','matching','simulations',id,'match-scores', ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminSimulationMatchScoresQueryOptions = <TData = Awaited<ReturnType<typeof listAdminSimulationMatchScores>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAdminSimulationMatchScoresParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSimulationMatchScores>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminSimulationMatchScoresQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminSimulationMatchScores>>> = ({ signal }) => listAdminSimulationMatchScores(toValue(id),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminSimulationMatchScores>>, TError, TData>
}

export type ListAdminSimulationMatchScoresQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminSimulationMatchScores>>>
export type ListAdminSimulationMatchScoresQueryError = ProblemDetails



export function useListAdminSimulationMatchScores<TData = Awaited<ReturnType<typeof listAdminSimulationMatchScores>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAdminSimulationMatchScoresParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminSimulationMatchScores>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminSimulationMatchScoresQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListSimulationCandidatesUrl = (id: number,
    params?: ListSimulationCandidatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["userSegmentIds","jobSegmentIds","companySegmentIds","userIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/matching/simulations/${id}/candidates?${stringifiedParams}` : `/admin/matching/simulations/${id}/candidates`
}

export const listSimulationCandidates = async (id: number,
    params?: ListSimulationCandidatesParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSimulationCandidatesResult> => {

  return fetchWithAuth<ListSimulationCandidatesResult>(getListSimulationCandidatesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSimulationCandidatesQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListSimulationCandidatesParams>,) => {
    return [
    'admin','matching','simulations',id,'candidates', ...(params ? [params] : [])
    ] as const;
    }


export const getListSimulationCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listSimulationCandidates>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListSimulationCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSimulationCandidates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListSimulationCandidatesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSimulationCandidates>>> = ({ signal }) => listSimulationCandidates(toValue(id),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSimulationCandidates>>, TError, TData>
}

export type ListSimulationCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listSimulationCandidates>>>
export type ListSimulationCandidatesQueryError = ProblemDetails



export function useListSimulationCandidates<TData = Awaited<ReturnType<typeof listSimulationCandidates>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListSimulationCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSimulationCandidates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSimulationCandidatesQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListSimulationJobsUrl = (id: number,
    params?: ListSimulationJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["userSegmentIds","jobSegmentIds","companySegmentIds","jobIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/matching/simulations/${id}/jobs?${stringifiedParams}` : `/admin/matching/simulations/${id}/jobs`
}

export const listSimulationJobs = async (id: number,
    params?: ListSimulationJobsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSimulationJobsResult> => {

  return fetchWithAuth<ListSimulationJobsResult>(getListSimulationJobsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSimulationJobsQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListSimulationJobsParams>,) => {
    return [
    'admin','matching','simulations',id,'jobs', ...(params ? [params] : [])
    ] as const;
    }


export const getListSimulationJobsQueryOptions = <TData = Awaited<ReturnType<typeof listSimulationJobs>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListSimulationJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSimulationJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListSimulationJobsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSimulationJobs>>> = ({ signal }) => listSimulationJobs(toValue(id),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSimulationJobs>>, TError, TData>
}

export type ListSimulationJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listSimulationJobs>>>
export type ListSimulationJobsQueryError = ProblemDetails



export function useListSimulationJobs<TData = Awaited<ReturnType<typeof listSimulationJobs>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListSimulationJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSimulationJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSimulationJobsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetMatchingSimulationStatisticsUrl = (id: number,
    params?: GetMatchingSimulationStatisticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["userSegmentIds","jobSegmentIds","companySegmentIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/matching/simulations/${id}/statistics?${stringifiedParams}` : `/admin/matching/simulations/${id}/statistics`
}

export const getMatchingSimulationStatistics = async (id: number,
    params?: GetMatchingSimulationStatisticsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetMatchingSimulationStatisticsResult> => {

  return fetchWithAuth<GetMatchingSimulationStatisticsResult>(getGetMatchingSimulationStatisticsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMatchingSimulationStatisticsQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetMatchingSimulationStatisticsParams>,) => {
    return [
    'admin','matching','simulations',id,'statistics', ...(params ? [params] : [])
    ] as const;
    }


export const getGetMatchingSimulationStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getMatchingSimulationStatistics>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetMatchingSimulationStatisticsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchingSimulationStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMatchingSimulationStatisticsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchingSimulationStatistics>>> = ({ signal }) => getMatchingSimulationStatistics(toValue(id),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMatchingSimulationStatistics>>, TError, TData>
}

export type GetMatchingSimulationStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getMatchingSimulationStatistics>>>
export type GetMatchingSimulationStatisticsQueryError = ProblemDetails



export function useGetMatchingSimulationStatistics<TData = Awaited<ReturnType<typeof getMatchingSimulationStatistics>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetMatchingSimulationStatisticsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchingSimulationStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMatchingSimulationStatisticsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getStreamSimulationLogsUrl = (id: number,) => {




  return `/admin/matching/simulations/${id}/logs/stream`
}

/**
 * @summary Streams simulation log messages as Server-Sent Events. The stream closes automatically
when the simulation completes or the client disconnects.
 */
export const streamSimulationLogs = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getStreamSimulationLogsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStreamSimulationLogsQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','matching','simulations',id,'logs','stream'
    ] as const;
    }


export const getStreamSimulationLogsQueryOptions = <TData = Awaited<ReturnType<typeof streamSimulationLogs>>, TError = unknown>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamSimulationLogs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getStreamSimulationLogsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamSimulationLogs>>> = ({ signal }) => streamSimulationLogs(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamSimulationLogs>>, TError, TData>
}

export type StreamSimulationLogsQueryResult = NonNullable<Awaited<ReturnType<typeof streamSimulationLogs>>>
export type StreamSimulationLogsQueryError = unknown


/**
 * @summary Streams simulation log messages as Server-Sent Events. The stream closes automatically
when the simulation completes or the client disconnects.
 */

export function useStreamSimulationLogs<TData = Awaited<ReturnType<typeof streamSimulationLogs>>, TError = unknown>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamSimulationLogs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStreamSimulationLogsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminAlgorithmVersionsUrl = () => {




  return `/admin/matching/algorithm-versions`
}

export const listAdminAlgorithmVersions = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminAlgorithmVersionsResult> => {

  return fetchWithAuth<ListAdminAlgorithmVersionsResult>(getListAdminAlgorithmVersionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminAlgorithmVersionsQueryKey = () => {
    return [
    'admin','matching','algorithm-versions'
    ] as const;
    }


export const getListAdminAlgorithmVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminAlgorithmVersions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAlgorithmVersions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminAlgorithmVersionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAlgorithmVersions>>> = ({ signal }) => listAdminAlgorithmVersions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminAlgorithmVersions>>, TError, TData>
}

export type ListAdminAlgorithmVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminAlgorithmVersions>>>
export type ListAdminAlgorithmVersionsQueryError = unknown



export function useListAdminAlgorithmVersions<TData = Awaited<ReturnType<typeof listAdminAlgorithmVersions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAlgorithmVersions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminAlgorithmVersionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminAlgorithmVersionGroupsUrl = () => {




  return `/admin/matching/algorithm-version-groups`
}

export const listAdminAlgorithmVersionGroups = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminAlgorithmVersionGroupsResult> => {

  return fetchWithAuth<ListAdminAlgorithmVersionGroupsResult>(getListAdminAlgorithmVersionGroupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminAlgorithmVersionGroupsQueryKey = () => {
    return [
    'admin','matching','algorithm-version-groups'
    ] as const;
    }


export const getListAdminAlgorithmVersionGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminAlgorithmVersionGroups>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAlgorithmVersionGroups>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminAlgorithmVersionGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAlgorithmVersionGroups>>> = ({ signal }) => listAdminAlgorithmVersionGroups({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminAlgorithmVersionGroups>>, TError, TData>
}

export type ListAdminAlgorithmVersionGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminAlgorithmVersionGroups>>>
export type ListAdminAlgorithmVersionGroupsQueryError = unknown



export function useListAdminAlgorithmVersionGroups<TData = Awaited<ReturnType<typeof listAdminAlgorithmVersionGroups>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAlgorithmVersionGroups>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminAlgorithmVersionGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminAlgorithmVersionUrl = (id: number,) => {




  return `/admin/matching/algorithm-versions/${id}`
}

export const getAdminAlgorithmVersion = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminAlgorithmVersionResult> => {

  return fetchWithAuth<GetAdminAlgorithmVersionResult>(getGetAdminAlgorithmVersionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAlgorithmVersionQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','matching','algorithm-versions',id
    ] as const;
    }


export const getGetAdminAlgorithmVersionQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAlgorithmVersion>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAlgorithmVersion>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminAlgorithmVersionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAlgorithmVersion>>> = ({ signal }) => getAdminAlgorithmVersion(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAlgorithmVersion>>, TError, TData>
}

export type GetAdminAlgorithmVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAlgorithmVersion>>>
export type GetAdminAlgorithmVersionQueryError = ProblemDetails



export function useGetAdminAlgorithmVersion<TData = Awaited<ReturnType<typeof getAdminAlgorithmVersion>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAlgorithmVersion>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAlgorithmVersionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminAlgorithmVersionMatchScoresUrl = (id: number,) => {




  return `/admin/matching/algorithm-versions/${id}/match-scores`
}

export const listAdminAlgorithmVersionMatchScores = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminAlgorithmVersionMatchScoresResult> => {

  return fetchWithAuth<ListAdminAlgorithmVersionMatchScoresResult>(getListAdminAlgorithmVersionMatchScoresUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminAlgorithmVersionMatchScoresQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','matching','algorithm-versions',id,'match-scores'
    ] as const;
    }


export const getListAdminAlgorithmVersionMatchScoresQueryOptions = <TData = Awaited<ReturnType<typeof listAdminAlgorithmVersionMatchScores>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAlgorithmVersionMatchScores>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminAlgorithmVersionMatchScoresQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAlgorithmVersionMatchScores>>> = ({ signal }) => listAdminAlgorithmVersionMatchScores(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminAlgorithmVersionMatchScores>>, TError, TData>
}

export type ListAdminAlgorithmVersionMatchScoresQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminAlgorithmVersionMatchScores>>>
export type ListAdminAlgorithmVersionMatchScoresQueryError = ProblemDetails



export function useListAdminAlgorithmVersionMatchScores<TData = Awaited<ReturnType<typeof listAdminAlgorithmVersionMatchScores>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAlgorithmVersionMatchScores>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminAlgorithmVersionMatchScoresQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminAlgorithmVersionStatisticsUrl = (id: number,
    params?: GetAdminAlgorithmVersionStatisticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/matching/algorithm-versions/${id}/statistics?${stringifiedParams}` : `/admin/matching/algorithm-versions/${id}/statistics`
}

export const getAdminAlgorithmVersionStatistics = async (id: number,
    params?: GetAdminAlgorithmVersionStatisticsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminAlgorithmVersionStatisticsResult> => {

  return fetchWithAuth<GetAdminAlgorithmVersionStatisticsResult>(getGetAdminAlgorithmVersionStatisticsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAlgorithmVersionStatisticsQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminAlgorithmVersionStatisticsParams>,) => {
    return [
    'admin','matching','algorithm-versions',id,'statistics', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminAlgorithmVersionStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAlgorithmVersionStatistics>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminAlgorithmVersionStatisticsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAlgorithmVersionStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminAlgorithmVersionStatisticsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAlgorithmVersionStatistics>>> = ({ signal }) => getAdminAlgorithmVersionStatistics(toValue(id),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAlgorithmVersionStatistics>>, TError, TData>
}

export type GetAdminAlgorithmVersionStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAlgorithmVersionStatistics>>>
export type GetAdminAlgorithmVersionStatisticsQueryError = ProblemDetails



export function useGetAdminAlgorithmVersionStatistics<TData = Awaited<ReturnType<typeof getAdminAlgorithmVersionStatistics>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminAlgorithmVersionStatisticsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAlgorithmVersionStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAlgorithmVersionStatisticsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminMatchScoreUrl = (matchScoreId: number,
    params?: GetAdminMatchScoreParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/matching/match-scores/${matchScoreId}?${stringifiedParams}` : `/admin/matching/match-scores/${matchScoreId}`
}

export const getAdminMatchScore = async (matchScoreId: number,
    params?: GetAdminMatchScoreParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminMatchScoreResult> => {

  return fetchWithAuth<GetAdminMatchScoreResult>(getGetAdminMatchScoreUrl(matchScoreId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminMatchScoreQueryKey = (matchScoreId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminMatchScoreParams>,) => {
    return [
    'admin','matching','match-scores',matchScoreId, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminMatchScoreQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMatchScore>>, TError = ProblemDetails>(matchScoreId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminMatchScoreParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchScore>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminMatchScoreQueryKey(matchScoreId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMatchScore>>> = ({ signal }) => getAdminMatchScore(toValue(matchScoreId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(matchScoreId) !== null && toValue(matchScoreId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchScore>>, TError, TData>
}

export type GetAdminMatchScoreQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMatchScore>>>
export type GetAdminMatchScoreQueryError = ProblemDetails



export function useGetAdminMatchScore<TData = Awaited<ReturnType<typeof getAdminMatchScore>>, TError = ProblemDetails>(
 matchScoreId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminMatchScoreParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchScore>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMatchScoreQueryOptions(matchScoreId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminLocationsUrl = (scope: LocationSearchScope,
    params?: ListAdminLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-locations/${scope}?${stringifiedParams}` : `/admin/admin-locations/${scope}`
}

export const listAdminLocations = async (scope: LocationSearchScope,
    params?: ListAdminLocationsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SearchAdminLocationsResult> => {

  return fetchWithAuth<SearchAdminLocationsResult>(getListAdminLocationsUrl(scope,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminLocationsQueryKey = (scope: MaybeRefOrGetter<LocationSearchScope>,
    params?: MaybeRefOrGetter<ListAdminLocationsParams>,) => {
    return [
    'admin','admin-locations',scope, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminLocationsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminLocations>>, TError = unknown>(scope: MaybeRefOrGetter<LocationSearchScope>,
    params?: MaybeRefOrGetter<ListAdminLocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminLocations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminLocationsQueryKey(scope,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminLocations>>> = ({ signal }) => listAdminLocations(toValue(scope),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(scope) !== null && toValue(scope) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminLocations>>, TError, TData>
}

export type ListAdminLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminLocations>>>
export type ListAdminLocationsQueryError = unknown



export function useListAdminLocations<TData = Awaited<ReturnType<typeof listAdminLocations>>, TError = unknown>(
 scope: MaybeRefOrGetter<LocationSearchScope>,
    params?: MaybeRefOrGetter<ListAdminLocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminLocations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminLocationsQueryOptions(scope,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getSearchAdminLocationsUrl = (scope: LocationSearchScope,
    params?: SearchAdminLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-locations/${scope}/search?${stringifiedParams}` : `/admin/admin-locations/${scope}/search`
}

export const searchAdminLocations = async (scope: LocationSearchScope,
    params?: SearchAdminLocationsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SearchAdminLocationsResult> => {

  return fetchWithAuth<SearchAdminLocationsResult>(getSearchAdminLocationsUrl(scope,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchAdminLocationsQueryKey = (scope: MaybeRefOrGetter<LocationSearchScope>,
    params?: MaybeRefOrGetter<SearchAdminLocationsParams>,) => {
    return [
    'admin','admin-locations',scope,'search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchAdminLocationsQueryOptions = <TData = Awaited<ReturnType<typeof searchAdminLocations>>, TError = unknown>(scope: MaybeRefOrGetter<LocationSearchScope>,
    params?: MaybeRefOrGetter<SearchAdminLocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdminLocations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSearchAdminLocationsQueryKey(scope,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAdminLocations>>> = ({ signal }) => searchAdminLocations(toValue(scope),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(scope) !== null && toValue(scope) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchAdminLocations>>, TError, TData>
}

export type SearchAdminLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof searchAdminLocations>>>
export type SearchAdminLocationsQueryError = unknown



export function useSearchAdminLocations<TData = Awaited<ReturnType<typeof searchAdminLocations>>, TError = unknown>(
 scope: MaybeRefOrGetter<LocationSearchScope>,
    params?: MaybeRefOrGetter<SearchAdminLocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdminLocations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchAdminLocationsQueryOptions(scope,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getSearchAdminJobsUrl = (params?: SearchAdminJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["statuses","jobCategoryIds","jobFunctionIds","experienceLevels","companyIds","educationLevelIds","preferredCharacteristicColors","candidatePoolSizes"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-job/search?${stringifiedParams}` : `/admin/admin-job/search`
}

/**
 * @summary Search and filter jobs for admin overview
 */
export const searchAdminJobs = async (params?: SearchAdminJobsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SearchAdminJobsResult> => {

  return fetchWithAuth<SearchAdminJobsResult>(getSearchAdminJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchAdminJobsQueryKey = (params?: MaybeRefOrGetter<SearchAdminJobsParams>,) => {
    return [
    'admin','admin-job','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchAdminJobsQueryOptions = <TData = Awaited<ReturnType<typeof searchAdminJobs>>, TError = unknown>(params?: MaybeRefOrGetter<SearchAdminJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdminJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSearchAdminJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAdminJobs>>> = ({ signal }) => searchAdminJobs(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchAdminJobs>>, TError, TData>
}

export type SearchAdminJobsQueryResult = NonNullable<Awaited<ReturnType<typeof searchAdminJobs>>>
export type SearchAdminJobsQueryError = unknown


/**
 * @summary Search and filter jobs for admin overview
 */

export function useSearchAdminJobs<TData = Awaited<ReturnType<typeof searchAdminJobs>>, TError = unknown>(
 params?: MaybeRefOrGetter<SearchAdminJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdminJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchAdminJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminJobUrl = (id: number,) => {




  return `/admin/admin-job/${id}`
}

/**
 * @summary Get full job details for admin
 */
export const getAdminJob = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminJobResult> => {

  return fetchWithAuth<GetAdminJobResult>(getGetAdminJobUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminJobQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','admin-job',id
    ] as const;
    }


export const getGetAdminJobQueryOptions = <TData = Awaited<ReturnType<typeof getAdminJob>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminJobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminJob>>> = ({ signal }) => getAdminJob(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminJob>>, TError, TData>
}

export type GetAdminJobQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminJob>>>
export type GetAdminJobQueryError = ProblemDetails


/**
 * @summary Get full job details for admin
 */

export function useGetAdminJob<TData = Awaited<ReturnType<typeof getAdminJob>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminJobQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getUpdateAdminJobUrl = (id: number,) => {




  return `/admin/admin-job/${id}`
}

/**
 * @summary Update a job from admin
 */
export const updateAdminJob = async (id: number,
    updateAdminJobCommandDto?: UpdateAdminJobCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

  return fetchWithAuth<number>(getUpdateAdminJobUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAdminJobCommandDto)
  }
);}





export const getUpdateAdminJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminJob>>, TError,{id: number;data?: UpdateAdminJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminJob>>, TError,{id: number;data?: UpdateAdminJobCommandDto}, TContext> => {

const mutationKey = ['updateAdminJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminJob>>, {id: number;data?: UpdateAdminJobCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAdminJob(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminJobMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminJob>>>
    export type UpdateAdminJobMutationBody = UpdateAdminJobCommandDto | undefined
    export type UpdateAdminJobMutationError = ProblemDetails

    /**
 * @summary Update a job from admin
 */
export const useUpdateAdminJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminJob>>, TError,{id: number;data?: UpdateAdminJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAdminJob>>,
        TError,
        {id: number;data?: UpdateAdminJobCommandDto},
        TContext
      > => {
      return useMutation(getUpdateAdminJobMutationOptions(options), queryClient);
    }

export const getListAdminJobMatchScoresUrl = (id: number,) => {




  return `/admin/admin-job/${id}/match-scores`
}

/**
 * @summary List all match scores for a job
 */
export const listAdminJobMatchScores = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminJobMatchScoresResult> => {

  return fetchWithAuth<ListAdminJobMatchScoresResult>(getListAdminJobMatchScoresUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminJobMatchScoresQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','admin-job',id,'match-scores'
    ] as const;
    }


export const getListAdminJobMatchScoresQueryOptions = <TData = Awaited<ReturnType<typeof listAdminJobMatchScores>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminJobMatchScores>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminJobMatchScoresQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminJobMatchScores>>> = ({ signal }) => listAdminJobMatchScores(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminJobMatchScores>>, TError, TData>
}

export type ListAdminJobMatchScoresQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminJobMatchScores>>>
export type ListAdminJobMatchScoresQueryError = ProblemDetails


/**
 * @summary List all match scores for a job
 */

export function useListAdminJobMatchScores<TData = Awaited<ReturnType<typeof listAdminJobMatchScores>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminJobMatchScores>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminJobMatchScoresQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminJobApplicationsUrl = (id: number,
    params?: ListAdminJobApplicationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["statuses","matchStatuses","experienceLevels","educationLevelIds","jobCategoryIds","jobFunctionIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-job/${id}/job-applications?${stringifiedParams}` : `/admin/admin-job/${id}/job-applications`
}

/**
 * @summary List all job applications for a job (excludes left-swipes), optionally filtered.
 */
export const listAdminJobApplications = async (id: number,
    params?: ListAdminJobApplicationsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminJobApplicationsResult> => {

  return fetchWithAuth<ListAdminJobApplicationsResult>(getListAdminJobApplicationsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminJobApplicationsQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAdminJobApplicationsParams>,) => {
    return [
    'admin','admin-job',id,'job-applications', ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminJobApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminJobApplications>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAdminJobApplicationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminJobApplications>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminJobApplicationsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminJobApplications>>> = ({ signal }) => listAdminJobApplications(toValue(id),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminJobApplications>>, TError, TData>
}

export type ListAdminJobApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminJobApplications>>>
export type ListAdminJobApplicationsQueryError = ProblemDetails


/**
 * @summary List all job applications for a job (excludes left-swipes), optionally filtered.
 */

export function useListAdminJobApplications<TData = Awaited<ReturnType<typeof listAdminJobApplications>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAdminJobApplicationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminJobApplications>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminJobApplicationsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminJobStatisticsUrl = (id: number,) => {




  return `/admin/admin-job/${id}/statistics`
}

/**
 * @summary Get statistics for a job
 */
export const getAdminJobStatistics = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminJobStatisticsResult> => {

  return fetchWithAuth<GetAdminJobStatisticsResult>(getGetAdminJobStatisticsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminJobStatisticsQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','admin-job',id,'statistics'
    ] as const;
    }


export const getGetAdminJobStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminJobStatistics>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminJobStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminJobStatisticsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminJobStatistics>>> = ({ signal }) => getAdminJobStatistics(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminJobStatistics>>, TError, TData>
}

export type GetAdminJobStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminJobStatistics>>>
export type GetAdminJobStatisticsQueryError = ProblemDetails


/**
 * @summary Get statistics for a job
 */

export function useGetAdminJobStatistics<TData = Awaited<ReturnType<typeof getAdminJobStatistics>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminJobStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminJobStatisticsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminJobMatchScoreStatisticsUrl = (id: number,
    params?: GetAdminJobMatchScoreStatisticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["userSegmentIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-job/${id}/match-score-statistics?${stringifiedParams}` : `/admin/admin-job/${id}/match-score-statistics`
}

/**
 * @summary Match-score statistics for a job, grouped per algorithm version
 */
export const getAdminJobMatchScoreStatistics = async (id: number,
    params?: GetAdminJobMatchScoreStatisticsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminJobMatchScoreStatisticsResult> => {

  return fetchWithAuth<GetAdminJobMatchScoreStatisticsResult>(getGetAdminJobMatchScoreStatisticsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminJobMatchScoreStatisticsQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminJobMatchScoreStatisticsParams>,) => {
    return [
    'admin','admin-job',id,'match-score-statistics', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminJobMatchScoreStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminJobMatchScoreStatistics>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminJobMatchScoreStatisticsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminJobMatchScoreStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminJobMatchScoreStatisticsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminJobMatchScoreStatistics>>> = ({ signal }) => getAdminJobMatchScoreStatistics(toValue(id),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminJobMatchScoreStatistics>>, TError, TData>
}

export type GetAdminJobMatchScoreStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminJobMatchScoreStatistics>>>
export type GetAdminJobMatchScoreStatisticsQueryError = ProblemDetails


/**
 * @summary Match-score statistics for a job, grouped per algorithm version
 */

export function useGetAdminJobMatchScoreStatistics<TData = Awaited<ReturnType<typeof getAdminJobMatchScoreStatistics>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminJobMatchScoreStatisticsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminJobMatchScoreStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminJobMatchScoreStatisticsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminJobStackComparisonUrl = (id: number,
    params?: GetAdminJobStackComparisonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["userSegmentIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-job/${id}/stack-comparison?${stringifiedParams}` : `/admin/admin-job/${id}/stack-comparison`
}

/**
 * @summary Compare the candidate stack a job sees between two algorithm versions
 */
export const getAdminJobStackComparison = async (id: number,
    params?: GetAdminJobStackComparisonParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminJobStackComparisonResult> => {

  return fetchWithAuth<GetAdminJobStackComparisonResult>(getGetAdminJobStackComparisonUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminJobStackComparisonQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminJobStackComparisonParams>,) => {
    return [
    'admin','admin-job',id,'stack-comparison', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminJobStackComparisonQueryOptions = <TData = Awaited<ReturnType<typeof getAdminJobStackComparison>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminJobStackComparisonParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminJobStackComparison>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminJobStackComparisonQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminJobStackComparison>>> = ({ signal }) => getAdminJobStackComparison(toValue(id),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminJobStackComparison>>, TError, TData>
}

export type GetAdminJobStackComparisonQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminJobStackComparison>>>
export type GetAdminJobStackComparisonQueryError = ProblemDetails


/**
 * @summary Compare the candidate stack a job sees between two algorithm versions
 */

export function useGetAdminJobStackComparison<TData = Awaited<ReturnType<typeof getAdminJobStackComparison>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminJobStackComparisonParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminJobStackComparison>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminJobStackComparisonQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getRepublishAdminJobUrl = (id: number,) => {




  return `/admin/admin-job/${id}/republish`
}

/**
 * @summary Republish a job from admin — bypasses job slot checks
 */
export const republishAdminJob = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

  return fetchWithAuth<number>(getRepublishAdminJobUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRepublishAdminJobMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof republishAdminJob>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof republishAdminJob>>, TError,{id: number}, TContext> => {

const mutationKey = ['republishAdminJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof republishAdminJob>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  republishAdminJob(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RepublishAdminJobMutationResult = NonNullable<Awaited<ReturnType<typeof republishAdminJob>>>

    export type RepublishAdminJobMutationError = ProblemDetails

    /**
 * @summary Republish a job from admin — bypasses job slot checks
 */
export const useRepublishAdminJob = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof republishAdminJob>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof republishAdminJob>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRepublishAdminJobMutationOptions(options), queryClient);
    }

export const getRecalculateAdminJobMatchScoresUrl = (id: number,) => {




  return `/admin/admin-job/${id}/recalculate`
}

/**
 * @summary Synchronously recalculate a job's match scores and return counts + degraded-input warnings.
 */
export const recalculateAdminJobMatchScores = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<RecalculateJobMatchScoresResult> => {

  return fetchWithAuth<RecalculateJobMatchScoresResult>(getRecalculateAdminJobMatchScoresUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRecalculateAdminJobMatchScoresMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculateAdminJobMatchScores>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof recalculateAdminJobMatchScores>>, TError,{id: number}, TContext> => {

const mutationKey = ['recalculateAdminJobMatchScores'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recalculateAdminJobMatchScores>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  recalculateAdminJobMatchScores(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecalculateAdminJobMatchScoresMutationResult = NonNullable<Awaited<ReturnType<typeof recalculateAdminJobMatchScores>>>

    export type RecalculateAdminJobMatchScoresMutationError = ProblemDetails

    /**
 * @summary Synchronously recalculate a job's match scores and return counts + degraded-input warnings.
 */
export const useRecalculateAdminJobMatchScores = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculateAdminJobMatchScores>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof recalculateAdminJobMatchScores>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRecalculateAdminJobMatchScoresMutationOptions(options), queryClient);
    }

export const getAdminCreateJobImportBatchUrl = () => {




  return `/admin/job-import/batches`
}

/**
 * @summary Create a new import batch for a company from the raw vacancies + pre-conversion fields.
 */
export const adminCreateJobImportBatch = async (createJobImportBatchCommandDto?: CreateJobImportBatchCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateJobImportBatchResult> => {

  return fetchWithAuth<CreateJobImportBatchResult>(getAdminCreateJobImportBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createJobImportBatchCommandDto)
  }
);}





export const getAdminCreateJobImportBatchMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateJobImportBatch>>, TError,{data?: CreateJobImportBatchCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreateJobImportBatch>>, TError,{data?: CreateJobImportBatchCommandDto}, TContext> => {

const mutationKey = ['adminCreateJobImportBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateJobImportBatch>>, {data?: CreateJobImportBatchCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateJobImportBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateJobImportBatchMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateJobImportBatch>>>
    export type AdminCreateJobImportBatchMutationBody = CreateJobImportBatchCommandDto | undefined
    export type AdminCreateJobImportBatchMutationError = ProblemDetails

    /**
 * @summary Create a new import batch for a company from the raw vacancies + pre-conversion fields.
 */
export const useAdminCreateJobImportBatch = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateJobImportBatch>>, TError,{data?: CreateJobImportBatchCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminCreateJobImportBatch>>,
        TError,
        {data?: CreateJobImportBatchCommandDto},
        TContext
      > => {
      return useMutation(getAdminCreateJobImportBatchMutationOptions(options), queryClient);
    }

export const getAdminListJobImportBatchesUrl = () => {




  return `/admin/job-import/batches`
}

/**
 * @summary List all import batches with per-status counts.
 */
export const adminListJobImportBatches = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListJobImportBatchesResult> => {

  return fetchWithAuth<ListJobImportBatchesResult>(getAdminListJobImportBatchesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListJobImportBatchesQueryKey = () => {
    return [
    'admin','job-import','batches'
    ] as const;
    }


export const getAdminListJobImportBatchesQueryOptions = <TData = Awaited<ReturnType<typeof adminListJobImportBatches>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListJobImportBatches>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminListJobImportBatchesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListJobImportBatches>>> = ({ signal }) => adminListJobImportBatches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListJobImportBatches>>, TError, TData>
}

export type AdminListJobImportBatchesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListJobImportBatches>>>
export type AdminListJobImportBatchesQueryError = unknown


/**
 * @summary List all import batches with per-status counts.
 */

export function useAdminListJobImportBatches<TData = Awaited<ReturnType<typeof adminListJobImportBatches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListJobImportBatches>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListJobImportBatchesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminGetJobImportBatchUrl = (id: number,) => {




  return `/admin/job-import/batches/${id}`
}

/**
 * @summary Full detail of a batch (items + statuses + linked drafts) — used to resume and finalize.
 */
export const adminGetJobImportBatch = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetJobImportBatchResult> => {

  return fetchWithAuth<GetJobImportBatchResult>(getAdminGetJobImportBatchUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetJobImportBatchQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','job-import','batches',id
    ] as const;
    }


export const getAdminGetJobImportBatchQueryOptions = <TData = Awaited<ReturnType<typeof adminGetJobImportBatch>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetJobImportBatch>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetJobImportBatchQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetJobImportBatch>>> = ({ signal }) => adminGetJobImportBatch(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetJobImportBatch>>, TError, TData>
}

export type AdminGetJobImportBatchQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetJobImportBatch>>>
export type AdminGetJobImportBatchQueryError = ProblemDetails


/**
 * @summary Full detail of a batch (items + statuses + linked drafts) — used to resume and finalize.
 */

export function useAdminGetJobImportBatch<TData = Awaited<ReturnType<typeof adminGetJobImportBatch>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetJobImportBatch>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetJobImportBatchQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminDeleteJobImportBatchUrl = (id: number,) => {




  return `/admin/job-import/batches/${id}`
}

/**
 * @summary Delete an import batch (and its throwaway draft concepts).
 */
export const adminDeleteJobImportBatch = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<boolean> => {

  return fetchWithAuth<boolean>(getAdminDeleteJobImportBatchUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminDeleteJobImportBatchMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteJobImportBatch>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteJobImportBatch>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminDeleteJobImportBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteJobImportBatch>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminDeleteJobImportBatch(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteJobImportBatchMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteJobImportBatch>>>

    export type AdminDeleteJobImportBatchMutationError = ProblemDetails

    /**
 * @summary Delete an import batch (and its throwaway draft concepts).
 */
export const useAdminDeleteJobImportBatch = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteJobImportBatch>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminDeleteJobImportBatch>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminDeleteJobImportBatchMutationOptions(options), queryClient);
    }

export const getAdminUpdateJobImportItemUrl = (id: number,) => {




  return `/admin/job-import/items/${id}`
}

/**
 * @summary Patch an import item: edit its content or update its status.
 */
export const adminUpdateJobImportItem = async (id: number,
    updateJobImportItemCommandDto?: UpdateJobImportItemCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

  return fetchWithAuth<number>(getAdminUpdateJobImportItemUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateJobImportItemCommandDto)
  }
);}





export const getAdminUpdateJobImportItemMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateJobImportItem>>, TError,{id: number;data?: UpdateJobImportItemCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateJobImportItem>>, TError,{id: number;data?: UpdateJobImportItemCommandDto}, TContext> => {

const mutationKey = ['adminUpdateJobImportItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateJobImportItem>>, {id: number;data?: UpdateJobImportItemCommandDto}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateJobImportItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateJobImportItemMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateJobImportItem>>>
    export type AdminUpdateJobImportItemMutationBody = UpdateJobImportItemCommandDto | undefined
    export type AdminUpdateJobImportItemMutationError = ProblemDetails

    /**
 * @summary Patch an import item: edit its content or update its status.
 */
export const useAdminUpdateJobImportItem = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateJobImportItem>>, TError,{id: number;data?: UpdateJobImportItemCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateJobImportItem>>,
        TError,
        {id: number;data?: UpdateJobImportItemCommandDto},
        TContext
      > => {
      return useMutation(getAdminUpdateJobImportItemMutationOptions(options), queryClient);
    }

export const getAdminConvertJobImportItemUrl = (id: number,) => {




  return `/admin/job-import/items/${id}/convert`
}

/**
 * @summary Runs the job agent on the item's vacancy text and creates (or overwrites) its draft job.
Returns the draft job id; on failure the item itself carries the reason.
 */
export const adminConvertJobImportItem = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<number> => {

  return fetchWithAuth<number>(getAdminConvertJobImportItemUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminConvertJobImportItemMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminConvertJobImportItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminConvertJobImportItem>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminConvertJobImportItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminConvertJobImportItem>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminConvertJobImportItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminConvertJobImportItemMutationResult = NonNullable<Awaited<ReturnType<typeof adminConvertJobImportItem>>>

    export type AdminConvertJobImportItemMutationError = ProblemDetails

    /**
 * @summary Runs the job agent on the item's vacancy text and creates (or overwrites) its draft job.
Returns the draft job id; on failure the item itself carries the reason.
 */
export const useAdminConvertJobImportItem = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminConvertJobImportItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminConvertJobImportItem>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminConvertJobImportItemMutationOptions(options), queryClient);
    }

export const getGetAdminCompanyBillingUrl = (companyId: number,) => {




  return `/admin/companies/${companyId}/billing`
}

export const getAdminCompanyBilling = async (companyId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminCompanyBillingResult> => {

  return fetchWithAuth<GetAdminCompanyBillingResult>(getGetAdminCompanyBillingUrl(companyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminCompanyBillingQueryKey = (companyId: MaybeRefOrGetter<number>,) => {
    return [
    'admin','companies',companyId,'billing'
    ] as const;
    }


export const getGetAdminCompanyBillingQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCompanyBilling>>, TError = ProblemDetails>(companyId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompanyBilling>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminCompanyBillingQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCompanyBilling>>> = ({ signal }) => getAdminCompanyBilling(toValue(companyId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCompanyBilling>>, TError, TData>
}

export type GetAdminCompanyBillingQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCompanyBilling>>>
export type GetAdminCompanyBillingQueryError = ProblemDetails



export function useGetAdminCompanyBilling<TData = Awaited<ReturnType<typeof getAdminCompanyBilling>>, TError = ProblemDetails>(
 companyId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompanyBilling>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCompanyBillingQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminCompanyInvoicesUrl = (companyId: number,) => {




  return `/admin/companies/${companyId}/billing/invoices`
}

export const listAdminCompanyInvoices = async (companyId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListInvoicesForCompanyResult> => {

  return fetchWithAuth<ListInvoicesForCompanyResult>(getListAdminCompanyInvoicesUrl(companyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminCompanyInvoicesQueryKey = (companyId: MaybeRefOrGetter<number>,) => {
    return [
    'admin','companies',companyId,'billing','invoices'
    ] as const;
    }


export const getListAdminCompanyInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminCompanyInvoices>>, TError = unknown>(companyId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCompanyInvoices>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminCompanyInvoicesQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminCompanyInvoices>>> = ({ signal }) => listAdminCompanyInvoices(toValue(companyId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminCompanyInvoices>>, TError, TData>
}

export type ListAdminCompanyInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminCompanyInvoices>>>
export type ListAdminCompanyInvoicesQueryError = unknown



export function useListAdminCompanyInvoices<TData = Awaited<ReturnType<typeof listAdminCompanyInvoices>>, TError = unknown>(
 companyId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCompanyInvoices>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminCompanyInvoicesQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminCompanyCreditNotesUrl = (companyId: number,) => {




  return `/admin/companies/${companyId}/billing/credit-notes`
}

export const listAdminCompanyCreditNotes = async (companyId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCreditNotesForCompanyResult> => {

  return fetchWithAuth<ListCreditNotesForCompanyResult>(getListAdminCompanyCreditNotesUrl(companyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminCompanyCreditNotesQueryKey = (companyId: MaybeRefOrGetter<number>,) => {
    return [
    'admin','companies',companyId,'billing','credit-notes'
    ] as const;
    }


export const getListAdminCompanyCreditNotesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminCompanyCreditNotes>>, TError = unknown>(companyId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCompanyCreditNotes>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminCompanyCreditNotesQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminCompanyCreditNotes>>> = ({ signal }) => listAdminCompanyCreditNotes(toValue(companyId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminCompanyCreditNotes>>, TError, TData>
}

export type ListAdminCompanyCreditNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminCompanyCreditNotes>>>
export type ListAdminCompanyCreditNotesQueryError = unknown



export function useListAdminCompanyCreditNotes<TData = Awaited<ReturnType<typeof listAdminCompanyCreditNotes>>, TError = unknown>(
 companyId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCompanyCreditNotes>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminCompanyCreditNotesQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminInvoiceFileUrlUrl = (companyId: number,
    fileId: string,) => {




  return `/admin/companies/${companyId}/billing/invoices/${fileId}`
}

export const getAdminInvoiceFileUrl = async (companyId: number,
    fileId: string, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetInvoiceFileUrlResult> => {

  return fetchWithAuth<GetInvoiceFileUrlResult>(getGetAdminInvoiceFileUrlUrl(companyId,fileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminInvoiceFileUrlQueryKey = (companyId: MaybeRefOrGetter<number>,
    fileId: MaybeRefOrGetter<string>,) => {
    return [
    'admin','companies',companyId,'billing','invoices',fileId
    ] as const;
    }


export const getGetAdminInvoiceFileUrlQueryOptions = <TData = Awaited<ReturnType<typeof getAdminInvoiceFileUrl>>, TError = unknown>(companyId: MaybeRefOrGetter<number>,
    fileId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInvoiceFileUrl>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminInvoiceFileUrlQueryKey(companyId,fileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminInvoiceFileUrl>>> = ({ signal }) => getAdminInvoiceFileUrl(toValue(companyId),toValue(fileId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined && toValue(fileId) !== null && toValue(fileId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminInvoiceFileUrl>>, TError, TData>
}

export type GetAdminInvoiceFileUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminInvoiceFileUrl>>>
export type GetAdminInvoiceFileUrlQueryError = unknown



export function useGetAdminInvoiceFileUrl<TData = Awaited<ReturnType<typeof getAdminInvoiceFileUrl>>, TError = unknown>(
 companyId: MaybeRefOrGetter<number>,
    fileId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInvoiceFileUrl>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminInvoiceFileUrlQueryOptions(companyId,fileId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminCreditNoteFileUrlUrl = (companyId: number,
    creditNoteId: string,) => {




  return `/admin/companies/${companyId}/billing/credit-notes/${creditNoteId}`
}

export const getAdminCreditNoteFileUrl = async (companyId: number,
    creditNoteId: string, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetCreditNoteFileUrlResult> => {

  return fetchWithAuth<GetCreditNoteFileUrlResult>(getGetAdminCreditNoteFileUrlUrl(companyId,creditNoteId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminCreditNoteFileUrlQueryKey = (companyId: MaybeRefOrGetter<number>,
    creditNoteId: MaybeRefOrGetter<string>,) => {
    return [
    'admin','companies',companyId,'billing','credit-notes',creditNoteId
    ] as const;
    }


export const getGetAdminCreditNoteFileUrlQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCreditNoteFileUrl>>, TError = unknown>(companyId: MaybeRefOrGetter<number>,
    creditNoteId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreditNoteFileUrl>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminCreditNoteFileUrlQueryKey(companyId,creditNoteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCreditNoteFileUrl>>> = ({ signal }) => getAdminCreditNoteFileUrl(toValue(companyId),toValue(creditNoteId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined && toValue(creditNoteId) !== null && toValue(creditNoteId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCreditNoteFileUrl>>, TError, TData>
}

export type GetAdminCreditNoteFileUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCreditNoteFileUrl>>>
export type GetAdminCreditNoteFileUrlQueryError = unknown



export function useGetAdminCreditNoteFileUrl<TData = Awaited<ReturnType<typeof getAdminCreditNoteFileUrl>>, TError = unknown>(
 companyId: MaybeRefOrGetter<number>,
    creditNoteId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreditNoteFileUrl>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCreditNoteFileUrlQueryOptions(companyId,creditNoteId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getSearchExactOnlineAccountsUrl = (params?: SearchExactOnlineAccountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/exact-online/accounts/search?${stringifiedParams}` : `/admin/exact-online/accounts/search`
}

export const searchExactOnlineAccounts = async (params?: SearchExactOnlineAccountsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SearchExactAccountsFromAdminResult> => {

  return fetchWithAuth<SearchExactAccountsFromAdminResult>(getSearchExactOnlineAccountsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchExactOnlineAccountsQueryKey = (params?: MaybeRefOrGetter<SearchExactOnlineAccountsParams>,) => {
    return [
    'admin','exact-online','accounts','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchExactOnlineAccountsQueryOptions = <TData = Awaited<ReturnType<typeof searchExactOnlineAccounts>>, TError = unknown>(params?: MaybeRefOrGetter<SearchExactOnlineAccountsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchExactOnlineAccounts>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSearchExactOnlineAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchExactOnlineAccounts>>> = ({ signal }) => searchExactOnlineAccounts(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchExactOnlineAccounts>>, TError, TData>
}

export type SearchExactOnlineAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof searchExactOnlineAccounts>>>
export type SearchExactOnlineAccountsQueryError = unknown



export function useSearchExactOnlineAccounts<TData = Awaited<ReturnType<typeof searchExactOnlineAccounts>>, TError = unknown>(
 params?: MaybeRefOrGetter<SearchExactOnlineAccountsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchExactOnlineAccounts>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchExactOnlineAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getSearchExactOnlineCustomerCompaniesUrl = (params?: SearchExactOnlineCustomerCompaniesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/exact-online/customer-companies?${stringifiedParams}` : `/admin/exact-online/customer-companies`
}

export const searchExactOnlineCustomerCompanies = async (params?: SearchExactOnlineCustomerCompaniesParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SearchCustomerCompaniesWithExactDataFromAdminResult> => {

  return fetchWithAuth<SearchCustomerCompaniesWithExactDataFromAdminResult>(getSearchExactOnlineCustomerCompaniesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchExactOnlineCustomerCompaniesQueryKey = (params?: MaybeRefOrGetter<SearchExactOnlineCustomerCompaniesParams>,) => {
    return [
    'admin','exact-online','customer-companies', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchExactOnlineCustomerCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof searchExactOnlineCustomerCompanies>>, TError = unknown>(params?: MaybeRefOrGetter<SearchExactOnlineCustomerCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchExactOnlineCustomerCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSearchExactOnlineCustomerCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchExactOnlineCustomerCompanies>>> = ({ signal }) => searchExactOnlineCustomerCompanies(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchExactOnlineCustomerCompanies>>, TError, TData>
}

export type SearchExactOnlineCustomerCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof searchExactOnlineCustomerCompanies>>>
export type SearchExactOnlineCustomerCompaniesQueryError = unknown



export function useSearchExactOnlineCustomerCompanies<TData = Awaited<ReturnType<typeof searchExactOnlineCustomerCompanies>>, TError = unknown>(
 params?: MaybeRefOrGetter<SearchExactOnlineCustomerCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchExactOnlineCustomerCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchExactOnlineCustomerCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getUpdateExactOnlineLinkUrl = (customerCompanyId: number,) => {




  return `/admin/exact-online/customer-companies/${customerCompanyId}/exact-link`
}

export const updateExactOnlineLink = async (customerCompanyId: number,
    linkCustomerCompanyToExactFromAdminCommandDto?: LinkCustomerCompanyToExactFromAdminCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getUpdateExactOnlineLinkUrl(customerCompanyId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkCustomerCompanyToExactFromAdminCommandDto)
  }
);}





export const getUpdateExactOnlineLinkMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateExactOnlineLink>>, TError,{customerCompanyId: number;data?: LinkCustomerCompanyToExactFromAdminCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateExactOnlineLink>>, TError,{customerCompanyId: number;data?: LinkCustomerCompanyToExactFromAdminCommandDto}, TContext> => {

const mutationKey = ['updateExactOnlineLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateExactOnlineLink>>, {customerCompanyId: number;data?: LinkCustomerCompanyToExactFromAdminCommandDto}> = (props) => {
          const {customerCompanyId,data} = props ?? {};

          return  updateExactOnlineLink(customerCompanyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateExactOnlineLinkMutationResult = NonNullable<Awaited<ReturnType<typeof updateExactOnlineLink>>>
    export type UpdateExactOnlineLinkMutationBody = LinkCustomerCompanyToExactFromAdminCommandDto | undefined
    export type UpdateExactOnlineLinkMutationError = ProblemDetails

    export const useUpdateExactOnlineLink = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateExactOnlineLink>>, TError,{customerCompanyId: number;data?: LinkCustomerCompanyToExactFromAdminCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateExactOnlineLink>>,
        TError,
        {customerCompanyId: number;data?: LinkCustomerCompanyToExactFromAdminCommandDto},
        TContext
      > => {
      return useMutation(getUpdateExactOnlineLinkMutationOptions(options), queryClient);
    }

export const getTriggerInvoiceSyncUrl = () => {




  return `/admin/invoicing/sync/invoices`
}

export const triggerInvoiceSync = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getTriggerInvoiceSyncUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTriggerInvoiceSyncMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerInvoiceSync>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerInvoiceSync>>, TError,void, TContext> => {

const mutationKey = ['triggerInvoiceSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerInvoiceSync>>, void> = () => {


          return  triggerInvoiceSync(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriggerInvoiceSyncMutationResult = NonNullable<Awaited<ReturnType<typeof triggerInvoiceSync>>>

    export type TriggerInvoiceSyncMutationError = unknown

    export const useTriggerInvoiceSync = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerInvoiceSync>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof triggerInvoiceSync>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTriggerInvoiceSyncMutationOptions(options), queryClient);
    }

export const getTriggerSubscriptionSyncUrl = () => {




  return `/admin/invoicing/sync/subscriptions`
}

export const triggerSubscriptionSync = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getTriggerSubscriptionSyncUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTriggerSubscriptionSyncMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerSubscriptionSync>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerSubscriptionSync>>, TError,void, TContext> => {

const mutationKey = ['triggerSubscriptionSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerSubscriptionSync>>, void> = () => {


          return  triggerSubscriptionSync(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriggerSubscriptionSyncMutationResult = NonNullable<Awaited<ReturnType<typeof triggerSubscriptionSync>>>

    export type TriggerSubscriptionSyncMutationError = unknown

    export const useTriggerSubscriptionSync = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerSubscriptionSync>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof triggerSubscriptionSync>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getTriggerSubscriptionSyncMutationOptions(options), queryClient);
    }

export const getAdminSearchIntegrationErrorsUrl = (params?: AdminSearchIntegrationErrorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["levels","integrationTypes"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/integration-error?${stringifiedParams}` : `/admin/integration-error`
}

/**
 * @summary Paged, filterable overview of captured ATS failures, newest first by default.
 */
export const adminSearchIntegrationErrors = async (params?: AdminSearchIntegrationErrorsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SearchIntegrationErrorLogsResult> => {

  return fetchWithAuth<SearchIntegrationErrorLogsResult>(getAdminSearchIntegrationErrorsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminSearchIntegrationErrorsQueryKey = (params?: MaybeRefOrGetter<AdminSearchIntegrationErrorsParams>,) => {
    return [
    'admin','integration-error', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminSearchIntegrationErrorsQueryOptions = <TData = Awaited<ReturnType<typeof adminSearchIntegrationErrors>>, TError = unknown>(params?: MaybeRefOrGetter<AdminSearchIntegrationErrorsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSearchIntegrationErrors>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminSearchIntegrationErrorsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSearchIntegrationErrors>>> = ({ signal }) => adminSearchIntegrationErrors(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSearchIntegrationErrors>>, TError, TData>
}

export type AdminSearchIntegrationErrorsQueryResult = NonNullable<Awaited<ReturnType<typeof adminSearchIntegrationErrors>>>
export type AdminSearchIntegrationErrorsQueryError = unknown


/**
 * @summary Paged, filterable overview of captured ATS failures, newest first by default.
 */

export function useAdminSearchIntegrationErrors<TData = Awaited<ReturnType<typeof adminSearchIntegrationErrors>>, TError = unknown>(
 params?: MaybeRefOrGetter<AdminSearchIntegrationErrorsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSearchIntegrationErrors>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminSearchIntegrationErrorsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminGetIntegrationErrorAlertPolicyUrl = () => {




  return `/admin/integration-error/alert-policy`
}

/**
 * @summary The alerting thresholds: the default policy plus a row per ATS.
 */
export const adminGetIntegrationErrorAlertPolicy = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetIntegrationErrorAlertPolicyResult> => {

  return fetchWithAuth<GetIntegrationErrorAlertPolicyResult>(getAdminGetIntegrationErrorAlertPolicyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetIntegrationErrorAlertPolicyQueryKey = () => {
    return [
    'admin','integration-error','alert-policy'
    ] as const;
    }


export const getAdminGetIntegrationErrorAlertPolicyQueryOptions = <TData = Awaited<ReturnType<typeof adminGetIntegrationErrorAlertPolicy>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetIntegrationErrorAlertPolicy>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetIntegrationErrorAlertPolicyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetIntegrationErrorAlertPolicy>>> = ({ signal }) => adminGetIntegrationErrorAlertPolicy({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetIntegrationErrorAlertPolicy>>, TError, TData>
}

export type AdminGetIntegrationErrorAlertPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetIntegrationErrorAlertPolicy>>>
export type AdminGetIntegrationErrorAlertPolicyQueryError = unknown


/**
 * @summary The alerting thresholds: the default policy plus a row per ATS.
 */

export function useAdminGetIntegrationErrorAlertPolicy<TData = Awaited<ReturnType<typeof adminGetIntegrationErrorAlertPolicy>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetIntegrationErrorAlertPolicy>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetIntegrationErrorAlertPolicyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getAdminUpdateIntegrationErrorAlertPolicyUrl = () => {




  return `/admin/integration-error/alert-policy`
}

/**
 * @summary Saves the alerting thresholds. Write-gated separately from reading: a wrong threshold silences
alerting entirely, which is a heavier consequence than viewing the log.
 */
export const adminUpdateIntegrationErrorAlertPolicy = async (updateIntegrationErrorAlertPolicyCommandDto?: UpdateIntegrationErrorAlertPolicyCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<boolean> => {

  return fetchWithAuth<boolean>(getAdminUpdateIntegrationErrorAlertPolicyUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateIntegrationErrorAlertPolicyCommandDto)
  }
);}





export const getAdminUpdateIntegrationErrorAlertPolicyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateIntegrationErrorAlertPolicy>>, TError,{data?: UpdateIntegrationErrorAlertPolicyCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateIntegrationErrorAlertPolicy>>, TError,{data?: UpdateIntegrationErrorAlertPolicyCommandDto}, TContext> => {

const mutationKey = ['adminUpdateIntegrationErrorAlertPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateIntegrationErrorAlertPolicy>>, {data?: UpdateIntegrationErrorAlertPolicyCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  adminUpdateIntegrationErrorAlertPolicy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateIntegrationErrorAlertPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateIntegrationErrorAlertPolicy>>>
    export type AdminUpdateIntegrationErrorAlertPolicyMutationBody = UpdateIntegrationErrorAlertPolicyCommandDto | undefined
    export type AdminUpdateIntegrationErrorAlertPolicyMutationError = ProblemDetails

    /**
 * @summary Saves the alerting thresholds. Write-gated separately from reading: a wrong threshold silences
alerting entirely, which is a heavier consequence than viewing the log.
 */
export const useAdminUpdateIntegrationErrorAlertPolicy = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateIntegrationErrorAlertPolicy>>, TError,{data?: UpdateIntegrationErrorAlertPolicyCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adminUpdateIntegrationErrorAlertPolicy>>,
        TError,
        {data?: UpdateIntegrationErrorAlertPolicyCommandDto},
        TContext
      > => {
      return useMutation(getAdminUpdateIntegrationErrorAlertPolicyMutationOptions(options), queryClient);
    }

export const getAdminGetIntegrationErrorUrl = (id: number,) => {




  return `/admin/integration-error/${id}`
}

/**
 * @summary Full detail of one failure: stack trace, inner exceptions, upstream response and properties.
 */
export const adminGetIntegrationError = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetIntegrationErrorLogResult> => {

  return fetchWithAuth<GetIntegrationErrorLogResult>(getAdminGetIntegrationErrorUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetIntegrationErrorQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','integration-error',id
    ] as const;
    }


export const getAdminGetIntegrationErrorQueryOptions = <TData = Awaited<ReturnType<typeof adminGetIntegrationError>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetIntegrationError>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAdminGetIntegrationErrorQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetIntegrationError>>> = ({ signal }) => adminGetIntegrationError(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetIntegrationError>>, TError, TData>
}

export type AdminGetIntegrationErrorQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetIntegrationError>>>
export type AdminGetIntegrationErrorQueryError = ProblemDetails


/**
 * @summary Full detail of one failure: stack trace, inner exceptions, upstream response and properties.
 */

export function useAdminGetIntegrationError<TData = Awaited<ReturnType<typeof adminGetIntegrationError>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetIntegrationError>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetIntegrationErrorQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminCompaniesUrl = (params?: ListAdminCompaniesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-companies?${stringifiedParams}` : `/admin/admin-companies`
}

export const listAdminCompanies = async (params?: ListAdminCompaniesParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCompaniesFromAdminResult> => {

  return fetchWithAuth<ListCompaniesFromAdminResult>(getListAdminCompaniesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminCompaniesQueryKey = (params?: MaybeRefOrGetter<ListAdminCompaniesParams>,) => {
    return [
    'admin','admin-companies', ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminCompanies>>, TError = unknown>(params?: MaybeRefOrGetter<ListAdminCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminCompanies>>> = ({ signal }) => listAdminCompanies(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminCompanies>>, TError, TData>
}

export type ListAdminCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminCompanies>>>
export type ListAdminCompaniesQueryError = unknown



export function useListAdminCompanies<TData = Awaited<ReturnType<typeof listAdminCompanies>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListAdminCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getCreateAdminCompanyUrl = () => {




  return `/admin/admin-companies`
}

export const createAdminCompany = async (createCompanyFromAdminAdminCreateCompanyDto?: CreateCompanyFromAdminAdminCreateCompanyDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateCompanyFromAdminResult> => {

  return fetchWithAuth<CreateCompanyFromAdminResult>(getCreateAdminCompanyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCompanyFromAdminAdminCreateCompanyDto)
  }
);}





export const getCreateAdminCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminCompany>>, TError,{data?: CreateCompanyFromAdminAdminCreateCompanyDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminCompany>>, TError,{data?: CreateCompanyFromAdminAdminCreateCompanyDto}, TContext> => {

const mutationKey = ['createAdminCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminCompany>>, {data?: CreateCompanyFromAdminAdminCreateCompanyDto}> = (props) => {
          const {data} = props ?? {};

          return  createAdminCompany(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminCompany>>>
    export type CreateAdminCompanyMutationBody = CreateCompanyFromAdminAdminCreateCompanyDto | undefined
    export type CreateAdminCompanyMutationError = ProblemDetails

    export const useCreateAdminCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminCompany>>, TError,{data?: CreateCompanyFromAdminAdminCreateCompanyDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAdminCompany>>,
        TError,
        {data?: CreateCompanyFromAdminAdminCreateCompanyDto},
        TContext
      > => {
      return useMutation(getCreateAdminCompanyMutationOptions(options), queryClient);
    }

export const getUpdateAdminCompanyUrl = () => {




  return `/admin/admin-companies`
}

export const updateAdminCompany = async (updateCompanyFromAdminRequestDto?: UpdateCompanyFromAdminRequestDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getUpdateAdminCompanyUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateCompanyFromAdminRequestDto)
  }
);}





export const getUpdateAdminCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminCompany>>, TError,{data?: UpdateCompanyFromAdminRequestDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminCompany>>, TError,{data?: UpdateCompanyFromAdminRequestDto}, TContext> => {

const mutationKey = ['updateAdminCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminCompany>>, {data?: UpdateCompanyFromAdminRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  updateAdminCompany(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminCompany>>>
    export type UpdateAdminCompanyMutationBody = UpdateCompanyFromAdminRequestDto | undefined
    export type UpdateAdminCompanyMutationError = ProblemDetails

    export const useUpdateAdminCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminCompany>>, TError,{data?: UpdateCompanyFromAdminRequestDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAdminCompany>>,
        TError,
        {data?: UpdateCompanyFromAdminRequestDto},
        TContext
      > => {
      return useMutation(getUpdateAdminCompanyMutationOptions(options), queryClient);
    }

export const getDeleteCompanyUrl = () => {




  return `/admin/admin-companies`
}

export const deleteCompany = async (deleteCompanyCommandDto?: DeleteCompanyCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getDeleteCompanyUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deleteCompanyCommandDto)
  }
);}





export const getDeleteCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{data?: DeleteCompanyCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{data?: DeleteCompanyCommandDto}, TContext> => {

const mutationKey = ['deleteCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompany>>, {data?: DeleteCompanyCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  deleteCompany(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompany>>>
    export type DeleteCompanyMutationBody = DeleteCompanyCommandDto | undefined
    export type DeleteCompanyMutationError = ProblemDetails

    export const useDeleteCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{data?: DeleteCompanyCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteCompany>>,
        TError,
        {data?: DeleteCompanyCommandDto},
        TContext
      > => {
      return useMutation(getDeleteCompanyMutationOptions(options), queryClient);
    }

export const getLookupAdminCompaniesUrl = () => {




  return `/admin/admin-companies/lookup`
}

export const lookupAdminCompanies = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<LookupCompaniesFromAdminResult> => {

  return fetchWithAuth<LookupCompaniesFromAdminResult>(getLookupAdminCompaniesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLookupAdminCompaniesQueryKey = () => {
    return [
    'admin','admin-companies','lookup'
    ] as const;
    }


export const getLookupAdminCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof lookupAdminCompanies>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupAdminCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLookupAdminCompaniesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lookupAdminCompanies>>> = ({ signal }) => lookupAdminCompanies({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lookupAdminCompanies>>, TError, TData>
}

export type LookupAdminCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof lookupAdminCompanies>>>
export type LookupAdminCompaniesQueryError = unknown



export function useLookupAdminCompanies<TData = Awaited<ReturnType<typeof lookupAdminCompanies>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupAdminCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLookupAdminCompaniesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListRelinkableCompaniesUrl = () => {




  return `/admin/admin-companies/relinkable`
}

export const listRelinkableCompanies = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListRelinkableCompaniesResult> => {

  return fetchWithAuth<ListRelinkableCompaniesResult>(getListRelinkableCompaniesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRelinkableCompaniesQueryKey = () => {
    return [
    'admin','admin-companies','relinkable'
    ] as const;
    }


export const getListRelinkableCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof listRelinkableCompanies>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRelinkableCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListRelinkableCompaniesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRelinkableCompanies>>> = ({ signal }) => listRelinkableCompanies({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRelinkableCompanies>>, TError, TData>
}

export type ListRelinkableCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof listRelinkableCompanies>>>
export type ListRelinkableCompaniesQueryError = unknown



export function useListRelinkableCompanies<TData = Awaited<ReturnType<typeof listRelinkableCompanies>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRelinkableCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRelinkableCompaniesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getResolveAdminCompanyByExactGuidUrl = (exactGuid: string,) => {




  return `/admin/admin-companies/by-exact-guid/${exactGuid}`
}

/**
 * @summary Resolves the company linked to an Exact Online account guid, so a Metabase dashboard row — which only
carries the Exact guid — can be forwarded to the right company detail page.
 */
export const resolveAdminCompanyByExactGuid = async (exactGuid: string, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ResolveCompanyByExactGuidFromAdminResult> => {

  return fetchWithAuth<ResolveCompanyByExactGuidFromAdminResult>(getResolveAdminCompanyByExactGuidUrl(exactGuid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getResolveAdminCompanyByExactGuidQueryKey = (exactGuid: MaybeRefOrGetter<string>,) => {
    return [
    'admin','admin-companies','by-exact-guid',exactGuid
    ] as const;
    }


export const getResolveAdminCompanyByExactGuidQueryOptions = <TData = Awaited<ReturnType<typeof resolveAdminCompanyByExactGuid>>, TError = unknown>(exactGuid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveAdminCompanyByExactGuid>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getResolveAdminCompanyByExactGuidQueryKey(exactGuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveAdminCompanyByExactGuid>>> = ({ signal }) => resolveAdminCompanyByExactGuid(toValue(exactGuid), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(exactGuid) !== null && toValue(exactGuid) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resolveAdminCompanyByExactGuid>>, TError, TData>
}

export type ResolveAdminCompanyByExactGuidQueryResult = NonNullable<Awaited<ReturnType<typeof resolveAdminCompanyByExactGuid>>>
export type ResolveAdminCompanyByExactGuidQueryError = unknown


/**
 * @summary Resolves the company linked to an Exact Online account guid, so a Metabase dashboard row — which only
carries the Exact guid — can be forwarded to the right company detail page.
 */

export function useResolveAdminCompanyByExactGuid<TData = Awaited<ReturnType<typeof resolveAdminCompanyByExactGuid>>, TError = unknown>(
 exactGuid: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveAdminCompanyByExactGuid>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResolveAdminCompanyByExactGuidQueryOptions(exactGuid,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getSearchAdminCompaniesUrl = (params?: SearchAdminCompaniesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["jobCategoryIds","jobFunctionIds","provinces","displayTypes","subscriptions"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-companies/search?${stringifiedParams}` : `/admin/admin-companies/search`
}

export const searchAdminCompanies = async (params?: SearchAdminCompaniesParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SearchCompaniesFromAdminResult> => {

  return fetchWithAuth<SearchCompaniesFromAdminResult>(getSearchAdminCompaniesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchAdminCompaniesQueryKey = (params?: MaybeRefOrGetter<SearchAdminCompaniesParams>,) => {
    return [
    'admin','admin-companies','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchAdminCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof searchAdminCompanies>>, TError = unknown>(params?: MaybeRefOrGetter<SearchAdminCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdminCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSearchAdminCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAdminCompanies>>> = ({ signal }) => searchAdminCompanies(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchAdminCompanies>>, TError, TData>
}

export type SearchAdminCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof searchAdminCompanies>>>
export type SearchAdminCompaniesQueryError = unknown



export function useSearchAdminCompanies<TData = Awaited<ReturnType<typeof searchAdminCompanies>>, TError = unknown>(
 params?: MaybeRefOrGetter<SearchAdminCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAdminCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchAdminCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminCompanyActiveSubscriptionsUrl = () => {




  return `/admin/admin-companies/active-subscriptions`
}

export const listAdminCompanyActiveSubscriptions = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListActiveSubscriptionsFromAdminResult> => {

  return fetchWithAuth<ListActiveSubscriptionsFromAdminResult>(getListAdminCompanyActiveSubscriptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminCompanyActiveSubscriptionsQueryKey = () => {
    return [
    'admin','admin-companies','active-subscriptions'
    ] as const;
    }


export const getListAdminCompanyActiveSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminCompanyActiveSubscriptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCompanyActiveSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminCompanyActiveSubscriptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminCompanyActiveSubscriptions>>> = ({ signal }) => listAdminCompanyActiveSubscriptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminCompanyActiveSubscriptions>>, TError, TData>
}

export type ListAdminCompanyActiveSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminCompanyActiveSubscriptions>>>
export type ListAdminCompanyActiveSubscriptionsQueryError = unknown



export function useListAdminCompanyActiveSubscriptions<TData = Awaited<ReturnType<typeof listAdminCompanyActiveSubscriptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCompanyActiveSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminCompanyActiveSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminCompanyUrl = (id: number,) => {




  return `/admin/admin-companies/${id}`
}

export const getAdminCompany = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetCompanyFromAdminResult> => {

  return fetchWithAuth<GetCompanyFromAdminResult>(getGetAdminCompanyUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminCompanyQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'admin','admin-companies',id
    ] as const;
    }


export const getGetAdminCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCompany>>, TError = unknown>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminCompanyQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCompany>>> = ({ signal }) => getAdminCompany(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCompany>>, TError, TData>
}

export type GetAdminCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCompany>>>
export type GetAdminCompanyQueryError = unknown



export function useGetAdminCompany<TData = Awaited<ReturnType<typeof getAdminCompany>>, TError = unknown>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCompanyQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminCompanyStatisticsUrl = (id: number,
    params?: GetAdminCompanyStatisticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-companies/${id}/statistics?${stringifiedParams}` : `/admin/admin-companies/${id}/statistics`
}

/**
 * @summary Get aggregated statistics for a company (cached for 1 hour). Supports optional date range filtering.
 */
export const getAdminCompanyStatistics = async (id: number,
    params?: GetAdminCompanyStatisticsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminCompanyStatisticsResult> => {

  return fetchWithAuth<GetAdminCompanyStatisticsResult>(getGetAdminCompanyStatisticsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminCompanyStatisticsQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminCompanyStatisticsParams>,) => {
    return [
    'admin','admin-companies',id,'statistics', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminCompanyStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCompanyStatistics>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminCompanyStatisticsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompanyStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminCompanyStatisticsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCompanyStatistics>>> = ({ signal }) => getAdminCompanyStatistics(toValue(id),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCompanyStatistics>>, TError, TData>
}

export type GetAdminCompanyStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCompanyStatistics>>>
export type GetAdminCompanyStatisticsQueryError = ProblemDetails


/**
 * @summary Get aggregated statistics for a company (cached for 1 hour). Supports optional date range filtering.
 */

export function useGetAdminCompanyStatistics<TData = Awaited<ReturnType<typeof getAdminCompanyStatistics>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminCompanyStatisticsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompanyStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCompanyStatisticsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getCreateSubCompanyUrl = () => {




  return `/admin/admin-companies/sub-company`
}

export const createSubCompany = async (createSubCompanyFromAdminCompanyDto?: CreateSubCompanyFromAdminCompanyDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<CreateSubCompanyFromAdminResult> => {

  return fetchWithAuth<CreateSubCompanyFromAdminResult>(getCreateSubCompanyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSubCompanyFromAdminCompanyDto)
  }
);}





export const getCreateSubCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubCompany>>, TError,{data?: CreateSubCompanyFromAdminCompanyDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createSubCompany>>, TError,{data?: CreateSubCompanyFromAdminCompanyDto}, TContext> => {

const mutationKey = ['createSubCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubCompany>>, {data?: CreateSubCompanyFromAdminCompanyDto}> = (props) => {
          const {data} = props ?? {};

          return  createSubCompany(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSubCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof createSubCompany>>>
    export type CreateSubCompanyMutationBody = CreateSubCompanyFromAdminCompanyDto | undefined
    export type CreateSubCompanyMutationError = ProblemDetails

    export const useCreateSubCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubCompany>>, TError,{data?: CreateSubCompanyFromAdminCompanyDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createSubCompany>>,
        TError,
        {data?: CreateSubCompanyFromAdminCompanyDto},
        TContext
      > => {
      return useMutation(getCreateSubCompanyMutationOptions(options), queryClient);
    }

export const getSetAdminCompanyIdealUrl = (companyId: number,) => {




  return `/admin/admin-companies/${companyId}/ideal`
}

/**
 * @summary Marks or unmarks a company as an Ideal Company, optionally together with companies from the same family.
 */
export const setAdminCompanyIdeal = async (companyId: number,
    setCompanyIdealCommandDto?: SetCompanyIdealCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<SetCompanyIdealResult> => {

  return fetchWithAuth<SetCompanyIdealResult>(getSetAdminCompanyIdealUrl(companyId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setCompanyIdealCommandDto)
  }
);}





export const getSetAdminCompanyIdealMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminCompanyIdeal>>, TError,{companyId: number;data?: SetCompanyIdealCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminCompanyIdeal>>, TError,{companyId: number;data?: SetCompanyIdealCommandDto}, TContext> => {

const mutationKey = ['setAdminCompanyIdeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminCompanyIdeal>>, {companyId: number;data?: SetCompanyIdealCommandDto}> = (props) => {
          const {companyId,data} = props ?? {};

          return  setAdminCompanyIdeal(companyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminCompanyIdealMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminCompanyIdeal>>>
    export type SetAdminCompanyIdealMutationBody = SetCompanyIdealCommandDto | undefined
    export type SetAdminCompanyIdealMutationError = ProblemDetails

    /**
 * @summary Marks or unmarks a company as an Ideal Company, optionally together with companies from the same family.
 */
export const useSetAdminCompanyIdeal = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminCompanyIdeal>>, TError,{companyId: number;data?: SetCompanyIdealCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof setAdminCompanyIdeal>>,
        TError,
        {companyId: number;data?: SetCompanyIdealCommandDto},
        TContext
      > => {
      return useMutation(getSetAdminCompanyIdealMutationOptions(options), queryClient);
    }

export const getUpdateAdminCompanyVideoUrl = (companyId: number,) => {




  return `/admin/admin-companies/${companyId}/video`
}

export const updateAdminCompanyVideo = async (companyId: number,
    updateCompanyVideoFromAdminCommandDto?: UpdateCompanyVideoFromAdminCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getUpdateAdminCompanyVideoUrl(companyId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateCompanyVideoFromAdminCommandDto)
  }
);}





export const getUpdateAdminCompanyVideoMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminCompanyVideo>>, TError,{companyId: number;data?: UpdateCompanyVideoFromAdminCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminCompanyVideo>>, TError,{companyId: number;data?: UpdateCompanyVideoFromAdminCommandDto}, TContext> => {

const mutationKey = ['updateAdminCompanyVideo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminCompanyVideo>>, {companyId: number;data?: UpdateCompanyVideoFromAdminCommandDto}> = (props) => {
          const {companyId,data} = props ?? {};

          return  updateAdminCompanyVideo(companyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminCompanyVideoMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminCompanyVideo>>>
    export type UpdateAdminCompanyVideoMutationBody = UpdateCompanyVideoFromAdminCommandDto | undefined
    export type UpdateAdminCompanyVideoMutationError = ProblemDetails

    export const useUpdateAdminCompanyVideo = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminCompanyVideo>>, TError,{companyId: number;data?: UpdateCompanyVideoFromAdminCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAdminCompanyVideo>>,
        TError,
        {companyId: number;data?: UpdateCompanyVideoFromAdminCommandDto},
        TContext
      > => {
      return useMutation(getUpdateAdminCompanyVideoMutationOptions(options), queryClient);
    }

export const getMoveSubscriptionStartDateEarlierUrl = (companyId: number,) => {




  return `/admin/admin-companies/${companyId}/subscription-start-date`
}

export const moveSubscriptionStartDateEarlier = async (companyId: number,
    moveSubscriptionStartDateEarlierCommandDto?: MoveSubscriptionStartDateEarlierCommandDto, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getMoveSubscriptionStartDateEarlierUrl(companyId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(moveSubscriptionStartDateEarlierCommandDto)
  }
);}





export const getMoveSubscriptionStartDateEarlierMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveSubscriptionStartDateEarlier>>, TError,{companyId: number;data?: MoveSubscriptionStartDateEarlierCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof moveSubscriptionStartDateEarlier>>, TError,{companyId: number;data?: MoveSubscriptionStartDateEarlierCommandDto}, TContext> => {

const mutationKey = ['moveSubscriptionStartDateEarlier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveSubscriptionStartDateEarlier>>, {companyId: number;data?: MoveSubscriptionStartDateEarlierCommandDto}> = (props) => {
          const {companyId,data} = props ?? {};

          return  moveSubscriptionStartDateEarlier(companyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveSubscriptionStartDateEarlierMutationResult = NonNullable<Awaited<ReturnType<typeof moveSubscriptionStartDateEarlier>>>
    export type MoveSubscriptionStartDateEarlierMutationBody = MoveSubscriptionStartDateEarlierCommandDto | undefined
    export type MoveSubscriptionStartDateEarlierMutationError = ProblemDetails

    export const useMoveSubscriptionStartDateEarlier = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveSubscriptionStartDateEarlier>>, TError,{companyId: number;data?: MoveSubscriptionStartDateEarlierCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof moveSubscriptionStartDateEarlier>>,
        TError,
        {companyId: number;data?: MoveSubscriptionStartDateEarlierCommandDto},
        TContext
      > => {
      return useMutation(getMoveSubscriptionStartDateEarlierMutationOptions(options), queryClient);
    }

export const getMarkAsFollowedUpUrl = (id: number,) => {




  return `/admin/admin-companies/mark-as-followed-up/${id}`
}

export const markAsFollowedUp = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Unit> => {

  return fetchWithAuth<Unit>(getMarkAsFollowedUpUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkAsFollowedUpMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAsFollowedUp>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof markAsFollowedUp>>, TError,{id: number}, TContext> => {

const mutationKey = ['markAsFollowedUp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAsFollowedUp>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  markAsFollowedUp(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAsFollowedUpMutationResult = NonNullable<Awaited<ReturnType<typeof markAsFollowedUp>>>

    export type MarkAsFollowedUpMutationError = ProblemDetails

    export const useMarkAsFollowedUp = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAsFollowedUp>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof markAsFollowedUp>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getMarkAsFollowedUpMutationOptions(options), queryClient);
    }

export const getScheduleAutoMatchForCompanyUrl = (id: number,) => {




  return `/admin/admin-companies/${id}/schedule-auto-match`
}

export const scheduleAutoMatchForCompany = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ScheduleAutoMatchForExistingCandidatesResult> => {

  return fetchWithAuth<ScheduleAutoMatchForExistingCandidatesResult>(getScheduleAutoMatchForCompanyUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getScheduleAutoMatchForCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleAutoMatchForCompany>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof scheduleAutoMatchForCompany>>, TError,{id: number}, TContext> => {

const mutationKey = ['scheduleAutoMatchForCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleAutoMatchForCompany>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  scheduleAutoMatchForCompany(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleAutoMatchForCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleAutoMatchForCompany>>>

    export type ScheduleAutoMatchForCompanyMutationError = ProblemDetails

    export const useScheduleAutoMatchForCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleAutoMatchForCompany>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof scheduleAutoMatchForCompany>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getScheduleAutoMatchForCompanyMutationOptions(options), queryClient);
    }

export const getListCompanyMediaUrl = (params?: ListCompanyMediaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["JobCategoryIds","JobFunctionIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/admin-companies/media?${stringifiedParams}` : `/admin/admin-companies/media`
}

/**
 * @summary One row per company with all of its media: the BunnyCDN video plus cover, logo and general images.
 */
export const listCompanyMedia = async (params?: ListCompanyMediaParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCompanyMediaResult> => {

  return fetchWithAuth<ListCompanyMediaResult>(getListCompanyMediaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCompanyMediaQueryKey = (params?: MaybeRefOrGetter<ListCompanyMediaParams>,) => {
    return [
    'admin','admin-companies','media', ...(params ? [params] : [])
    ] as const;
    }


export const getListCompanyMediaQueryOptions = <TData = Awaited<ReturnType<typeof listCompanyMedia>>, TError = unknown>(params?: MaybeRefOrGetter<ListCompanyMediaParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyMedia>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListCompanyMediaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanyMedia>>> = ({ signal }) => listCompanyMedia(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompanyMedia>>, TError, TData>
}

export type ListCompanyMediaQueryResult = NonNullable<Awaited<ReturnType<typeof listCompanyMedia>>>
export type ListCompanyMediaQueryError = unknown


/**
 * @summary One row per company with all of its media: the BunnyCDN video plus cover, logo and general images.
 */

export function useListCompanyMedia<TData = Awaited<ReturnType<typeof listCompanyMedia>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListCompanyMediaParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanyMedia>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCompanyMediaQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getDownloadCompanyImageUrl = (imageId: string,) => {




  return `/admin/admin-companies/media/images/${imageId}`
}

/**
 * @summary Download a single company image.
 */
export const downloadCompanyImage = async (imageId: string, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Blob> => {

  return fetchWithAuth<Blob>(getDownloadCompanyImageUrl(imageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadCompanyImageQueryKey = (imageId: MaybeRefOrGetter<string>,) => {
    return [
    'admin','admin-companies','media','images',imageId
    ] as const;
    }


export const getDownloadCompanyImageQueryOptions = <TData = Awaited<ReturnType<typeof downloadCompanyImage>>, TError = ProblemDetails>(imageId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCompanyImage>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getDownloadCompanyImageQueryKey(imageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadCompanyImage>>> = ({ signal }) => downloadCompanyImage(toValue(imageId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(imageId) !== null && toValue(imageId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadCompanyImage>>, TError, TData>
}

export type DownloadCompanyImageQueryResult = NonNullable<Awaited<ReturnType<typeof downloadCompanyImage>>>
export type DownloadCompanyImageQueryError = ProblemDetails


/**
 * @summary Download a single company image.
 */

export function useDownloadCompanyImage<TData = Awaited<ReturnType<typeof downloadCompanyImage>>, TError = ProblemDetails>(
 imageId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadCompanyImage>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadCompanyImageQueryOptions(imageId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminMatchingCandidatesUrl = (params?: ListAdminMatchingCandidatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["jobCategoryIds","jobFunctionIds","experienceLevels","educationLevelIds","provinces","ageBuckets","jobSeekingStatuses","referralSourceIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/matching/candidates?${stringifiedParams}` : `/admin/matching/candidates`
}

export const listAdminMatchingCandidates = async (params?: ListAdminMatchingCandidatesParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminMatchingCandidatesResult> => {

  return fetchWithAuth<ListAdminMatchingCandidatesResult>(getListAdminMatchingCandidatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminMatchingCandidatesQueryKey = (params?: MaybeRefOrGetter<ListAdminMatchingCandidatesParams>,) => {
    return [
    'admin','matching','candidates', ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminMatchingCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminMatchingCandidates>>, TError = unknown>(params?: MaybeRefOrGetter<ListAdminMatchingCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMatchingCandidates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminMatchingCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminMatchingCandidates>>> = ({ signal }) => listAdminMatchingCandidates(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminMatchingCandidates>>, TError, TData>
}

export type ListAdminMatchingCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminMatchingCandidates>>>
export type ListAdminMatchingCandidatesQueryError = unknown



export function useListAdminMatchingCandidates<TData = Awaited<ReturnType<typeof listAdminMatchingCandidates>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListAdminMatchingCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMatchingCandidates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminMatchingCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getLookupAdminCandidatesUrl = (params?: LookupAdminCandidatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/matching/candidates/lookup?${stringifiedParams}` : `/admin/matching/candidates/lookup`
}

export const lookupAdminCandidates = async (params?: LookupAdminCandidatesParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<LookupAdminCandidatesResult> => {

  return fetchWithAuth<LookupAdminCandidatesResult>(getLookupAdminCandidatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLookupAdminCandidatesQueryKey = (params?: MaybeRefOrGetter<LookupAdminCandidatesParams>,) => {
    return [
    'admin','matching','candidates','lookup', ...(params ? [params] : [])
    ] as const;
    }


export const getLookupAdminCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof lookupAdminCandidates>>, TError = unknown>(params?: MaybeRefOrGetter<LookupAdminCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupAdminCandidates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLookupAdminCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lookupAdminCandidates>>> = ({ signal }) => lookupAdminCandidates(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lookupAdminCandidates>>, TError, TData>
}

export type LookupAdminCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof lookupAdminCandidates>>>
export type LookupAdminCandidatesQueryError = unknown



export function useLookupAdminCandidates<TData = Awaited<ReturnType<typeof lookupAdminCandidates>>, TError = unknown>(
 params?: MaybeRefOrGetter<LookupAdminCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupAdminCandidates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLookupAdminCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminMatchingCandidateUrl = (userId: number,) => {




  return `/admin/matching/candidates/${userId}`
}

export const getAdminMatchingCandidate = async (userId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminMatchingCandidateResult> => {

  return fetchWithAuth<GetAdminMatchingCandidateResult>(getGetAdminMatchingCandidateUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminMatchingCandidateQueryKey = (userId: MaybeRefOrGetter<number>,) => {
    return [
    'admin','matching','candidates',userId
    ] as const;
    }


export const getGetAdminMatchingCandidateQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMatchingCandidate>>, TError = ProblemDetails>(userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchingCandidate>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminMatchingCandidateQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMatchingCandidate>>> = ({ signal }) => getAdminMatchingCandidate(toValue(userId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchingCandidate>>, TError, TData>
}

export type GetAdminMatchingCandidateQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMatchingCandidate>>>
export type GetAdminMatchingCandidateQueryError = ProblemDetails



export function useGetAdminMatchingCandidate<TData = Awaited<ReturnType<typeof getAdminMatchingCandidate>>, TError = ProblemDetails>(
 userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMatchingCandidate>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMatchingCandidateQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getRecalculateAdminCandidateMatchScoresUrl = (userId: number,) => {




  return `/admin/matching/candidates/${userId}/recalculate`
}

/**
 * @summary Synchronously recalculate a candidate's match scores and return counts + degraded-input warnings.
 */
export const recalculateAdminCandidateMatchScores = async (userId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<RecalculateCandidateMatchScoresResult> => {

  return fetchWithAuth<RecalculateCandidateMatchScoresResult>(getRecalculateAdminCandidateMatchScoresUrl(userId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRecalculateAdminCandidateMatchScoresMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculateAdminCandidateMatchScores>>, TError,{userId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof recalculateAdminCandidateMatchScores>>, TError,{userId: number}, TContext> => {

const mutationKey = ['recalculateAdminCandidateMatchScores'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recalculateAdminCandidateMatchScores>>, {userId: number}> = (props) => {
          const {userId} = props ?? {};

          return  recalculateAdminCandidateMatchScores(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecalculateAdminCandidateMatchScoresMutationResult = NonNullable<Awaited<ReturnType<typeof recalculateAdminCandidateMatchScores>>>

    export type RecalculateAdminCandidateMatchScoresMutationError = ProblemDetails

    /**
 * @summary Synchronously recalculate a candidate's match scores and return counts + degraded-input warnings.
 */
export const useRecalculateAdminCandidateMatchScores = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculateAdminCandidateMatchScores>>, TError,{userId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof recalculateAdminCandidateMatchScores>>,
        TError,
        {userId: number},
        TContext
      > => {
      return useMutation(getRecalculateAdminCandidateMatchScoresMutationOptions(options), queryClient);
    }

export const getDeleteAdminOnboardingUserUrl = (onboardingUserId: number,) => {




  return `/admin/matching/onboarding-users/${onboardingUserId}`
}

/**
 * @summary Delete a job seeker that has not finished the onboarding yet.
 */
export const deleteAdminOnboardingUser = async (onboardingUserId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<void> => {

  return fetchWithAuth<void>(getDeleteAdminOnboardingUserUrl(onboardingUserId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAdminOnboardingUserMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOnboardingUser>>, TError,{onboardingUserId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOnboardingUser>>, TError,{onboardingUserId: number}, TContext> => {

const mutationKey = ['deleteAdminOnboardingUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminOnboardingUser>>, {onboardingUserId: number}> = (props) => {
          const {onboardingUserId} = props ?? {};

          return  deleteAdminOnboardingUser(onboardingUserId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminOnboardingUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminOnboardingUser>>>

    export type DeleteAdminOnboardingUserMutationError = ProblemDetails

    /**
 * @summary Delete a job seeker that has not finished the onboarding yet.
 */
export const useDeleteAdminOnboardingUser = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOnboardingUser>>, TError,{onboardingUserId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAdminOnboardingUser>>,
        TError,
        {onboardingUserId: number},
        TContext
      > => {
      return useMutation(getDeleteAdminOnboardingUserMutationOptions(options), queryClient);
    }

export const getGetAdminCandidateStatisticsUrl = (userId: number,) => {




  return `/admin/matching/candidates/${userId}/statistics`
}

export const getAdminCandidateStatistics = async (userId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminCandidateStatisticsResult> => {

  return fetchWithAuth<GetAdminCandidateStatisticsResult>(getGetAdminCandidateStatisticsUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminCandidateStatisticsQueryKey = (userId: MaybeRefOrGetter<number>,) => {
    return [
    'admin','matching','candidates',userId,'statistics'
    ] as const;
    }


export const getGetAdminCandidateStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCandidateStatistics>>, TError = ProblemDetails>(userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCandidateStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminCandidateStatisticsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCandidateStatistics>>> = ({ signal }) => getAdminCandidateStatistics(toValue(userId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCandidateStatistics>>, TError, TData>
}

export type GetAdminCandidateStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCandidateStatistics>>>
export type GetAdminCandidateStatisticsQueryError = ProblemDetails



export function useGetAdminCandidateStatistics<TData = Awaited<ReturnType<typeof getAdminCandidateStatistics>>, TError = ProblemDetails>(
 userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCandidateStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCandidateStatisticsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminCandidateMatchScoresUrl = (userId: number,) => {




  return `/admin/matching/candidates/${userId}/match-scores`
}

export const listAdminCandidateMatchScores = async (userId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminCandidateMatchScoresResult> => {

  return fetchWithAuth<ListAdminCandidateMatchScoresResult>(getListAdminCandidateMatchScoresUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminCandidateMatchScoresQueryKey = (userId: MaybeRefOrGetter<number>,) => {
    return [
    'admin','matching','candidates',userId,'match-scores'
    ] as const;
    }


export const getListAdminCandidateMatchScoresQueryOptions = <TData = Awaited<ReturnType<typeof listAdminCandidateMatchScores>>, TError = ProblemDetails>(userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCandidateMatchScores>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminCandidateMatchScoresQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminCandidateMatchScores>>> = ({ signal }) => listAdminCandidateMatchScores(toValue(userId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminCandidateMatchScores>>, TError, TData>
}

export type ListAdminCandidateMatchScoresQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminCandidateMatchScores>>>
export type ListAdminCandidateMatchScoresQueryError = ProblemDetails



export function useListAdminCandidateMatchScores<TData = Awaited<ReturnType<typeof listAdminCandidateMatchScores>>, TError = ProblemDetails>(
 userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCandidateMatchScores>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminCandidateMatchScoresQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAdminCandidateJobApplicationsUrl = (userId: number,
    params?: ListAdminCandidateJobApplicationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["statuses","matchStatuses"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/matching/candidates/${userId}/job-applications?${stringifiedParams}` : `/admin/matching/candidates/${userId}/job-applications`
}

export const listAdminCandidateJobApplications = async (userId: number,
    params?: ListAdminCandidateJobApplicationsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAdminCandidateJobApplicationsResult> => {

  return fetchWithAuth<ListAdminCandidateJobApplicationsResult>(getListAdminCandidateJobApplicationsUrl(userId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminCandidateJobApplicationsQueryKey = (userId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAdminCandidateJobApplicationsParams>,) => {
    return [
    'admin','matching','candidates',userId,'job-applications', ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminCandidateJobApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminCandidateJobApplications>>, TError = ProblemDetails>(userId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAdminCandidateJobApplicationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCandidateJobApplications>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAdminCandidateJobApplicationsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminCandidateJobApplications>>> = ({ signal }) => listAdminCandidateJobApplications(toValue(userId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminCandidateJobApplications>>, TError, TData>
}

export type ListAdminCandidateJobApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminCandidateJobApplications>>>
export type ListAdminCandidateJobApplicationsQueryError = ProblemDetails



export function useListAdminCandidateJobApplications<TData = Awaited<ReturnType<typeof listAdminCandidateJobApplications>>, TError = ProblemDetails>(
 userId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListAdminCandidateJobApplicationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminCandidateJobApplications>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminCandidateJobApplicationsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminCandidateMatchScoreStatisticsUrl = (userId: number,
    params?: GetAdminCandidateMatchScoreStatisticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["jobSegmentIds","companySegmentIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/matching/candidates/${userId}/match-score-statistics?${stringifiedParams}` : `/admin/matching/candidates/${userId}/match-score-statistics`
}

export const getAdminCandidateMatchScoreStatistics = async (userId: number,
    params?: GetAdminCandidateMatchScoreStatisticsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminCandidateMatchScoreStatisticsResult> => {

  return fetchWithAuth<GetAdminCandidateMatchScoreStatisticsResult>(getGetAdminCandidateMatchScoreStatisticsUrl(userId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminCandidateMatchScoreStatisticsQueryKey = (userId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminCandidateMatchScoreStatisticsParams>,) => {
    return [
    'admin','matching','candidates',userId,'match-score-statistics', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminCandidateMatchScoreStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCandidateMatchScoreStatistics>>, TError = ProblemDetails>(userId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminCandidateMatchScoreStatisticsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCandidateMatchScoreStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminCandidateMatchScoreStatisticsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCandidateMatchScoreStatistics>>> = ({ signal }) => getAdminCandidateMatchScoreStatistics(toValue(userId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCandidateMatchScoreStatistics>>, TError, TData>
}

export type GetAdminCandidateMatchScoreStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCandidateMatchScoreStatistics>>>
export type GetAdminCandidateMatchScoreStatisticsQueryError = ProblemDetails



export function useGetAdminCandidateMatchScoreStatistics<TData = Awaited<ReturnType<typeof getAdminCandidateMatchScoreStatistics>>, TError = ProblemDetails>(
 userId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminCandidateMatchScoreStatisticsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCandidateMatchScoreStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCandidateMatchScoreStatisticsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAdminCandidateStackComparisonUrl = (userId: number,
    params?: GetAdminCandidateStackComparisonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["jobSegmentIds","companySegmentIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/matching/candidates/${userId}/stack-comparison?${stringifiedParams}` : `/admin/matching/candidates/${userId}/stack-comparison`
}

export const getAdminCandidateStackComparison = async (userId: number,
    params?: GetAdminCandidateStackComparisonParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAdminCandidateStackComparisonResult> => {

  return fetchWithAuth<GetAdminCandidateStackComparisonResult>(getGetAdminCandidateStackComparisonUrl(userId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminCandidateStackComparisonQueryKey = (userId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminCandidateStackComparisonParams>,) => {
    return [
    'admin','matching','candidates',userId,'stack-comparison', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminCandidateStackComparisonQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCandidateStackComparison>>, TError = ProblemDetails>(userId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminCandidateStackComparisonParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCandidateStackComparison>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAdminCandidateStackComparisonQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCandidateStackComparison>>> = ({ signal }) => getAdminCandidateStackComparison(toValue(userId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCandidateStackComparison>>, TError, TData>
}

export type GetAdminCandidateStackComparisonQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCandidateStackComparison>>>
export type GetAdminCandidateStackComparisonQueryError = ProblemDetails



export function useGetAdminCandidateStackComparison<TData = Awaited<ReturnType<typeof getAdminCandidateStackComparison>>, TError = ProblemDetails>(
 userId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetAdminCandidateStackComparisonParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCandidateStackComparison>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCandidateStackComparisonQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getDownloadAdminCandidatePdfUrl = (userId: number,) => {




  return `/admin/matching/candidates/${userId}/resume`
}

/**
 * @summary Download a candidate's profile as a PDF file.
 */
export const downloadAdminCandidatePdf = async (userId: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<Blob> => {

  return fetchWithAuth<Blob>(getDownloadAdminCandidatePdfUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadAdminCandidatePdfQueryKey = (userId: MaybeRefOrGetter<number>,) => {
    return [
    'admin','matching','candidates',userId,'resume'
    ] as const;
    }


export const getDownloadAdminCandidatePdfQueryOptions = <TData = Awaited<ReturnType<typeof downloadAdminCandidatePdf>>, TError = Blob>(userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAdminCandidatePdf>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getDownloadAdminCandidatePdfQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadAdminCandidatePdf>>> = ({ signal }) => downloadAdminCandidatePdf(toValue(userId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadAdminCandidatePdf>>, TError, TData>
}

export type DownloadAdminCandidatePdfQueryResult = NonNullable<Awaited<ReturnType<typeof downloadAdminCandidatePdf>>>
export type DownloadAdminCandidatePdfQueryError = Blob


/**
 * @summary Download a candidate's profile as a PDF file.
 */

export function useDownloadAdminCandidatePdf<TData = Awaited<ReturnType<typeof downloadAdminCandidatePdf>>, TError = Blob>(
 userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAdminCandidatePdf>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadAdminCandidatePdfQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListEducationLevelsUrl = () => {




  return `/education-level`
}

/**
 * @summary List all education levels
 */
export const listEducationLevels = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListEducationLevelsResult> => {

  return fetchWithAuth<ListEducationLevelsResult>(getListEducationLevelsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEducationLevelsQueryKey = () => {
    return [
    'education-level'
    ] as const;
    }


export const getListEducationLevelsQueryOptions = <TData = Awaited<ReturnType<typeof listEducationLevels>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEducationLevels>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListEducationLevelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEducationLevels>>> = ({ signal }) => listEducationLevels({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEducationLevels>>, TError, TData>
}

export type ListEducationLevelsQueryResult = NonNullable<Awaited<ReturnType<typeof listEducationLevels>>>
export type ListEducationLevelsQueryError = unknown


/**
 * @summary List all education levels
 */

export function useListEducationLevels<TData = Awaited<ReturnType<typeof listEducationLevels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEducationLevels>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEducationLevelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListPersonalCharacteristicsUrl = () => {




  return `/personal-characteristics`
}

/**
 * @summary List all personal characteristics
 */
export const listPersonalCharacteristics = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListPersonalCharacteristicsResult> => {

  return fetchWithAuth<ListPersonalCharacteristicsResult>(getListPersonalCharacteristicsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPersonalCharacteristicsQueryKey = () => {
    return [
    'personal-characteristics'
    ] as const;
    }


export const getListPersonalCharacteristicsQueryOptions = <TData = Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListPersonalCharacteristicsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersonalCharacteristics>>> = ({ signal }) => listPersonalCharacteristics({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError, TData>
}

export type ListPersonalCharacteristicsQueryResult = NonNullable<Awaited<ReturnType<typeof listPersonalCharacteristics>>>
export type ListPersonalCharacteristicsQueryError = unknown


/**
 * @summary List all personal characteristics
 */

export function useListPersonalCharacteristics<TData = Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPersonalCharacteristicsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListNewJobReasonsUrl = () => {




  return `/new-job-reasons`
}

/**
 * @summary List all new job reasons
 */
export const listNewJobReasons = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListNewJobReasonsResult> => {

  return fetchWithAuth<ListNewJobReasonsResult>(getListNewJobReasonsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNewJobReasonsQueryKey = () => {
    return [
    'new-job-reasons'
    ] as const;
    }


export const getListNewJobReasonsQueryOptions = <TData = Awaited<ReturnType<typeof listNewJobReasons>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewJobReasons>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListNewJobReasonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNewJobReasons>>> = ({ signal }) => listNewJobReasons({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNewJobReasons>>, TError, TData>
}

export type ListNewJobReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof listNewJobReasons>>>
export type ListNewJobReasonsQueryError = unknown


/**
 * @summary List all new job reasons
 */

export function useListNewJobReasons<TData = Awaited<ReturnType<typeof listNewJobReasons>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewJobReasons>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNewJobReasonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListPersonalityTypesUrl = () => {




  return `/personality-types`
}

export const listPersonalityTypes = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListPersonalityTypesResult> => {

  return fetchWithAuth<ListPersonalityTypesResult>(getListPersonalityTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPersonalityTypesQueryKey = () => {
    return [
    'personality-types'
    ] as const;
    }


export const getListPersonalityTypesQueryOptions = <TData = Awaited<ReturnType<typeof listPersonalityTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalityTypes>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListPersonalityTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersonalityTypes>>> = ({ signal }) => listPersonalityTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPersonalityTypes>>, TError, TData>
}

export type ListPersonalityTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listPersonalityTypes>>>
export type ListPersonalityTypesQueryError = unknown



export function useListPersonalityTypes<TData = Awaited<ReturnType<typeof listPersonalityTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalityTypes>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPersonalityTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetAutoCompleteLocationsUrl = (params: GetAutoCompleteLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/location/auto-complete?${stringifiedParams}` : `/location/auto-complete`
}

/**
 * @summary Get Auto complete locations from the Google Places API.
 */
export const getAutoCompleteLocations = async (params: GetAutoCompleteLocationsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetAutoCompleteLocationsResult> => {

  return fetchWithAuth<GetAutoCompleteLocationsResult>(getGetAutoCompleteLocationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAutoCompleteLocationsQueryKey = (params?: MaybeRefOrGetter<GetAutoCompleteLocationsParams>,) => {
    return [
    'location','auto-complete', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAutoCompleteLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError = ProblemDetails>(params: MaybeRefOrGetter<GetAutoCompleteLocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAutoCompleteLocationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAutoCompleteLocations>>> = ({ signal }) => getAutoCompleteLocations(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError, TData>
}

export type GetAutoCompleteLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAutoCompleteLocations>>>
export type GetAutoCompleteLocationsQueryError = ProblemDetails


/**
 * @summary Get Auto complete locations from the Google Places API.
 */

export function useGetAutoCompleteLocations<TData = Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError = ProblemDetails>(
 params: MaybeRefOrGetter<GetAutoCompleteLocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAutoCompleteLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetLocationDetailsUrl = (params: GetLocationDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/location/details/v2?${stringifiedParams}` : `/location/details/v2`
}

/**
 * @summary Get location details (including Lat, Long) from the Google Places API based on the place Id.
 */
export const getLocationDetails = async (params: GetLocationDetailsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetLocationDetailsResult> => {

  return fetchWithAuth<GetLocationDetailsResult>(getGetLocationDetailsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLocationDetailsQueryKey = (params?: MaybeRefOrGetter<GetLocationDetailsParams>,) => {
    return [
    'location','details','v2', ...(params ? [params] : [])
    ] as const;
    }


export const getGetLocationDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getLocationDetails>>, TError = ProblemDetails>(params: MaybeRefOrGetter<GetLocationDetailsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationDetails>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetLocationDetailsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationDetails>>> = ({ signal }) => getLocationDetails(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationDetails>>, TError, TData>
}

export type GetLocationDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationDetails>>>
export type GetLocationDetailsQueryError = ProblemDetails


/**
 * @summary Get location details (including Lat, Long) from the Google Places API based on the place Id.
 */

export function useGetLocationDetails<TData = Awaited<ReturnType<typeof getLocationDetails>>, TError = ProblemDetails>(
 params: MaybeRefOrGetter<GetLocationDetailsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationDetails>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetLocationGeocodeUrl = (params?: GetLocationGeocodeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/location/location-geocode?${stringifiedParams}` : `/location/location-geocode`
}

/**
 * @summary Get a location geocode (including Lat, Long) from the Google Places API based on the lat long.
 */
export const getLocationGeocode = async (params?: GetLocationGeocodeParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetLocationGeocodeResult> => {

  return fetchWithAuth<GetLocationGeocodeResult>(getGetLocationGeocodeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLocationGeocodeQueryKey = (params?: MaybeRefOrGetter<GetLocationGeocodeParams>,) => {
    return [
    'location','location-geocode', ...(params ? [params] : [])
    ] as const;
    }


export const getGetLocationGeocodeQueryOptions = <TData = Awaited<ReturnType<typeof getLocationGeocode>>, TError = ProblemDetails>(params?: MaybeRefOrGetter<GetLocationGeocodeParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationGeocode>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetLocationGeocodeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationGeocode>>> = ({ signal }) => getLocationGeocode(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationGeocode>>, TError, TData>
}

export type GetLocationGeocodeQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationGeocode>>>
export type GetLocationGeocodeQueryError = ProblemDetails


/**
 * @summary Get a location geocode (including Lat, Long) from the Google Places API based on the lat long.
 */

export function useGetLocationGeocode<TData = Awaited<ReturnType<typeof getLocationGeocode>>, TError = ProblemDetails>(
 params?: MaybeRefOrGetter<GetLocationGeocodeParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationGeocode>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationGeocodeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListSkillsCertificatesAndLanguagesUrl = () => {




  return `/skill/v2`
}

export const listSkillsCertificatesAndLanguages = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSkillsCertificatesAndLanguagesResult> => {

  return fetchWithAuth<ListSkillsCertificatesAndLanguagesResult>(getListSkillsCertificatesAndLanguagesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSkillsCertificatesAndLanguagesQueryKey = () => {
    return [
    'skill','v2'
    ] as const;
    }


export const getListSkillsCertificatesAndLanguagesQueryOptions = <TData = Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListSkillsCertificatesAndLanguagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>> = ({ signal }) => listSkillsCertificatesAndLanguages({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>, TError, TData>
}

export type ListSkillsCertificatesAndLanguagesQueryResult = NonNullable<Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>>
export type ListSkillsCertificatesAndLanguagesQueryError = unknown



export function useListSkillsCertificatesAndLanguages<TData = Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsCertificatesAndLanguages>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSkillsCertificatesAndLanguagesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListAllSkillsUrl = () => {




  return `/skill/v2/list-all-skills`
}

export const listAllSkills = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListAllSkillsResult> => {

  return fetchWithAuth<ListAllSkillsResult>(getListAllSkillsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllSkillsQueryKey = () => {
    return [
    'skill','v2','list-all-skills'
    ] as const;
    }


export const getListAllSkillsQueryOptions = <TData = Awaited<ReturnType<typeof listAllSkills>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllSkills>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAllSkillsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllSkills>>> = ({ signal }) => listAllSkills({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllSkills>>, TError, TData>
}

export type ListAllSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof listAllSkills>>>
export type ListAllSkillsQueryError = unknown



export function useListAllSkills<TData = Awaited<ReturnType<typeof listAllSkills>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllSkills>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllSkillsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListSkillsForJobCategoriesUrl = (params?: ListSkillsForJobCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["jobCategoryIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/skill/v2/list-for-job-categories?${stringifiedParams}` : `/skill/v2/list-for-job-categories`
}

export const listSkillsForJobCategories = async (params?: ListSkillsForJobCategoriesParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSkillsForJobCategoriesResult> => {

  return fetchWithAuth<ListSkillsForJobCategoriesResult>(getListSkillsForJobCategoriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSkillsForJobCategoriesQueryKey = (params?: MaybeRefOrGetter<ListSkillsForJobCategoriesParams>,) => {
    return [
    'skill','v2','list-for-job-categories', ...(params ? [params] : [])
    ] as const;
    }


export const getListSkillsForJobCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError = unknown>(params?: MaybeRefOrGetter<ListSkillsForJobCategoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListSkillsForJobCategoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSkillsForJobCategories>>> = ({ signal }) => listSkillsForJobCategories(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError, TData>
}

export type ListSkillsForJobCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listSkillsForJobCategories>>>
export type ListSkillsForJobCategoriesQueryError = unknown



export function useListSkillsForJobCategories<TData = Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListSkillsForJobCategoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSkillsForJobCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListCertificatesUrl = () => {




  return `/skill/v2/list-certificates`
}

export const listCertificates = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListCertificatesResult> => {

  return fetchWithAuth<ListCertificatesResult>(getListCertificatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCertificatesQueryKey = () => {
    return [
    'skill','v2','list-certificates'
    ] as const;
    }


export const getListCertificatesQueryOptions = <TData = Awaited<ReturnType<typeof listCertificates>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCertificates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListCertificatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCertificates>>> = ({ signal }) => listCertificates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCertificates>>, TError, TData>
}

export type ListCertificatesQueryResult = NonNullable<Awaited<ReturnType<typeof listCertificates>>>
export type ListCertificatesQueryError = unknown



export function useListCertificates<TData = Awaited<ReturnType<typeof listCertificates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCertificates>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCertificatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListJobFunctionsUrl = (params?: ListJobFunctionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/job-function?${stringifiedParams}` : `/job-function`
}

export const listJobFunctions = async (params?: ListJobFunctionsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<JobFunctionCrudListResult> => {

  return fetchWithAuth<JobFunctionCrudListResult>(getListJobFunctionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobFunctionsQueryKey = (params?: MaybeRefOrGetter<ListJobFunctionsParams>,) => {
    return [
    'job-function', ...(params ? [params] : [])
    ] as const;
    }


export const getListJobFunctionsQueryOptions = <TData = Awaited<ReturnType<typeof listJobFunctions>>, TError = unknown>(params?: MaybeRefOrGetter<ListJobFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobFunctions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListJobFunctionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobFunctions>>> = ({ signal }) => listJobFunctions(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobFunctions>>, TError, TData>
}

export type ListJobFunctionsQueryResult = NonNullable<Awaited<ReturnType<typeof listJobFunctions>>>
export type ListJobFunctionsQueryError = unknown



export function useListJobFunctions<TData = Awaited<ReturnType<typeof listJobFunctions>>, TError = unknown>(
 params?: MaybeRefOrGetter<ListJobFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobFunctions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobFunctionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListSimilarJobFunctionsUrl = (params?: ListSimilarJobFunctionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/job-function/similar?${stringifiedParams}` : `/job-function/similar`
}

/**
 * @summary Shared by onboarding and profile job-function editing: given the user's selected Job Functions
(DB-backed or free text), returns one group of occupation-relevant Job Functions per selection.
POST (not GET) because free-text selections don't bind cleanly from a query string.
 */
export const listSimilarJobFunctions = async (itemInput?: ItemInput[],
    params?: ListSimilarJobFunctionsParams, options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListSimilarJobFunctionsResult> => {

  return fetchWithAuth<ListSimilarJobFunctionsResult>(getListSimilarJobFunctionsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(itemInput)
  }
);}





export const getListSimilarJobFunctionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listSimilarJobFunctions>>, TError,{data?: ItemInput[];params?: ListSimilarJobFunctionsParams}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof listSimilarJobFunctions>>, TError,{data?: ItemInput[];params?: ListSimilarJobFunctionsParams}, TContext> => {

const mutationKey = ['listSimilarJobFunctions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof listSimilarJobFunctions>>, {data?: ItemInput[];params?: ListSimilarJobFunctionsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  listSimilarJobFunctions(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ListSimilarJobFunctionsMutationResult = NonNullable<Awaited<ReturnType<typeof listSimilarJobFunctions>>>
    export type ListSimilarJobFunctionsMutationBody = ItemInput[] | undefined
    export type ListSimilarJobFunctionsMutationError = unknown

    /**
 * @summary Shared by onboarding and profile job-function editing: given the user's selected Job Functions
(DB-backed or free text), returns one group of occupation-relevant Job Functions per selection.
POST (not GET) because free-text selections don't bind cleanly from a query string.
 */
export const useListSimilarJobFunctions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listSimilarJobFunctions>>, TError,{data?: ItemInput[];params?: ListSimilarJobFunctionsParams}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof listSimilarJobFunctions>>,
        TError,
        {data?: ItemInput[];params?: ListSimilarJobFunctionsParams},
        TContext
      > => {
      return useMutation(getListSimilarJobFunctionsMutationOptions(options), queryClient);
    }

export const getListJobCategoriesUrl = () => {




  return `/job-category/v2`
}

/**
 * @summary List all job categories, along with their job functions and skills
 */
export const listJobCategories = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<JobCategoryCrudListResult> => {

  return fetchWithAuth<JobCategoryCrudListResult>(getListJobCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobCategoriesQueryKey = () => {
    return [
    'job-category','v2'
    ] as const;
    }


export const getListJobCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listJobCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListJobCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobCategories>>> = ({ signal }) => listJobCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobCategories>>, TError, TData>
}

export type ListJobCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listJobCategories>>>
export type ListJobCategoriesQueryError = unknown


/**
 * @summary List all job categories, along with their job functions and skills
 */

export function useListJobCategories<TData = Awaited<ReturnType<typeof listJobCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetJobCategoryUrl = (id: number,) => {




  return `/job-category/v2/${id}`
}

/**
 * @summary List a job category, along with their job functions and skills
 */
export const getJobCategory = async (id: number, options?: Parameters<typeof fetchWithAuth>[1]): Promise<JobCategoryCrudJobCategoryDto> => {

  return fetchWithAuth<JobCategoryCrudJobCategoryDto>(getGetJobCategoryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobCategoryQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'job-category','v2',id
    ] as const;
    }


export const getGetJobCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getJobCategory>>, TError = ProblemDetails>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobCategory>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetJobCategoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobCategory>>> = ({ signal }) => getJobCategory(toValue(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobCategory>>, TError, TData>
}

export type GetJobCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getJobCategory>>>
export type GetJobCategoryQueryError = ProblemDetails


/**
 * @summary List a job category, along with their job functions and skills
 */

export function useGetJobCategory<TData = Awaited<ReturnType<typeof getJobCategory>>, TError = ProblemDetails>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobCategory>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobCategoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getListInterestsUrl = () => {




  return `/interest`
}

/**
 * @summary List all interests
 */
export const listInterests = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<ListInterestsResult> => {

  return fetchWithAuth<ListInterestsResult>(getListInterestsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInterestsQueryKey = () => {
    return [
    'interest'
    ] as const;
    }


export const getListInterestsQueryOptions = <TData = Awaited<ReturnType<typeof listInterests>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterests>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListInterestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInterests>>> = ({ signal }) => listInterests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInterests>>, TError, TData>
}

export type ListInterestsQueryResult = NonNullable<Awaited<ReturnType<typeof listInterests>>>
export type ListInterestsQueryError = unknown


/**
 * @summary List all interests
 */

export function useListInterests<TData = Awaited<ReturnType<typeof listInterests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterests>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInterestsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export const getGetRoleUrl = () => {




  return `/user/account/role`
}

/**
 * @summary Get the role of the current user.
 */
export const getRole = async ( options?: Parameters<typeof fetchWithAuth>[1]): Promise<GetRoleResult> => {

  return fetchWithAuth<GetRoleResult>(getGetRoleUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRoleQueryKey = () => {
    return [
    'user','account','role'
    ] as const;
    }


export const getGetRoleQueryOptions = <TData = Awaited<ReturnType<typeof getRole>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetRoleQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRole>>> = ({ signal }) => getRole({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>
}

export type GetRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getRole>>>
export type GetRoleQueryError = unknown


/**
 * @summary Get the role of the current user.
 */

export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoleQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
